// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/logos/LogoTCA.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.rbc-btn {
  color: inherit;
  font: inherit;
  margin: 0;
}

button.rbc-btn {
  overflow: visible;
  text-transform: none;
  appearance: button;
  cursor: pointer;
}

button[disabled].rbc-btn {
  cursor: not-allowed;
}

button.rbc-input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

.rbc-calendar {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.rbc-m-b-negative-3 {
  margin-bottom: -3px;
}

.rbc-h-full {
  height: 100%;
}

.rbc-calendar *,
.rbc-calendar *:before,
.rbc-calendar *:after {
  box-sizing: inherit;
}

.rbc-abs-full, .rbc-row-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.rbc-ellipsis, .rbc-show-more, .rbc-row-segment .rbc-event-content, .rbc-event-label {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rbc-rtl {
  direction: rtl;
}

.rbc-off-range {
  color: #999999;
}

.rbc-off-range-bg {
  background: rgb(229.5, 229.5, 229.5);
}

.rbc-header {
  overflow: hidden;
  flex: 1 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 3px;
  text-align: center;
  vertical-align: middle;
  font-weight: bold;
  font-size: 90%;
  min-height: 0;
  border-bottom: 1px solid #ddd;
}
.rbc-header + .rbc-header {
  border-left: 1px solid #ddd;
}
.rbc-rtl .rbc-header + .rbc-header {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}
.rbc-header > a, .rbc-header > a:active, .rbc-header > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-button-link {
  color: inherit;
  background: none;
  margin: 0;
  padding: 0;
  border: none;
  cursor: pointer;
  -webkit-user-select: text;
          user-select: text;
}

.rbc-row-content {
  position: relative;
  user-select: none;
  -webkit-user-select: none;
  z-index: 4;
}

.rbc-row-content-scrollable {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.rbc-row-content-scrollable .rbc-row-content-scroll-container {
  height: 100%;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  /* Hide scrollbar for Chrome, Safari and Opera */
}
.rbc-row-content-scrollable .rbc-row-content-scroll-container::-webkit-scrollbar {
  display: none;
}

.rbc-today {
  background-color: #eaf6ff;
}

.rbc-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  font-size: 16px;
}
.rbc-toolbar .rbc-toolbar-label {
  flex-grow: 1;
  padding: 0 10px;
  text-align: center;
}
.rbc-toolbar button {
  color: #373a3c;
  display: inline-block;
  margin: 0;
  text-align: center;
  vertical-align: middle;
  background: none;
  background-image: none;
  border: 1px solid #ccc;
  padding: 0.375rem 1rem;
  border-radius: 4px;
  line-height: normal;
  white-space: nowrap;
}
.rbc-toolbar button:active, .rbc-toolbar button.rbc-active {
  background-image: none;
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  background-color: rgb(229.5, 229.5, 229.5);
  border-color: rgb(173.4, 173.4, 173.4);
}
.rbc-toolbar button:active:hover, .rbc-toolbar button:active:focus, .rbc-toolbar button.rbc-active:hover, .rbc-toolbar button.rbc-active:focus {
  color: #373a3c;
  background-color: rgb(211.65, 211.65, 211.65);
  border-color: rgb(140.25, 140.25, 140.25);
}
.rbc-toolbar button:focus {
  color: #373a3c;
  background-color: rgb(229.5, 229.5, 229.5);
  border-color: rgb(173.4, 173.4, 173.4);
}
.rbc-toolbar button:hover {
  color: #373a3c;
  cursor: pointer;
  background-color: rgb(229.5, 229.5, 229.5);
  border-color: rgb(173.4, 173.4, 173.4);
}

.rbc-btn-group {
  display: inline-block;
  white-space: nowrap;
}
.rbc-btn-group > button:first-child:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-btn-group > button:last-child:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {
  border-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {
  border-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-btn-group > button:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.rbc-btn-group button + button {
  margin-left: -1px;
}
.rbc-rtl .rbc-btn-group button + button {
  margin-left: 0;
  margin-right: -1px;
}
.rbc-btn-group + .rbc-btn-group, .rbc-btn-group + button {
  margin-left: 10px;
}

@media (max-width: 767px) {
  .rbc-toolbar {
    flex-direction: column;
  }
}
.rbc-event, .rbc-day-slot .rbc-background-event {
  border: none;
  box-sizing: border-box;
  box-shadow: none;
  margin: 0;
  padding: 2px 5px;
  background-color: #3174ad;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  width: 100%;
  text-align: left;
}
.rbc-slot-selecting .rbc-event, .rbc-slot-selecting .rbc-day-slot .rbc-background-event, .rbc-day-slot .rbc-slot-selecting .rbc-background-event {
  cursor: inherit;
  pointer-events: none;
}
.rbc-event.rbc-selected, .rbc-day-slot .rbc-selected.rbc-background-event {
  background-color: rgb(37.7432432432, 89.3513513514, 133.2567567568);
}
.rbc-event:focus, .rbc-day-slot .rbc-background-event:focus {
  outline: 5px auto #3b99fc;
}

.rbc-event-label {
  font-size: 80%;
}

.rbc-event-overlaps {
  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);
}

.rbc-event-continues-prior {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rbc-event-continues-after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-earlier {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rbc-event-continues-later {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-row {
  display: flex;
  flex-direction: row;
}

.rbc-row-segment {
  padding: 0 1px 1px 1px;
}
.rbc-selected-cell {
  background-color: rgba(0, 0, 0, 0.1);
}

.rbc-show-more {
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 4;
  font-weight: bold;
  font-size: 85%;
  height: auto;
  line-height: normal;
  color: #3174ad;
}
.rbc-show-more:hover, .rbc-show-more:focus {
  color: rgb(37.7432432432, 89.3513513514, 133.2567567568);
}

.rbc-month-view {
  position: relative;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  flex: 1 0;
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
  height: 100%;
}

.rbc-month-header {
  display: flex;
  flex-direction: row;
}

.rbc-month-row {
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1 0;
  flex-basis: 0px;
  overflow: hidden;
  height: 100%;
}
.rbc-month-row + .rbc-month-row {
  border-top: 1px solid #ddd;
}

.rbc-date-cell {
  flex: 1 1;
  min-width: 0;
  padding-right: 5px;
  text-align: right;
}
.rbc-date-cell.rbc-now {
  font-weight: bold;
}
.rbc-date-cell > a, .rbc-date-cell > a:active, .rbc-date-cell > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-bg {
  display: flex;
  flex-direction: row;
  flex: 1 0;
  overflow: hidden;
  right: 1px;
}

.rbc-day-bg {
  flex: 1 0;
}
.rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid #ddd;
}
.rbc-rtl .rbc-day-bg + .rbc-day-bg {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}

.rbc-overlay {
  position: absolute;
  z-index: 5;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
  padding: 10px;
}
.rbc-overlay > * + * {
  margin-top: 1px;
}

.rbc-overlay-header {
  border-bottom: 1px solid #e5e5e5;
  margin: -10px -10px 5px -10px;
  padding: 2px 10px;
}

.rbc-agenda-view {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  overflow: auto;
}
.rbc-agenda-view table.rbc-agenda-table {
  width: 100%;
  border: 1px solid #ddd;
  border-spacing: 0;
  border-collapse: collapse;
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
  padding: 5px 10px;
  vertical-align: top;
}
.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {
  padding-left: 15px;
  padding-right: 15px;
  text-transform: lowercase;
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left: 1px solid #ddd;
}
.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {
  border-top: 1px solid #ddd;
}
.rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  padding: 3px 5px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  text-align: right;
}

.rbc-agenda-time-cell {
  text-transform: lowercase;
}
.rbc-agenda-time-cell .rbc-continues-after:after {
  content: " »";
}
.rbc-agenda-time-cell .rbc-continues-prior:before {
  content: "« ";
}

.rbc-agenda-date-cell,
.rbc-agenda-time-cell {
  white-space: nowrap;
}

.rbc-agenda-event-cell {
  width: 100%;
}

.rbc-time-column {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.rbc-time-column .rbc-timeslot-group {
  flex: 1 1;
}

.rbc-timeslot-group {
  border-bottom: 1px solid #ddd;
  min-height: 40px;
  display: flex;
  flex-flow: column nowrap;
}

.rbc-time-gutter,
.rbc-header-gutter {
  flex: none;
}

.rbc-label {
  padding: 0 5px;
}

.rbc-day-slot {
  position: relative;
}
.rbc-day-slot .rbc-events-container {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  margin-right: 10px;
  top: 0;
}
.rbc-day-slot .rbc-events-container.rbc-rtl {
  left: 10px;
  right: 0;
}
.rbc-day-slot .rbc-event, .rbc-day-slot .rbc-background-event {
  border: 1px solid rgb(37.7432432432, 89.3513513514, 133.2567567568);
  display: flex;
  max-height: 100%;
  min-height: 20px;
  flex-flow: column wrap;
  align-items: flex-start;
  overflow: hidden;
  position: absolute;
}
.rbc-day-slot .rbc-background-event {
  opacity: 0.75;
}
.rbc-day-slot .rbc-event-label {
  flex: none;
  padding-right: 5px;
  width: auto;
}
.rbc-day-slot .rbc-event-content {
  width: 100%;
  flex: 1 1;
  word-wrap: break-word;
  line-height: 1;
  height: 100%;
  min-height: 1em;
}
.rbc-day-slot .rbc-time-slot {
  border-top: 1px solid rgb(246.5, 246.5, 246.5);
}

.rbc-time-view-resources .rbc-time-gutter,
.rbc-time-view-resources .rbc-time-header-gutter {
  position: sticky;
  left: 0;
  background-color: white;
  border-right: 1px solid #ddd;
  z-index: 10;
  margin-right: -1px;
}
.rbc-time-view-resources .rbc-time-header {
  overflow: hidden;
}
.rbc-time-view-resources .rbc-time-header-content {
  min-width: auto;
  flex: 1 0;
  flex-basis: 0px;
}
.rbc-time-view-resources .rbc-time-header-cell-single-day {
  display: none;
}
.rbc-time-view-resources .rbc-day-slot {
  min-width: 140px;
}
.rbc-time-view-resources .rbc-header,
.rbc-time-view-resources .rbc-day-bg {
  width: 140px;
  flex: 1 1;
  flex-basis: 0 px;
}

.rbc-time-header-content + .rbc-time-header-content {
  margin-left: -1px;
}

.rbc-time-slot {
  flex: 1 0;
}
.rbc-time-slot.rbc-now {
  font-weight: bold;
}

.rbc-day-header {
  text-align: center;
}

.rbc-slot-selection {
  z-index: 10;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 75%;
  width: 100%;
  padding: 3px;
}

.rbc-slot-selecting {
  cursor: move;
}

.rbc-time-view {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  width: 100%;
  border: 1px solid #ddd;
  min-height: 0;
}
.rbc-time-view .rbc-time-gutter {
  white-space: nowrap;
  text-align: right;
}
.rbc-time-view .rbc-allday-cell {
  box-sizing: content-box;
  width: 100%;
  height: 100%;
  position: relative;
}
.rbc-time-view .rbc-allday-cell + .rbc-allday-cell {
  border-left: 1px solid #ddd;
}
.rbc-time-view .rbc-allday-events {
  position: relative;
  z-index: 4;
}
.rbc-time-view .rbc-row {
  box-sizing: border-box;
  min-height: 20px;
}

.rbc-time-header {
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
}
.rbc-time-header.rbc-overflowing {
  border-right: 1px solid #ddd;
}
.rbc-rtl .rbc-time-header.rbc-overflowing {
  border-right-width: 0;
  border-left: 1px solid #ddd;
}
.rbc-time-header > .rbc-row:first-child {
  border-bottom: 1px solid #ddd;
}
.rbc-time-header > .rbc-row.rbc-row-resource {
  border-bottom: 1px solid #ddd;
}

.rbc-time-header-cell-single-day {
  display: none;
}

.rbc-time-header-content {
  flex: 1 1;
  display: flex;
  min-width: 0;
  flex-direction: column;
  border-left: 1px solid #ddd;
}
.rbc-rtl .rbc-time-header-content {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}
.rbc-time-header-content > .rbc-row.rbc-row-resource {
  border-bottom: 1px solid #ddd;
  flex-shrink: 0;
}

.rbc-time-content {
  display: flex;
  flex: 1 0;
  align-items: flex-start;
  width: 100%;
  border-top: 2px solid #ddd;
  overflow-y: auto;
  position: relative;
}
.rbc-time-content > .rbc-time-gutter {
  flex: none;
}
.rbc-time-content > * + * > * {
  border-left: 1px solid #ddd;
}
.rbc-rtl .rbc-time-content > * + * > * {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}
.rbc-time-content > .rbc-day-slot {
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
}

.rbc-current-time-indicator {
  position: absolute;
  z-index: 3;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #74ad31;
  pointer-events: none;
}

.rbc-resource-grouping.rbc-time-header-content {
  display: flex;
  flex-direction: column;
}
.rbc-resource-grouping .rbc-row .rbc-header {
  width: 141px;
}

* {
  font-family: "Inter", sans-serif;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

#root {
  width: 100%;
}
#root ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
#root p {
  line-height: 1.8rem;
}
#root p,
#root h1,
#root h2,
#root h3 {
  margin: 0;
}
#root button {
  cursor: pointer;
}
#root a {
  cursor: pointer;
  text-decoration: none;
}

*::marker {
  color: var(--orange-800) !important;
  width: 25px;
  height: 25px;
  place-content: center;
  place-items: center;
  font-size: 1.3rem;
}

:root {
  --green: #00a65a;
  --green-dark: #398439;
  --green-hover: #008d4c;
  --blue: #3c8dbc;
  --blue-dark: #204d74;
  --blue-light: #ecf0f5;
  --blue-hover: #367fa9;
  --red: #dd4b39;
  --red-dark: #d73925;
  --red-hover: #d73925;
  --black: #333333;
  --black-hover: #999999;
  --grey: #d2d6de;
  --grey-dark: #444;
  --grey-badge: #b5bbc8;
  --orange: #f0ad4e;
  --orange-dark: #eea236;
  --orange-hover: #d58512;
  --yellow: #f39c12;
  --yellow-dark: #db8b0b;
  --yellow-hover: rgb(216, 140, 32);
  --ligthblue: #00c0ef;
  --ligthblue-dark: #00acd6;
  --ligthblue-hover: #269abc;
  --cyan: #00c0ef;
  --cyan-hover: #00acd6;
  --dark-blue: #337ab7;
  --dark-blue-hover: #367fa9;
  --teal: #39cccc;
  --purple: #605ca8;
  --white: #fff;
  --query-mobile: 480px;
  --query-tablet: 768px;
  --query-large: 992px;
  --query-notebook: 1024px;
  --font-chica: .75rem;
  --font-mobile: 0.675rem;
  --font-normal: .875rem;
  --font-boton: 1rem;
  --font-mediana: 1.1rem;
  --font-mediana2: 1.3rem;
  --font-grande: 1.5rem;
  --font-subtitulo: 2rem;
  --font-titulo: 2.5rem;
  --font-gigante: 3rem;
  --radius-5: 5px;
  --radius-10: 10px;
  --radius-15: 15px;
  --radius-20: 20px;
  --radius-25: 25px;
  --radius-30: 30px;
  --radius-35: 35px;
  --radius-40: 40px;
  --radius-45: 45px;
  --radius-50: 50px;
  --box-shadow-light: 0px 2px 10px 5px #e9e9e9 ;
}

.text-orange {
  color: var(--orange);
}

.text-red {
  color: var(--red);
}

.text-green {
  color: var(--green);
}

.text-blue {
  color: var(--blue);
}

.text-cyan {
  color: var(--cyan);
}

.text-ligthblue {
  color: var(--ligthblue);
}

.text-black {
  color: var(--black) !important;
}

.text-white {
  color: var(--white) !important;
}

.text-grey {
  color: var(--grey) !important;
}

.bg-orange {
  background-color: var(--orange) !important;
}

.bg-yellow {
  background-color: var(--yellow) !important;
}

.bg-red {
  background-color: var(--red) !important;
}

.bg-green {
  background-color: var(--green) !important;
}

.bg-blue {
  background-color: var(--blue) !important;
}

.bg-dark-blue {
  background-color: var(--dark-blue) !important;
}

.bg-cyan {
  background-color: var(--cyan) !important;
}

.bg-ligthblue {
  background-color: var(--ligthblue) !important;
}

.bg-ligthblue-dark {
  background-color: var(--ligthblue-dark) !important;
}

.bg-teal {
  background-color: var(--teal) !important;
}

.bg-purple {
  background-color: var(--purple) !important;
}

.bg-grey {
  background-color: var(--grey) !important;
}

.bg-grey-badge {
  background-color: var(--grey-badge) !important;
}

.bgOrangeGradient {
  background: linear-gradient(130deg, rgb(205, 154, 98) 0%, rgba(205, 154, 98, 0.9019607843) 70%, rgba(255, 255, 255, 0.84) 103%);
}

.bgOrangeGradient::after {
  content: "";
  position: absolute;
  bottom: 2rem;
  right: 2rem;
  width: 120px;
  height: 120px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center/contain;
}

.borderData {
  border-top: 1px dotted #d2d6de;
  border-radius: 5px;
  margin-bottom: 20px;
  text-align: center;
}

.btn-default {
  width: fit-content !important;
  background-color: #f4f4f4 !important;
  color: var(--black) !important;
  border-color: #ddd !important;
}

.btn-actions {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
.btn-actions .btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.optionBtns {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 5px;
}
.optionBtns .btn {
  width: 31px;
  height: 31px;
  font-size: var(--font-chica);
}

@media (max-width: 768px) {
  .sm-flex-column {
    flex-direction: column !important;
  }
}

@media (max-width: 480px) {
  .xs-flex-column {
    flex-direction: column !important;
  }
}

/* 🔹 Variantes */
.primary {
  background-color: var(--orange);
  color: var(--white);
}
.primary:hover {
  background-color: var(--orange-hover);
}

.secondary {
  background-color: var(--grey);
  color: var(--black);
}
.secondary:hover {
  background-color: var(--grey-dark);
  color: var(--white);
}

.new {
  background-color: var(--blue);
  color: var(--white);
}
.new:hover {
  background-color: var(--blue-hover);
}

.outline {
  background-color: var(--white);
  color: var(--orange);
  border: 1px solid var(--orange);
}
.outline:hover {
  background-color: var(--orange);
  color: var(--white);
}

.info {
  background-color: var(--dark-blue);
  color: var(--white);
}
.info:hover {
  background-color: var(--dark-blue-hover);
}

.error {
  background-color: var(--red);
  color: var(--white);
}
.error:hover {
  background-color: var(--red-hover);
}

.infoLight {
  background-color: rgba(183, 51, 51, 0.1);
  color: var(--red-dark);
  border: 1px solid rgba(51, 122, 183, 0.25);
}
.infoLight:hover {
  background-color: rgba(198, 59, 85, 0.2);
}

.successLight {
  background-color: rgba(0, 166, 90, 0.1);
  color: var(--green);
  border: 1px solid rgba(0, 166, 90, 0.25);
}
.successLight:hover {
  background-color: rgba(0, 166, 90, 0.2);
}

:root {
  /* 12px */
  /* 16px */
  /* 14px */
  /* 20px */
  /* 16px */
  /* 24px */
  /* 18px */
  /* 28px */
  /* 20px */
  /* 28px */
  /* 24px */
  /* 32px */
  /* 30px */
  /* 36px */
  /* 36px */
  /* 40px */
  /* 48px */
  /* 60px */
  /* 72px */
  /* 96px */
  /* 128px */
}
:root .text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
:root .text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
:root .text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
:root .text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
:root .text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
:root .text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
:root .text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
:root .text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
:root .text-5xl {
  font-size: 3rem;
  line-height: 1;
  /* Define el valor de línea según tus necesidades */
}
:root .text-6xl {
  font-size: 3.75rem;
  line-height: 1;
  /* Define el valor de línea según tus necesidades */
}
:root .text-7xl {
  font-size: 4.5rem;
  line-height: 1;
  /* Define el valor de línea según tus necesidades */
}
:root .text-8xl {
  font-size: 6rem;
  line-height: 1;
  /* Define el valor de línea según tus necesidades */
}
:root .text-9xl {
  font-size: 8rem;
  line-height: 1;
  /* Define el valor de línea según tus necesidades */
}

.h0 {
  height: 0 !important;
}

.p0 {
  padding: 0 !important;
}

.w0 {
  width: 0rem !important;
}

.height0 {
  height: 0rem !important;
}

.h0vh {
  height: 0vh !important;
}

.m0 {
  margin: 0rem !important;
}

.ml0 {
  margin-left: 0rem !important;
}

.mb0 {
  margin-bottom: 0rem !important;
}

.mr0 {
  margin-right: 0rem !important;
}

.mt0 {
  margin-top: 0rem !important;
}

.mx0 {
  margin-inline: 0rem !important;
}

.my0 {
  margin-block: 0rem !important;
}

.gap-0 {
  gap: 0rem !important;
}

.w1 {
  width: 1rem !important;
}

.height1 {
  height: 1rem !important;
}

.h1vh {
  height: 10vh !important;
}

.m1 {
  margin: 1rem !important;
}

.ml1 {
  margin-left: 1rem !important;
}

.mb1 {
  margin-bottom: 1rem !important;
}

.mr1 {
  margin-right: 1rem !important;
}

.mt1 {
  margin-top: 1rem !important;
}

.mx1 {
  margin-inline: 1rem !important;
}

.my1 {
  margin-block: 1rem !important;
}

.gap-1 {
  gap: 1rem !important;
}

.w2 {
  width: 2rem !important;
}

.height2 {
  height: 2rem !important;
}

.h2vh {
  height: 20vh !important;
}

.m2 {
  margin: 2rem !important;
}

.ml2 {
  margin-left: 2rem !important;
}

.mb2 {
  margin-bottom: 2rem !important;
}

.mr2 {
  margin-right: 2rem !important;
}

.mt2 {
  margin-top: 2rem !important;
}

.mx2 {
  margin-inline: 2rem !important;
}

.my2 {
  margin-block: 2rem !important;
}

.gap-2 {
  gap: 2rem !important;
}

.w3 {
  width: 3rem !important;
}

.height3 {
  height: 3rem !important;
}

.h3vh {
  height: 30vh !important;
}

.m3 {
  margin: 3rem !important;
}

.ml3 {
  margin-left: 3rem !important;
}

.mb3 {
  margin-bottom: 3rem !important;
}

.mr3 {
  margin-right: 3rem !important;
}

.mt3 {
  margin-top: 3rem !important;
}

.mx3 {
  margin-inline: 3rem !important;
}

.my3 {
  margin-block: 3rem !important;
}

.gap-3 {
  gap: 3rem !important;
}

.w4 {
  width: 4rem !important;
}

.height4 {
  height: 4rem !important;
}

.h4vh {
  height: 40vh !important;
}

.m4 {
  margin: 4rem !important;
}

.ml4 {
  margin-left: 4rem !important;
}

.mb4 {
  margin-bottom: 4rem !important;
}

.mr4 {
  margin-right: 4rem !important;
}

.mt4 {
  margin-top: 4rem !important;
}

.mx4 {
  margin-inline: 4rem !important;
}

.my4 {
  margin-block: 4rem !important;
}

.gap-4 {
  gap: 4rem !important;
}

.w5 {
  width: 5rem !important;
}

.height5 {
  height: 5rem !important;
}

.h5vh {
  height: 50vh !important;
}

.m5 {
  margin: 5rem !important;
}

.ml5 {
  margin-left: 5rem !important;
}

.mb5 {
  margin-bottom: 5rem !important;
}

.mr5 {
  margin-right: 5rem !important;
}

.mt5 {
  margin-top: 5rem !important;
}

.mx5 {
  margin-inline: 5rem !important;
}

.my5 {
  margin-block: 5rem !important;
}

.gap-5 {
  gap: 5rem !important;
}

.w6 {
  width: 6rem !important;
}

.height6 {
  height: 6rem !important;
}

.h6vh {
  height: 60vh !important;
}

.m6 {
  margin: 6rem !important;
}

.ml6 {
  margin-left: 6rem !important;
}

.mb6 {
  margin-bottom: 6rem !important;
}

.mr6 {
  margin-right: 6rem !important;
}

.mt6 {
  margin-top: 6rem !important;
}

.mx6 {
  margin-inline: 6rem !important;
}

.my6 {
  margin-block: 6rem !important;
}

.gap-6 {
  gap: 6rem !important;
}

.w7 {
  width: 7rem !important;
}

.height7 {
  height: 7rem !important;
}

.h7vh {
  height: 70vh !important;
}

.m7 {
  margin: 7rem !important;
}

.ml7 {
  margin-left: 7rem !important;
}

.mb7 {
  margin-bottom: 7rem !important;
}

.mr7 {
  margin-right: 7rem !important;
}

.mt7 {
  margin-top: 7rem !important;
}

.mx7 {
  margin-inline: 7rem !important;
}

.my7 {
  margin-block: 7rem !important;
}

.gap-7 {
  gap: 7rem !important;
}

.w8 {
  width: 8rem !important;
}

.height8 {
  height: 8rem !important;
}

.h8vh {
  height: 80vh !important;
}

.m8 {
  margin: 8rem !important;
}

.ml8 {
  margin-left: 8rem !important;
}

.mb8 {
  margin-bottom: 8rem !important;
}

.mr8 {
  margin-right: 8rem !important;
}

.mt8 {
  margin-top: 8rem !important;
}

.mx8 {
  margin-inline: 8rem !important;
}

.my8 {
  margin-block: 8rem !important;
}

.gap-8 {
  gap: 8rem !important;
}

.w9 {
  width: 9rem !important;
}

.height9 {
  height: 9rem !important;
}

.h9vh {
  height: 90vh !important;
}

.m9 {
  margin: 9rem !important;
}

.ml9 {
  margin-left: 9rem !important;
}

.mb9 {
  margin-bottom: 9rem !important;
}

.mr9 {
  margin-right: 9rem !important;
}

.mt9 {
  margin-top: 9rem !important;
}

.mx9 {
  margin-inline: 9rem !important;
}

.my9 {
  margin-block: 9rem !important;
}

.gap-9 {
  gap: 9rem !important;
}

.w10 {
  width: 10rem !important;
}

.height10 {
  height: 10rem !important;
}

.h10vh {
  height: 100vh !important;
}

.m10 {
  margin: 10rem !important;
}

.ml10 {
  margin-left: 10rem !important;
}

.mb10 {
  margin-bottom: 10rem !important;
}

.mr10 {
  margin-right: 10rem !important;
}

.mt10 {
  margin-top: 10rem !important;
}

.mx10 {
  margin-inline: 10rem !important;
}

.my10 {
  margin-block: 10rem !important;
}

.gap-10 {
  gap: 10rem !important;
}

.my-auto {
  margin-inline: auto !important;
}

.mw0 {
  max-width: 0rem !important;
}

.mh0 {
  max-height: 0rem !important;
}

.mw1 {
  max-width: 1rem !important;
}

.mh1 {
  max-height: 1rem !important;
}

.mw2 {
  max-width: 2rem !important;
}

.mh2 {
  max-height: 2rem !important;
}

.mw3 {
  max-width: 3rem !important;
}

.mh3 {
  max-height: 3rem !important;
}

.mw4 {
  max-width: 4rem !important;
}

.mh4 {
  max-height: 4rem !important;
}

.mw5 {
  max-width: 5rem !important;
}

.mh5 {
  max-height: 5rem !important;
}

.mw6 {
  max-width: 6rem !important;
}

.mh6 {
  max-height: 6rem !important;
}

.mw7 {
  max-width: 7rem !important;
}

.mh7 {
  max-height: 7rem !important;
}

.mw8 {
  max-width: 8rem !important;
}

.mh8 {
  max-height: 8rem !important;
}

.mw9 {
  max-width: 9rem !important;
}

.mh9 {
  max-height: 9rem !important;
}

.mw10 {
  max-width: 10rem !important;
}

.mh10 {
  max-height: 10rem !important;
}

.mw11 {
  max-width: 11rem !important;
}

.mh11 {
  max-height: 11rem !important;
}

.mw12 {
  max-width: 12rem !important;
}

.mh12 {
  max-height: 12rem !important;
}

.mw13 {
  max-width: 13rem !important;
}

.mh13 {
  max-height: 13rem !important;
}

.mw14 {
  max-width: 14rem !important;
}

.mh14 {
  max-height: 14rem !important;
}

.mw15 {
  max-width: 15rem !important;
}

.mh15 {
  max-height: 15rem !important;
}

.mw16 {
  max-width: 16rem !important;
}

.mh16 {
  max-height: 16rem !important;
}

.mw17 {
  max-width: 17rem !important;
}

.mh17 {
  max-height: 17rem !important;
}

.mw18 {
  max-width: 18rem !important;
}

.mh18 {
  max-height: 18rem !important;
}

.mw19 {
  max-width: 19rem !important;
}

.mh19 {
  max-height: 19rem !important;
}

.mw20 {
  max-width: 20rem !important;
}

.mh20 {
  max-height: 20rem !important;
}

.mw21 {
  max-width: 21rem !important;
}

.mh21 {
  max-height: 21rem !important;
}

.mw22 {
  max-width: 22rem !important;
}

.mh22 {
  max-height: 22rem !important;
}

.mw23 {
  max-width: 23rem !important;
}

.mh23 {
  max-height: 23rem !important;
}

.mw24 {
  max-width: 24rem !important;
}

.mh24 {
  max-height: 24rem !important;
}

.mw25 {
  max-width: 25rem !important;
}

.mh25 {
  max-height: 25rem !important;
}

.mw26 {
  max-width: 26rem !important;
}

.mh26 {
  max-height: 26rem !important;
}

.mw27 {
  max-width: 27rem !important;
}

.mh27 {
  max-height: 27rem !important;
}

.mw28 {
  max-width: 28rem !important;
}

.mh28 {
  max-height: 28rem !important;
}

.mw29 {
  max-width: 29rem !important;
}

.mh29 {
  max-height: 29rem !important;
}

.mw30 {
  max-width: 30rem !important;
}

.mh30 {
  max-height: 30rem !important;
}

.mw31 {
  max-width: 31rem !important;
}

.mh31 {
  max-height: 31rem !important;
}

.mw32 {
  max-width: 32rem !important;
}

.mh32 {
  max-height: 32rem !important;
}

.mw33 {
  max-width: 33rem !important;
}

.mh33 {
  max-height: 33rem !important;
}

.mw34 {
  max-width: 34rem !important;
}

.mh34 {
  max-height: 34rem !important;
}

.mw35 {
  max-width: 35rem !important;
}

.mh35 {
  max-height: 35rem !important;
}

.mw36 {
  max-width: 36rem !important;
}

.mh36 {
  max-height: 36rem !important;
}

.mw37 {
  max-width: 37rem !important;
}

.mh37 {
  max-height: 37rem !important;
}

.mw38 {
  max-width: 38rem !important;
}

.mh38 {
  max-height: 38rem !important;
}

.mw39 {
  max-width: 39rem !important;
}

.mh39 {
  max-height: 39rem !important;
}

.mw40 {
  max-width: 40rem !important;
}

.mh40 {
  max-height: 40rem !important;
}

.mw41 {
  max-width: 41rem !important;
}

.mh41 {
  max-height: 41rem !important;
}

.mw42 {
  max-width: 42rem !important;
}

.mh42 {
  max-height: 42rem !important;
}

.mw43 {
  max-width: 43rem !important;
}

.mh43 {
  max-height: 43rem !important;
}

.mw44 {
  max-width: 44rem !important;
}

.mh44 {
  max-height: 44rem !important;
}

.mw45 {
  max-width: 45rem !important;
}

.mh45 {
  max-height: 45rem !important;
}

.mw46 {
  max-width: 46rem !important;
}

.mh46 {
  max-height: 46rem !important;
}

.mw47 {
  max-width: 47rem !important;
}

.mh47 {
  max-height: 47rem !important;
}

.mw48 {
  max-width: 48rem !important;
}

.mh48 {
  max-height: 48rem !important;
}

.mw49 {
  max-width: 49rem !important;
}

.mh49 {
  max-height: 49rem !important;
}

.mw50 {
  max-width: 50rem !important;
}

.mh50 {
  max-height: 50rem !important;
}

.mw51 {
  max-width: 51rem !important;
}

.mh51 {
  max-height: 51rem !important;
}

.mw52 {
  max-width: 52rem !important;
}

.mh52 {
  max-height: 52rem !important;
}

.mw53 {
  max-width: 53rem !important;
}

.mh53 {
  max-height: 53rem !important;
}

.mw54 {
  max-width: 54rem !important;
}

.mh54 {
  max-height: 54rem !important;
}

.mw55 {
  max-width: 55rem !important;
}

.mh55 {
  max-height: 55rem !important;
}

.mw56 {
  max-width: 56rem !important;
}

.mh56 {
  max-height: 56rem !important;
}

.mw57 {
  max-width: 57rem !important;
}

.mh57 {
  max-height: 57rem !important;
}

.mw58 {
  max-width: 58rem !important;
}

.mh58 {
  max-height: 58rem !important;
}

.mw59 {
  max-width: 59rem !important;
}

.mh59 {
  max-height: 59rem !important;
}

.mw60 {
  max-width: 60rem !important;
}

.mh60 {
  max-height: 60rem !important;
}

.mw61 {
  max-width: 61rem !important;
}

.mh61 {
  max-height: 61rem !important;
}

.mw62 {
  max-width: 62rem !important;
}

.mh62 {
  max-height: 62rem !important;
}

.mw63 {
  max-width: 63rem !important;
}

.mh63 {
  max-height: 63rem !important;
}

.mw64 {
  max-width: 64rem !important;
}

.mh64 {
  max-height: 64rem !important;
}

.mw65 {
  max-width: 65rem !important;
}

.mh65 {
  max-height: 65rem !important;
}

.mw66 {
  max-width: 66rem !important;
}

.mh66 {
  max-height: 66rem !important;
}

.mw67 {
  max-width: 67rem !important;
}

.mh67 {
  max-height: 67rem !important;
}

.mw68 {
  max-width: 68rem !important;
}

.mh68 {
  max-height: 68rem !important;
}

.mw69 {
  max-width: 69rem !important;
}

.mh69 {
  max-height: 69rem !important;
}

.mw70 {
  max-width: 70rem !important;
}

.mh70 {
  max-height: 70rem !important;
}

.mw71 {
  max-width: 71rem !important;
}

.mh71 {
  max-height: 71rem !important;
}

.mw72 {
  max-width: 72rem !important;
}

.mh72 {
  max-height: 72rem !important;
}

.mw73 {
  max-width: 73rem !important;
}

.mh73 {
  max-height: 73rem !important;
}

.mw74 {
  max-width: 74rem !important;
}

.mh74 {
  max-height: 74rem !important;
}

.mw75 {
  max-width: 75rem !important;
}

.mh75 {
  max-height: 75rem !important;
}

.mw76 {
  max-width: 76rem !important;
}

.mh76 {
  max-height: 76rem !important;
}

.mw77 {
  max-width: 77rem !important;
}

.mh77 {
  max-height: 77rem !important;
}

.mw78 {
  max-width: 78rem !important;
}

.mh78 {
  max-height: 78rem !important;
}

.mw79 {
  max-width: 79rem !important;
}

.mh79 {
  max-height: 79rem !important;
}

.mw80 {
  max-width: 80rem !important;
}

.mh80 {
  max-height: 80rem !important;
}

.mw81 {
  max-width: 81rem !important;
}

.mh81 {
  max-height: 81rem !important;
}

.mw82 {
  max-width: 82rem !important;
}

.mh82 {
  max-height: 82rem !important;
}

.mw83 {
  max-width: 83rem !important;
}

.mh83 {
  max-height: 83rem !important;
}

.mw84 {
  max-width: 84rem !important;
}

.mh84 {
  max-height: 84rem !important;
}

.mw85 {
  max-width: 85rem !important;
}

.mh85 {
  max-height: 85rem !important;
}

.mw86 {
  max-width: 86rem !important;
}

.mh86 {
  max-height: 86rem !important;
}

.mw87 {
  max-width: 87rem !important;
}

.mh87 {
  max-height: 87rem !important;
}

.mw88 {
  max-width: 88rem !important;
}

.mh88 {
  max-height: 88rem !important;
}

.mw89 {
  max-width: 89rem !important;
}

.mh89 {
  max-height: 89rem !important;
}

.mw90 {
  max-width: 90rem !important;
}

.mh90 {
  max-height: 90rem !important;
}

.mw91 {
  max-width: 91rem !important;
}

.mh91 {
  max-height: 91rem !important;
}

.mw92 {
  max-width: 92rem !important;
}

.mh92 {
  max-height: 92rem !important;
}

.mw93 {
  max-width: 93rem !important;
}

.mh93 {
  max-height: 93rem !important;
}

.mw94 {
  max-width: 94rem !important;
}

.mh94 {
  max-height: 94rem !important;
}

.mw95 {
  max-width: 95rem !important;
}

.mh95 {
  max-height: 95rem !important;
}

.mw96 {
  max-width: 96rem !important;
}

.mh96 {
  max-height: 96rem !important;
}

.mw97 {
  max-width: 97rem !important;
}

.mh97 {
  max-height: 97rem !important;
}

.mw98 {
  max-width: 98rem !important;
}

.mh98 {
  max-height: 98rem !important;
}

.mw99 {
  max-width: 99rem !important;
}

.mh99 {
  max-height: 99rem !important;
}

.mw100 {
  max-width: 100rem !important;
}

.mh100 {
  max-height: 100rem !important;
}

/* ---------------- */
@media (max-width: 1090px) {
  .h0-maxtablet {
    height: 0vh !important;
  }
}

@media (max-width: 1090px) {
  .m0-maxtablet {
    margin: 0rem !important;
  }
}

@media (max-width: 1090px) {
  .ml0-maxtablet {
    margin-left: 0rem !important;
  }
}

@media (max-width: 1090px) {
  .mb0-maxtablet {
    margin-bottom: 0rem !important;
  }
}

@media (max-width: 1090px) {
  .mr0-maxtablet {
    margin-right: 0rem !important;
  }
}

@media (max-width: 1090px) {
  .mt0-maxtablet {
    margin-top: 0rem !important;
  }
}

@media (max-width: 1090px) {
  .mx0-maxtablet {
    margin-inline: 0rem !important;
  }
}

@media (max-width: 1090px) {
  .my0-maxtablet {
    margin-block: 0rem !important;
  }
}

@media (max-width: 1090px) {
  .h1-maxtablet {
    height: 10vh !important;
  }
}

@media (max-width: 1090px) {
  .m1-maxtablet {
    margin: 1rem !important;
  }
}

@media (max-width: 1090px) {
  .ml1-maxtablet {
    margin-left: 1rem !important;
  }
}

@media (max-width: 1090px) {
  .mb1-maxtablet {
    margin-bottom: 1rem !important;
  }
}

@media (max-width: 1090px) {
  .mr1-maxtablet {
    margin-right: 1rem !important;
  }
}

@media (max-width: 1090px) {
  .mt1-maxtablet {
    margin-top: 1rem !important;
  }
}

@media (max-width: 1090px) {
  .mx1-maxtablet {
    margin-inline: 1rem !important;
  }
}

@media (max-width: 1090px) {
  .my1-maxtablet {
    margin-block: 1rem !important;
  }
}

@media (max-width: 1090px) {
  .h2-maxtablet {
    height: 20vh !important;
  }
}

@media (max-width: 1090px) {
  .m2-maxtablet {
    margin: 2rem !important;
  }
}

@media (max-width: 1090px) {
  .ml2-maxtablet {
    margin-left: 2rem !important;
  }
}

@media (max-width: 1090px) {
  .mb2-maxtablet {
    margin-bottom: 2rem !important;
  }
}

@media (max-width: 1090px) {
  .mr2-maxtablet {
    margin-right: 2rem !important;
  }
}

@media (max-width: 1090px) {
  .mt2-maxtablet {
    margin-top: 2rem !important;
  }
}

@media (max-width: 1090px) {
  .mx2-maxtablet {
    margin-inline: 2rem !important;
  }
}

@media (max-width: 1090px) {
  .my2-maxtablet {
    margin-block: 2rem !important;
  }
}

@media (max-width: 1090px) {
  .h3-maxtablet {
    height: 30vh !important;
  }
}

@media (max-width: 1090px) {
  .m3-maxtablet {
    margin: 3rem !important;
  }
}

@media (max-width: 1090px) {
  .ml3-maxtablet {
    margin-left: 3rem !important;
  }
}

@media (max-width: 1090px) {
  .mb3-maxtablet {
    margin-bottom: 3rem !important;
  }
}

@media (max-width: 1090px) {
  .mr3-maxtablet {
    margin-right: 3rem !important;
  }
}

@media (max-width: 1090px) {
  .mt3-maxtablet {
    margin-top: 3rem !important;
  }
}

@media (max-width: 1090px) {
  .mx3-maxtablet {
    margin-inline: 3rem !important;
  }
}

@media (max-width: 1090px) {
  .my3-maxtablet {
    margin-block: 3rem !important;
  }
}

@media (max-width: 1090px) {
  .h4-maxtablet {
    height: 40vh !important;
  }
}

@media (max-width: 1090px) {
  .m4-maxtablet {
    margin: 4rem !important;
  }
}

@media (max-width: 1090px) {
  .ml4-maxtablet {
    margin-left: 4rem !important;
  }
}

@media (max-width: 1090px) {
  .mb4-maxtablet {
    margin-bottom: 4rem !important;
  }
}

@media (max-width: 1090px) {
  .mr4-maxtablet {
    margin-right: 4rem !important;
  }
}

@media (max-width: 1090px) {
  .mt4-maxtablet {
    margin-top: 4rem !important;
  }
}

@media (max-width: 1090px) {
  .mx4-maxtablet {
    margin-inline: 4rem !important;
  }
}

@media (max-width: 1090px) {
  .my4-maxtablet {
    margin-block: 4rem !important;
  }
}

@media (max-width: 1090px) {
  .h5-maxtablet {
    height: 50vh !important;
  }
}

@media (max-width: 1090px) {
  .m5-maxtablet {
    margin: 5rem !important;
  }
}

@media (max-width: 1090px) {
  .ml5-maxtablet {
    margin-left: 5rem !important;
  }
}

@media (max-width: 1090px) {
  .mb5-maxtablet {
    margin-bottom: 5rem !important;
  }
}

@media (max-width: 1090px) {
  .mr5-maxtablet {
    margin-right: 5rem !important;
  }
}

@media (max-width: 1090px) {
  .mt5-maxtablet {
    margin-top: 5rem !important;
  }
}

@media (max-width: 1090px) {
  .mx5-maxtablet {
    margin-inline: 5rem !important;
  }
}

@media (max-width: 1090px) {
  .my5-maxtablet {
    margin-block: 5rem !important;
  }
}

@media (max-width: 1090px) {
  .h6-maxtablet {
    height: 60vh !important;
  }
}

@media (max-width: 1090px) {
  .m6-maxtablet {
    margin: 6rem !important;
  }
}

@media (max-width: 1090px) {
  .ml6-maxtablet {
    margin-left: 6rem !important;
  }
}

@media (max-width: 1090px) {
  .mb6-maxtablet {
    margin-bottom: 6rem !important;
  }
}

@media (max-width: 1090px) {
  .mr6-maxtablet {
    margin-right: 6rem !important;
  }
}

@media (max-width: 1090px) {
  .mt6-maxtablet {
    margin-top: 6rem !important;
  }
}

@media (max-width: 1090px) {
  .mx6-maxtablet {
    margin-inline: 6rem !important;
  }
}

@media (max-width: 1090px) {
  .my6-maxtablet {
    margin-block: 6rem !important;
  }
}

@media (max-width: 1090px) {
  .h7-maxtablet {
    height: 70vh !important;
  }
}

@media (max-width: 1090px) {
  .m7-maxtablet {
    margin: 7rem !important;
  }
}

@media (max-width: 1090px) {
  .ml7-maxtablet {
    margin-left: 7rem !important;
  }
}

@media (max-width: 1090px) {
  .mb7-maxtablet {
    margin-bottom: 7rem !important;
  }
}

@media (max-width: 1090px) {
  .mr7-maxtablet {
    margin-right: 7rem !important;
  }
}

@media (max-width: 1090px) {
  .mt7-maxtablet {
    margin-top: 7rem !important;
  }
}

@media (max-width: 1090px) {
  .mx7-maxtablet {
    margin-inline: 7rem !important;
  }
}

@media (max-width: 1090px) {
  .my7-maxtablet {
    margin-block: 7rem !important;
  }
}

@media (max-width: 1090px) {
  .h8-maxtablet {
    height: 80vh !important;
  }
}

@media (max-width: 1090px) {
  .m8-maxtablet {
    margin: 8rem !important;
  }
}

@media (max-width: 1090px) {
  .ml8-maxtablet {
    margin-left: 8rem !important;
  }
}

@media (max-width: 1090px) {
  .mb8-maxtablet {
    margin-bottom: 8rem !important;
  }
}

@media (max-width: 1090px) {
  .mr8-maxtablet {
    margin-right: 8rem !important;
  }
}

@media (max-width: 1090px) {
  .mt8-maxtablet {
    margin-top: 8rem !important;
  }
}

@media (max-width: 1090px) {
  .mx8-maxtablet {
    margin-inline: 8rem !important;
  }
}

@media (max-width: 1090px) {
  .my8-maxtablet {
    margin-block: 8rem !important;
  }
}

@media (max-width: 1090px) {
  .h9-maxtablet {
    height: 90vh !important;
  }
}

@media (max-width: 1090px) {
  .m9-maxtablet {
    margin: 9rem !important;
  }
}

@media (max-width: 1090px) {
  .ml9-maxtablet {
    margin-left: 9rem !important;
  }
}

@media (max-width: 1090px) {
  .mb9-maxtablet {
    margin-bottom: 9rem !important;
  }
}

@media (max-width: 1090px) {
  .mr9-maxtablet {
    margin-right: 9rem !important;
  }
}

@media (max-width: 1090px) {
  .mt9-maxtablet {
    margin-top: 9rem !important;
  }
}

@media (max-width: 1090px) {
  .mx9-maxtablet {
    margin-inline: 9rem !important;
  }
}

@media (max-width: 1090px) {
  .my9-maxtablet {
    margin-block: 9rem !important;
  }
}

@media (max-width: 1090px) {
  .h10-maxtablet {
    height: 100vh !important;
  }
}

@media (max-width: 1090px) {
  .m10-maxtablet {
    margin: 10rem !important;
  }
}

@media (max-width: 1090px) {
  .ml10-maxtablet {
    margin-left: 10rem !important;
  }
}

@media (max-width: 1090px) {
  .mb10-maxtablet {
    margin-bottom: 10rem !important;
  }
}

@media (max-width: 1090px) {
  .mr10-maxtablet {
    margin-right: 10rem !important;
  }
}

@media (max-width: 1090px) {
  .mt10-maxtablet {
    margin-top: 10rem !important;
  }
}

@media (max-width: 1090px) {
  .mx10-maxtablet {
    margin-inline: 10rem !important;
  }
}

@media (max-width: 1090px) {
  .my10-maxtablet {
    margin-block: 10rem !important;
  }
}

.z0 {
  position: relative;
  z-index: 0 !important;
}

.z-0 {
  position: relative;
  z-index: 0 !important;
}

.z1 {
  position: relative;
  z-index: 1 !important;
}

.z-1 {
  position: relative;
  z-index: -1 !important;
}

.z2 {
  position: relative;
  z-index: 2 !important;
}

.z-2 {
  position: relative;
  z-index: -2 !important;
}

.z3 {
  position: relative;
  z-index: 3 !important;
}

.z-3 {
  position: relative;
  z-index: -3 !important;
}

.p1 {
  padding: 1rem !important;
}

.pl1 {
  padding-left: 1rem !important;
}

.pb1 {
  padding-bottom: 1rem !important;
}

.pr1 {
  padding-right: 1rem !important;
}

.pt1 {
  padding-top: 1rem !important;
}

.px1 {
  padding-inline: 1rem !important;
}

.py1 {
  padding-block: 1rem !important;
}

.p2 {
  padding: 2rem !important;
}

.pl2 {
  padding-left: 2rem !important;
}

.pb2 {
  padding-bottom: 2rem !important;
}

.pr2 {
  padding-right: 2rem !important;
}

.pt2 {
  padding-top: 2rem !important;
}

.px2 {
  padding-inline: 2rem !important;
}

.py2 {
  padding-block: 2rem !important;
}

.p3 {
  padding: 3rem !important;
}

.pl3 {
  padding-left: 3rem !important;
}

.pb3 {
  padding-bottom: 3rem !important;
}

.pr3 {
  padding-right: 3rem !important;
}

.pt3 {
  padding-top: 3rem !important;
}

.px3 {
  padding-inline: 3rem !important;
}

.py3 {
  padding-block: 3rem !important;
}

.p4 {
  padding: 4rem !important;
}

.pl4 {
  padding-left: 4rem !important;
}

.pb4 {
  padding-bottom: 4rem !important;
}

.pr4 {
  padding-right: 4rem !important;
}

.pt4 {
  padding-top: 4rem !important;
}

.px4 {
  padding-inline: 4rem !important;
}

.py4 {
  padding-block: 4rem !important;
}

.p5 {
  padding: 5rem !important;
}

.pl5 {
  padding-left: 5rem !important;
}

.pb5 {
  padding-bottom: 5rem !important;
}

.pr5 {
  padding-right: 5rem !important;
}

.pt5 {
  padding-top: 5rem !important;
}

.px5 {
  padding-inline: 5rem !important;
}

.py5 {
  padding-block: 5rem !important;
}

.relative {
  position: relative;
}

.color-white {
  color: #FFF !important;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.w0 {
  width: 0% !important;
}

@media (max-width: 1090px) {
  .w0-maxtablet {
    width: 0% !important;
  }
}

.w5 {
  width: 5% !important;
}

@media (max-width: 1090px) {
  .w5-maxtablet {
    width: 5% !important;
  }
}

.w10 {
  width: 10% !important;
}

@media (max-width: 1090px) {
  .w10-maxtablet {
    width: 10% !important;
  }
}

.w15 {
  width: 15% !important;
}

@media (max-width: 1090px) {
  .w15-maxtablet {
    width: 15% !important;
  }
}

.w20 {
  width: 20% !important;
}

@media (max-width: 1090px) {
  .w20-maxtablet {
    width: 20% !important;
  }
}

.w25 {
  width: 25% !important;
}

@media (max-width: 1090px) {
  .w25-maxtablet {
    width: 25% !important;
  }
}

.w30 {
  width: 30% !important;
}

@media (max-width: 1090px) {
  .w30-maxtablet {
    width: 30% !important;
  }
}

.w35 {
  width: 35% !important;
}

@media (max-width: 1090px) {
  .w35-maxtablet {
    width: 35% !important;
  }
}

.w40 {
  width: 40% !important;
}

@media (max-width: 1090px) {
  .w40-maxtablet {
    width: 40% !important;
  }
}

.w45 {
  width: 45% !important;
}

@media (max-width: 1090px) {
  .w45-maxtablet {
    width: 45% !important;
  }
}

.w50 {
  width: 50% !important;
}

@media (max-width: 1090px) {
  .w50-maxtablet {
    width: 50% !important;
  }
}

.w55 {
  width: 55% !important;
}

@media (max-width: 1090px) {
  .w55-maxtablet {
    width: 55% !important;
  }
}

.w60 {
  width: 60% !important;
}

@media (max-width: 1090px) {
  .w60-maxtablet {
    width: 60% !important;
  }
}

.w65 {
  width: 65% !important;
}

@media (max-width: 1090px) {
  .w65-maxtablet {
    width: 65% !important;
  }
}

.w70 {
  width: 70% !important;
}

@media (max-width: 1090px) {
  .w70-maxtablet {
    width: 70% !important;
  }
}

.w75 {
  width: 75% !important;
}

@media (max-width: 1090px) {
  .w75-maxtablet {
    width: 75% !important;
  }
}

.w80 {
  width: 80% !important;
}

@media (max-width: 1090px) {
  .w80-maxtablet {
    width: 80% !important;
  }
}

.w85 {
  width: 85% !important;
}

@media (max-width: 1090px) {
  .w85-maxtablet {
    width: 85% !important;
  }
}

.w90 {
  width: 90% !important;
}

@media (max-width: 1090px) {
  .w90-maxtablet {
    width: 90% !important;
  }
}

.w95 {
  width: 95% !important;
}

@media (max-width: 1090px) {
  .w95-maxtablet {
    width: 95% !important;
  }
}

.w100 {
  width: 100% !important;
}

@media (max-width: 1090px) {
  .w100-maxtablet {
    width: 100% !important;
  }
}

.break-spaces {
  white-space: break-spaces;
}

.w-fit {
  width: fit-content !important;
}

.d-none {
  display: none !important;
}

.wmincontent {
  width: min-content !important;
}

.hmincontent {
  height: min-content !important;
}

.wmaxcontent {
  width: max-content !important;
}

.hmaxcontent {
  height: max-content !important;
}

.title {
  text-align: center;
  font-size: var(--font-grande);
}

.text-l {
  text-align: left;
}

.text-r {
  text-align: right;
}

.secondarytitle {
  text-align: left;
  margin-bottom: 2rem;
  font-size: var(--font-grande);
}

.bg-attach-fix {
  background-attachment: fixed;
}

.gridcenter {
  grid-column: 1/-1 !important;
  width: 100% !important;
}

.dflex {
  display: flex !important;
}

.justify-center {
  justify-content: center !important;
}

.justify-evenly {
  justify-content: space-evenly !important;
}

.justify-between {
  justify-content: space-between !important;
}

.align-start {
  align-items: start !important;
}

.align-center {
  align-items: center !important;
}

.align-baseline {
  align-items: baseline !important;
}

.dcenter {
  display: flex !important;
  justify-content: center !important;
}

.dcol {
  display: flex;
  flex-direction: column !important;
}

.drow {
  display: flex;
  flex-direction: row !important;
}

.relative {
  position: relative;
}

.dcolcenter {
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
}

.color-grey {
  color: var(--grey-color) !important;
}

.relative {
  position: relative;
}

.check {
  font-size: 1.2rem !important;
  display: inline-block;
  color: #FF9933;
  transform: translateY(4px);
}

.leermas {
  color: #FF9933;
  width: max-content;
  min-width: fit-content;
  cursor: pointer;
  transition: color 150ms ease-in-out;
}
.leermas svg {
  margin-left: 5px;
  font-size: 1.2rem;
}
.leermas:hover {
  color: var(--stronggreen-color) !important;
}

.center-child {
  display: grid;
  place-items: center;
}

.tituloImagen {
  font-size: var(--font-gigante) !important;
}

.tituloSection {
  font-size: var(--font-mediana2) !important;
}

.subtituloSection {
  font-size: var(--font-mediana) !important;
}

.parrafoSection {
  font-size: var(--font-normal) !important;
}

.tituloBox {
  margin-bottom: 1rem;
  color: white;
  text-align: center;
  font-size: var(--font-grande);
  background-color: var(--stronggreen-color);
  padding: 1rem;
  border-radius: 5px;
}

@media (max-width: 630px) {
  .mobile-dnone {
    display: none !important;
  }
}
.swiper-pagination-bullet-active {
  background: var(--gold-800) !important;
}

.btnGreen {
  background: var(--green-800);
  border-radius: 24px;
  border: none;
  transition: all ease 0.3s;
  width: 10rem;
  padding: 0.5rem;
  color: var(--white) !important;
  font-weight: 400;
  font-size: var(--font-boton);
}
.btnGreen a {
  color: var(--white) !important;
  text-decoration: none;
  outline: none;
  position: relative;
  font-weight: 400;
  font-size: var(--font-boton);
  padding: 1rem;
  text-align: center;
}
.btnGreen:hover {
  background: var(--green-600);
}
.btnGreen:disabled, .btnGreen[disabled=true], .btnGreen[disabled=disabled] {
  filter: grayscale(0.6);
}
.btnGreen {
  margin-top: 1rem;
  max-height: 3rem;
}

.btnOrange {
  background: var(--gold-800);
  border-radius: 24px;
  border: none;
  transition: all ease 0.3s;
  width: 10rem;
  padding: 0.5rem;
  color: var(--white) !important;
  font-weight: 400;
  font-size: var(--font-boton);
}
.btnOrange a {
  color: var(--white) !important;
  text-decoration: none;
  outline: none;
  position: relative;
  font-weight: 400;
  font-size: var(--font-boton);
  padding: 1rem;
  text-align: center;
}
.btnOrange:hover {
  background: var(--gold-600);
}
.btnOrange:disabled, .btnOrange[disabled=true], .btnOrange[disabled=disabled] {
  filter: grayscale(0.6);
}
.btnOrange {
  padding: 0.4rem;
  border-radius: 10px;
  font-size: var(--font-chica);
}

.btnWhite {
  background: var(--white) !important;
  border-radius: 24px;
  border: none;
  transition: all ease 0.3s;
  width: 10rem;
  padding: 0.5rem;
  color: var(--gold-800) !important;
  font-weight: 400;
  font-size: var(--font-boton);
}
.btnWhite a {
  color: var(--gold-800) !important;
  text-decoration: none;
  outline: none;
  position: relative;
  font-weight: 400;
  font-size: var(--font-boton);
  padding: 1rem;
  text-align: center;
}
.btnWhite:hover {
  background: #f88c1f;
}
.btnWhite:disabled, .btnWhite[disabled=true], .btnWhite[disabled=disabled] {
  filter: grayscale(0.6);
}
.btnWhite {
  padding: 0.4rem;
  border-radius: 10px;
  font-size: var(--font-chica);
  border: 1px solid var(--gold-800);
}

.Button {
  width: auto;
  height: 2rem;
  border-radius: 5px;
  border: none;
  color: var(--white);
  background-color: var(--green-800);
  border: none;
  z-index: 99;
  border: 2px solid transparent;
  transition: 0.4s all;
}
.Button:hover {
  background-color: var(--white);
  transition: 0.4s all;
  border: 2px solid var(--green-800);
  color: var(--green-800);
}
.Button:disabled, .Button[disabled=true], .Button[disabled=disabled] {
  filter: grayscale(0.6);
}

.Button-orange {
  width: auto;
  height: 2rem;
  border-radius: 5px;
  border: none;
  color: var(--white);
  background-color: var(--gold-800);
  border: none;
  z-index: 99;
  border: 2px solid transparent;
  transition: 0.4s all;
}
.Button-orange:hover {
  background-color: var(--white);
  transition: 0.4s all;
  border: 2px solid var(--gold-800);
  color: var(--gold-800);
}
.Button-orange:disabled, .Button-orange[disabled=true], .Button-orange[disabled=disabled] {
  filter: grayscale(0.6);
}

.Button-gray {
  width: auto;
  height: 2rem;
  border-radius: 5px;
  border: none;
  color: var(--white);
  background-color: var(--grey-light-color);
  border: none;
  z-index: 99;
  border: 2px solid transparent;
  transition: 0.4s all;
}
.Button-gray:hover {
  background-color: var(--white);
  transition: 0.4s all;
  border: 2px solid var(--grey-light-color);
  color: var(--grey-light-color);
}
.Button-gray:disabled, .Button-gray[disabled=true], .Button-gray[disabled=disabled] {
  filter: grayscale(0.6);
}

.no-caret-dropdown .dropdown-toggle::after {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/App.scss","webpack://./node_modules/react-big-calendar/lib/sass/reset.scss","webpack://./node_modules/react-big-calendar/lib/sass/styles.scss","webpack://./node_modules/react-big-calendar/lib/sass/variables.scss","webpack://./node_modules/react-big-calendar/lib/sass/toolbar.scss","webpack://./node_modules/react-big-calendar/lib/sass/event.scss","webpack://./node_modules/react-big-calendar/lib/sass/month.scss","webpack://./node_modules/react-big-calendar/lib/sass/agenda.scss","webpack://./node_modules/react-big-calendar/lib/sass/time-column.scss","webpack://./node_modules/react-big-calendar/lib/sass/time-grid.scss","webpack://./src/sass/_base.scss","webpack://./src/sass/_sizes.scss","webpack://./src/sass/utils/_helpers.scss","webpack://./src/sass/component/_buttons.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,cAAA;EACA,aAAA;EACA,SAAA;ADGF;;ACAA;EACE,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;ADGF;;ACAA;EACE,mBAAA;ADGF;;ACAA;EACE,SAAA;EACA,UAAA;ADGF;;AEnBA;EACE,sBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AFsBF;;AEnBA;EACE,mBAAA;AFsBF;;AEnBA;EACE,YAAA;AFsBF;;AEnBA;;;EAGE,mBAAA;AFsBF;;AEnBA;EACE,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AFsBF;;AEnBA;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AFsBF;;AEnBA;EACE,cAAA;AFsBF;;AEnBA;EACE,cC9CmB;AHoErB;;AEnBA;EACE,oCCjDsB;AHuExB;;AEnBA;EACE,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,6BAAA;AFsBF;AEpBE;EACE,2BAAA;AFsBJ;AEnBE;EACE,oBAAA;EACA,4BAAA;AFqBJ;AEjBI;EAGE,cAAA;EACA,qBAAA;AFiBN;;AEZA;EACE,cAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AFeF;;AEZA;EACE,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,UAAA;AFeF;;AEZA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AFeF;AEbE;EACE,YAAA;EACA,kBAAA;EACA,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;EAEA,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;EAEA,gDAAA;AFaJ;AEZI;EACE,aAAA;AFcN;;AETA;EACE,yBC7FmB;AHyGrB;;AInIA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AJsIF;AIpIE;EACE,YAAA;EACA,eAAA;EACA,kBAAA;AJsIJ;AInIE;EACE,cDGQ;ECFR,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AJqIJ;AInII;EAEE,sBAAA;EACA,gDAAA;EACA,0CAnCc;EAoCd,sCAnCU;AJuKhB;AIlIM;EAEE,cDnBI;ECoBJ,6CAAA;EACA,yCAAA;AJmIR;AI/HI;EACE,cD1BM;EC2BN,0CAhDc;EAiDd,sCAhDU;AJiLhB;AI9HI;EACE,cDhCM;ECiCN,eAAA;EACA,0CAvDc;EAwDV,sCAvDM;AJuLhB;;AI3HA;EACE,qBAAA;EACA,mBAAA;AJ8HF;AI5HE;EACE,0BAAA;EACA,6BAAA;AJ8HJ;AI3HE;EACE,yBAAA;EACA,4BAAA;AJ6HJ;AI1HE;EACE,kBAAA;EACA,yBAAA;EACA,4BAAA;AJ4HJ;AIzHE;EACE,kBAAA;EACA,0BAAA;EACA,6BAAA;AJ2HJ;AIxHE;EACE,gBAAA;AJ0HJ;AIvHE;EACE,iBAAA;AJyHJ;AItHE;EACE,cAAA;EACA,kBAAA;AJwHJ;AIrHE;EAEE,iBAAA;AJsHJ;;AIlHA;EACE;IACE,sBAAA;EJqHF;AACF;AKlOA;EACE,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,gBFac;EEZd,yBFOS;EENT,kBFUoB;EETpB,WFQY;EEPZ,eAAA;EACA,WAAA;EACA,gBAAA;ALoOF;AKlOE;EACE,eAAA;EACA,oBAAA;ALoOJ;AKjOE;EACE,mEAAA;ALmOJ;AKhOE;EACE,yBAAA;ALkOJ;;AK9NA;EAEE,cAAA;ALgOF;;AK7NA;EACE,kDAAA;ALgOF;;AK7NA;EACE,yBAAA;EACA,4BAAA;ALgOF;;AK9NA;EACE,0BAAA;EACA,6BAAA;ALiOF;;AK7NA;EACE,yBAAA;EACA,0BAAA;ALgOF;;AK9NA;EACE,4BAAA;EACA,6BAAA;ALiOF;;AMrRA;EACE,aAAA;EACA,mBAAA;ANwRF;;AMrRA;EACE,sBAAA;ANwRF;AMjRA;EACE,oCHHwB;AHsR1B;;AMhRA;EAEE,0CAAA;EACA,UHDa;EGEb,iBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,cHZS;AH8RX;AMjRE;EAEE,wDAAA;ANkRJ;;AM9QA;EACE,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EAEA,YAAA;ANgRF;;AM7QA;EACE,aAAA;EACA,mBAAA;ANgRF;;AM7QA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EAEA,YAAA;AN+QF;AM7QE;EACE,0BAAA;AN+QJ;;AM3QA;EACE,SAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AN8QF;AM5QE;EACE,iBAAA;AN8QJ;AM1QI;EAGE,cAAA;EACA,qBAAA;AN0QN;;AMrQA;EAEE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;ANuQF;;AMpQA;EACE,SAAA;ANuQF;AMrQE;EACE,2BAAA;ANuQJ;AMpQE;EACE,oBAAA;EACA,4BAAA;ANsQJ;;AMlQA;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,sBAAA;EACA,0CAAA;EACA,aAAA;ANqQF;AMnQE;EACE,eAAA;ANqQJ;;AMjQA;EACE,gCAAA;EACA,6BAAA;EACA,iBAAA;ANoQF;;AO/XA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;APkYF;AOhYE;EACE,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;APkYJ;AOhYI;EACE,iBAAA;EACA,mBAAA;APkYN;AO/XI;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;APiYN;AO9XI;EACE,2BAAA;APgYN;AO5XM;EACE,oBAAA;EACA,4BAAA;AP8XR;AO1XI;EACE,0BAAA;AP4XN;AOzXI;EACE,gBAAA;EACA,gBAAA;EACA,6BAAA;AP2XN;AOzXM;EACE,iBAAA;AP2XR;;AOrXA;EACE,yBAAA;APwXF;AOtXE;EACE,aAAA;APwXJ;AOtXE;EACE,aAAA;APwXJ;;AOpXA;;EAEE,mBAAA;APuXF;;AOlXA;EACE,WAAA;APqXF;;AQ1bA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AR6bF;AQ3bE;EACE,SAAA;AR6bJ;;AQxbA;EACE,6BAAA;EACA,gBAAA;EACA,aAAA;EACA,wBAAA;AR2bF;;AQxbA;;EAEE,UAAA;AR2bF;;AQxbA;EACE,cAAA;AR2bF;;AQxbA;EACE,kBAAA;AR2bF;AQzbE;EACE,SAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;AR2bJ;AQzbI;EACE,UAAA;EACA,QAAA;AR2bN;AQvbE;EACE,mEAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;ARybJ;AQtbE;EAEE,aAAA;ARubJ;AQpbE;EACE,UAAA;EACA,kBAAA;EACA,WAAA;ARsbJ;AQnbE;EACE,WAAA;EACA,SAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;ARqbJ;AQlbE;EACE,8CAAA;ARobJ;;AQ/aE;;EAEE,gBAAA;EACA,OAAA;EACA,uBAAA;EACA,4BAAA;EACA,WAAA;EACA,kBAAA;ARkbJ;AQ/aE;EACE,gBAAA;ARibJ;AQ9aE;EACE,eAAA;EACA,SAAA;EACA,eAAA;ARgbJ;AQ7aE;EACE,aAAA;AR+aJ;AQ5aE;EACE,gBAAA;AR8aJ;AQ3aE;;EAEE,YAAA;EAEA,SAAA;EACA,gBAAA;AR4aJ;;AQxaA;EACE,iBAAA;AR2aF;;AQxaA;EACE,SAAA;AR2aF;AQzaE;EACE,iBAAA;AR2aJ;;AQvaA;EACE,kBAAA;AR0aF;;AS5iBA;EACE,WAAA;EACA,kBAAA;EACA,oCNMwB;EMLxB,YNIqB;EMHrB,cAAA;EACA,WAAA;EACA,YAAA;AT+iBF;;AS5iBA;EACE,YAAA;AT+iBF;;AS5iBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;AT+iBF;AS7iBE;EACE,mBAAA;EACA,iBAAA;AT+iBJ;AS5iBE;EACE,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AT8iBJ;AS5iBE;EACE,2BAAA;AT8iBJ;AS3iBE;EACE,kBAAA;EACA,UAAA;AT6iBJ;AS1iBE;EACE,sBAAA;EACA,gBAAA;AT4iBJ;;ASxiBA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;AT2iBF;ASziBE;EACE,4BAAA;AT2iBJ;ASxiBE;EACE,qBAAA;EACA,2BAAA;AT0iBJ;ASviBE;EACE,6BAAA;ATyiBJ;AStiBE;EACE,6BAAA;ATwiBJ;;AS5hBA;EACE,aAAA;AT+hBF;;AS5hBA;EACE,SAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;AT+hBF;AS7hBE;EACE,oBAAA;EACA,4BAAA;AT+hBJ;AS5hBE;EACE,6BAAA;EACA,cAAA;AT8hBJ;;AS1hBA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;AT6hBF;AS3hBE;EACE,UAAA;AT6hBJ;AS1hBE;EACE,2BAAA;AT4hBJ;ASzhBE;EACE,oBAAA;EACA,4BAAA;AT2hBJ;ASxhBE;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;AT0hBJ;;ASthBA;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EAEA,yBNjHmB;EMkHnB,oBAAA;ATwhBF;;ASphBE;EACE,aAAA;EACA,sBAAA;ATuhBJ;ASphBE;EACE,YAAA;ATshBJ;;AU1qBA;EAEE,gCAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;AV4qBF;;AUzqBA;EACE,WAAA;AV4qBF;AU1qBE;EACE,UAAA;EACA,SAAA;EACA,gBAAA;AV4qBJ;AUxqBE;EACE,mBAAA;AV0qBJ;AUvqBE;;;;EAIE,SAAA;AVyqBJ;AUtqBE;EACE,eAAA;AVwqBJ;AUrqBE;EACE,eAAA;EACA,qBAAA;AVuqBJ;;AUnqBA;EACE,mCAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AVsqBF;;AUnqBA;EACE,gBAAA;EACA,qBAAA;EACA,sBAAA;EAEA,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EAEA,cAAA;EACA,mBAAA;EACA,oBAAA;EAEA,gBAAA;EACA,sBAAA;EAEA,eAAA;EACA,iBAAA;EACA,qBAAA;EAEA,iBAAA;EACA,sBAAA;EACA,uBAAA;EAEA,iBAAA;EACA,sBAAA;EACA,iCAAA;EAEA,oBAAA;EACA,yBAAA;EACA,0BAAA;EAEA,eAAA;EACA,qBAAA;EAEA,oBAAA;EACA,0BAAA;EAEA,eAAA;EAEA,iBAAA;EAEA,aAAA;EAGA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,wBAAA;EAGA,oBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;EAGA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EAGA,6CAAA;AVkpBF;;AU9oBA;EACE,oBAAA;AVipBF;;AU9oBA;EACE,iBAAA;AVipBF;;AU9oBA;EACE,mBAAA;AVipBF;;AU9oBA;EACE,kBAAA;AVipBF;;AU9oBA;EACE,kBAAA;AVipBF;;AU9oBA;EACE,uBAAA;AVipBF;;AU9oBA;EACE,8BAAA;AVipBF;;AU9oBA;EACE,8BAAA;AVipBF;;AU9oBA;EACE,6BAAA;AVipBF;;AU7oBA;EACE,0CAAA;AVgpBF;;AU7oBA;EACE,0CAAA;AVgpBF;;AU7oBA;EACE,uCAAA;AVgpBF;;AU7oBA;EACE,yCAAA;AVgpBF;;AU7oBA;EACE,wCAAA;AVgpBF;;AU7oBA;EACE,6CAAA;AVgpBF;;AU7oBA;EACE,wCAAA;AVgpBF;;AU7oBA;EACE,6CAAA;AVgpBF;;AU7oBA;EACE,kDAAA;AVgpBF;;AU7oBA;EACE,wCAAA;AVgpBF;;AU7oBA;EACE,0CAAA;AVgpBF;;AU7oBA;EACE,wCAAA;AVgpBF;;AU7oBA;EACE,8CAAA;AVgpBF;;AU7oBA;EACE,+HAAA;AVgpBF;;AU7oBA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,4EAAA;AVgpBF;;AU5oBA;EACE,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AV+oBF;;AU5oBA;EACE,6BAAA;EACA,oCAAA;EACA,8BAAA;EACA,6BAAA;AV+oBF;;AU5oBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AV+oBF;AU7oBE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AV+oBJ;;AU3oBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AV8oBF;AU5oBE;EACE,WAAA;EACA,YAAA;EACA,4BAAA;AV8oBJ;;AUzoBE;EADF;IAEI,iCAAA;EV6oBF;AACF;;AUzoBE;EADF;IAEI,iCAAA;EV6oBF;AACF;;AU1oBA,iBAAA;AACA;EACE,+BAAA;EACA,mBAAA;AV6oBF;AU3oBE;EACE,qCAAA;AV6oBJ;;AUzoBA;EACE,6BAAA;EACA,mBAAA;AV4oBF;AU1oBE;EACE,kCAAA;EACA,mBAAA;AV4oBJ;;AUxoBA;EACE,6BAAA;EACA,mBAAA;AV2oBF;AUzoBE;EACE,mCAAA;AV2oBJ;;AUvoBA;EACE,8BAAA;EACA,oBAAA;EACA,+BAAA;AV0oBF;AUxoBE;EACE,+BAAA;EACA,mBAAA;AV0oBJ;;AUtoBA;EACE,kCAAA;EACA,mBAAA;AVyoBF;AUvoBE;EACE,wCAAA;AVyoBJ;;AUroBA;EACE,4BAAA;EACA,mBAAA;AVwoBF;AUtoBE;EACE,kCAAA;AVwoBJ;;AUpoBA;EACE,wCAAA;EACA,sBAAA;EACA,0CAAA;AVuoBF;AUroBE;EACE,wCAAA;AVuoBJ;;AUnoBA;EACE,uCAAA;EACA,mBAAA;EACA,wCAAA;AVsoBF;AUpoBE;EACE,uCAAA;AVsoBJ;;AW/+BA;EAEE,SAAA;EAEA,SAAA;EAEA,SAAA;EAEA,SAAA;EAEA,SAAA;EAEA,SAAA;EAEA,SAAA;EAEA,SAAA;EAEA,SAAA;EAEA,SAAA;EAEA,SAAA;EAEA,SAAA;EAEA,SAAA;EAEA,SAAA;EAEA,SAAA;EAEA,SAAA;EAEA,SAAA;EAEA,SAAA;EAEA,SAAA;EAEA,SAAA;EAGA,UAAA;AX49BF;AW39BE;EACE,kBA5Ca;EA6Cb,iBA3Ce;AXwgCnB;AW19BE;EACE,mBA7Ca;EA8Cb,oBA5Ce;AXwgCnB;AWz9BE;EACE,eA9Ce;EA+Cf,mBA7CiB;AXwgCrB;AWx9BE;EACE,mBA/Ca;EAgDb,oBA9Ce;AXwgCnB;AWv9BE;EACE,kBAhDa;EAiDb,oBA/Ce;AXwgCnB;AWt9BE;EACE,iBAjDc;EAkDd,iBAhDgB;AXwgCpB;AWr9BE;EACE,mBAlDc;EAmDd,oBAjDgB;AXwgCpB;AWp9BE;EACE,kBAnDc;EAoDd,mBAlDgB;AXwgCpB;AWn9BE;EACE,eApDc;EAqDd,cAAA;EACA,mDAAA;AXq9BJ;AWl9BE;EACE,kBAxDc;EAyDd,cAAA;EACA,mDAAA;AXo9BJ;AWj9BE;EACE,iBA5Dc;EA6Dd,cAAA;EACA,mDAAA;AXm9BJ;AWh9BE;EACE,eAhEc;EAiEd,cAAA;EACA,mDAAA;AXk9BJ;AW/8BE;EACE,eApEc;EAqEd,cAAA;EACA,mDAAA;AXi9BJ;;AYzjCA;EACE,oBAAA;AZ4jCF;;AYzjCA;EACE,qBAAA;AZ4jCF;;AYxjCE;EACE,sBAAA;AZ2jCJ;;AYxjCE;EACE,uBAAA;AZ2jCJ;;AYxjCE;EACE,sBAAA;AZ2jCJ;;AYxjCE;EACE,uBAAA;AZ2jCJ;;AYxjCE;EACE,4BAAA;AZ2jCJ;;AYxjCE;EACE,8BAAA;AZ2jCJ;;AYxjCE;EACE,6BAAA;AZ2jCJ;;AYxjCE;EACE,2BAAA;AZ2jCJ;;AYxjCE;EACE,8BAAA;AZ2jCJ;;AYxjCE;EACE,6BAAA;AZ2jCJ;;AYxjCE;EACE,oBAAA;AZ2jCJ;;AYpmCE;EACE,sBAAA;AZumCJ;;AYpmCE;EACE,uBAAA;AZumCJ;;AYpmCE;EACE,uBAAA;AZumCJ;;AYpmCE;EACE,uBAAA;AZumCJ;;AYpmCE;EACE,4BAAA;AZumCJ;;AYpmCE;EACE,8BAAA;AZumCJ;;AYpmCE;EACE,6BAAA;AZumCJ;;AYpmCE;EACE,2BAAA;AZumCJ;;AYpmCE;EACE,8BAAA;AZumCJ;;AYpmCE;EACE,6BAAA;AZumCJ;;AYpmCE;EACE,oBAAA;AZumCJ;;AYhpCE;EACE,sBAAA;AZmpCJ;;AYhpCE;EACE,uBAAA;AZmpCJ;;AYhpCE;EACE,uBAAA;AZmpCJ;;AYhpCE;EACE,uBAAA;AZmpCJ;;AYhpCE;EACE,4BAAA;AZmpCJ;;AYhpCE;EACE,8BAAA;AZmpCJ;;AYhpCE;EACE,6BAAA;AZmpCJ;;AYhpCE;EACE,2BAAA;AZmpCJ;;AYhpCE;EACE,8BAAA;AZmpCJ;;AYhpCE;EACE,6BAAA;AZmpCJ;;AYhpCE;EACE,oBAAA;AZmpCJ;;AY5rCE;EACE,sBAAA;AZ+rCJ;;AY5rCE;EACE,uBAAA;AZ+rCJ;;AY5rCE;EACE,uBAAA;AZ+rCJ;;AY5rCE;EACE,uBAAA;AZ+rCJ;;AY5rCE;EACE,4BAAA;AZ+rCJ;;AY5rCE;EACE,8BAAA;AZ+rCJ;;AY5rCE;EACE,6BAAA;AZ+rCJ;;AY5rCE;EACE,2BAAA;AZ+rCJ;;AY5rCE;EACE,8BAAA;AZ+rCJ;;AY5rCE;EACE,6BAAA;AZ+rCJ;;AY5rCE;EACE,oBAAA;AZ+rCJ;;AYxuCE;EACE,sBAAA;AZ2uCJ;;AYxuCE;EACE,uBAAA;AZ2uCJ;;AYxuCE;EACE,uBAAA;AZ2uCJ;;AYxuCE;EACE,uBAAA;AZ2uCJ;;AYxuCE;EACE,4BAAA;AZ2uCJ;;AYxuCE;EACE,8BAAA;AZ2uCJ;;AYxuCE;EACE,6BAAA;AZ2uCJ;;AYxuCE;EACE,2BAAA;AZ2uCJ;;AYxuCE;EACE,8BAAA;AZ2uCJ;;AYxuCE;EACE,6BAAA;AZ2uCJ;;AYxuCE;EACE,oBAAA;AZ2uCJ;;AYpxCE;EACE,sBAAA;AZuxCJ;;AYpxCE;EACE,uBAAA;AZuxCJ;;AYpxCE;EACE,uBAAA;AZuxCJ;;AYpxCE;EACE,uBAAA;AZuxCJ;;AYpxCE;EACE,4BAAA;AZuxCJ;;AYpxCE;EACE,8BAAA;AZuxCJ;;AYpxCE;EACE,6BAAA;AZuxCJ;;AYpxCE;EACE,2BAAA;AZuxCJ;;AYpxCE;EACE,8BAAA;AZuxCJ;;AYpxCE;EACE,6BAAA;AZuxCJ;;AYpxCE;EACE,oBAAA;AZuxCJ;;AYh0CE;EACE,sBAAA;AZm0CJ;;AYh0CE;EACE,uBAAA;AZm0CJ;;AYh0CE;EACE,uBAAA;AZm0CJ;;AYh0CE;EACE,uBAAA;AZm0CJ;;AYh0CE;EACE,4BAAA;AZm0CJ;;AYh0CE;EACE,8BAAA;AZm0CJ;;AYh0CE;EACE,6BAAA;AZm0CJ;;AYh0CE;EACE,2BAAA;AZm0CJ;;AYh0CE;EACE,8BAAA;AZm0CJ;;AYh0CE;EACE,6BAAA;AZm0CJ;;AYh0CE;EACE,oBAAA;AZm0CJ;;AY52CE;EACE,sBAAA;AZ+2CJ;;AY52CE;EACE,uBAAA;AZ+2CJ;;AY52CE;EACE,uBAAA;AZ+2CJ;;AY52CE;EACE,uBAAA;AZ+2CJ;;AY52CE;EACE,4BAAA;AZ+2CJ;;AY52CE;EACE,8BAAA;AZ+2CJ;;AY52CE;EACE,6BAAA;AZ+2CJ;;AY52CE;EACE,2BAAA;AZ+2CJ;;AY52CE;EACE,8BAAA;AZ+2CJ;;AY52CE;EACE,6BAAA;AZ+2CJ;;AY52CE;EACE,oBAAA;AZ+2CJ;;AYx5CE;EACE,sBAAA;AZ25CJ;;AYx5CE;EACE,uBAAA;AZ25CJ;;AYx5CE;EACE,uBAAA;AZ25CJ;;AYx5CE;EACE,uBAAA;AZ25CJ;;AYx5CE;EACE,4BAAA;AZ25CJ;;AYx5CE;EACE,8BAAA;AZ25CJ;;AYx5CE;EACE,6BAAA;AZ25CJ;;AYx5CE;EACE,2BAAA;AZ25CJ;;AYx5CE;EACE,8BAAA;AZ25CJ;;AYx5CE;EACE,6BAAA;AZ25CJ;;AYx5CE;EACE,oBAAA;AZ25CJ;;AYp8CE;EACE,sBAAA;AZu8CJ;;AYp8CE;EACE,uBAAA;AZu8CJ;;AYp8CE;EACE,uBAAA;AZu8CJ;;AYp8CE;EACE,uBAAA;AZu8CJ;;AYp8CE;EACE,4BAAA;AZu8CJ;;AYp8CE;EACE,8BAAA;AZu8CJ;;AYp8CE;EACE,6BAAA;AZu8CJ;;AYp8CE;EACE,2BAAA;AZu8CJ;;AYp8CE;EACE,8BAAA;AZu8CJ;;AYp8CE;EACE,6BAAA;AZu8CJ;;AYp8CE;EACE,oBAAA;AZu8CJ;;AYh/CE;EACE,uBAAA;AZm/CJ;;AYh/CE;EACE,wBAAA;AZm/CJ;;AYh/CE;EACE,wBAAA;AZm/CJ;;AYh/CE;EACE,wBAAA;AZm/CJ;;AYh/CE;EACE,6BAAA;AZm/CJ;;AYh/CE;EACE,+BAAA;AZm/CJ;;AYh/CE;EACE,8BAAA;AZm/CJ;;AYh/CE;EACE,4BAAA;AZm/CJ;;AYh/CE;EACE,+BAAA;AZm/CJ;;AYh/CE;EACE,8BAAA;AZm/CJ;;AYh/CE;EACE,qBAAA;AZm/CJ;;AY/+CA;EACE,8BAAA;AZk/CF;;AY9+CE;EACE,0BAAA;AZi/CJ;;AY9+CE;EACE,2BAAA;AZi/CJ;;AYt/CE;EACE,0BAAA;AZy/CJ;;AYt/CE;EACE,2BAAA;AZy/CJ;;AY9/CE;EACE,0BAAA;AZigDJ;;AY9/CE;EACE,2BAAA;AZigDJ;;AYtgDE;EACE,0BAAA;AZygDJ;;AYtgDE;EACE,2BAAA;AZygDJ;;AY9gDE;EACE,0BAAA;AZihDJ;;AY9gDE;EACE,2BAAA;AZihDJ;;AYthDE;EACE,0BAAA;AZyhDJ;;AYthDE;EACE,2BAAA;AZyhDJ;;AY9hDE;EACE,0BAAA;AZiiDJ;;AY9hDE;EACE,2BAAA;AZiiDJ;;AYtiDE;EACE,0BAAA;AZyiDJ;;AYtiDE;EACE,2BAAA;AZyiDJ;;AY9iDE;EACE,0BAAA;AZijDJ;;AY9iDE;EACE,2BAAA;AZijDJ;;AYtjDE;EACE,0BAAA;AZyjDJ;;AYtjDE;EACE,2BAAA;AZyjDJ;;AY9jDE;EACE,2BAAA;AZikDJ;;AY9jDE;EACE,4BAAA;AZikDJ;;AYtkDE;EACE,2BAAA;AZykDJ;;AYtkDE;EACE,4BAAA;AZykDJ;;AY9kDE;EACE,2BAAA;AZilDJ;;AY9kDE;EACE,4BAAA;AZilDJ;;AYtlDE;EACE,2BAAA;AZylDJ;;AYtlDE;EACE,4BAAA;AZylDJ;;AY9lDE;EACE,2BAAA;AZimDJ;;AY9lDE;EACE,4BAAA;AZimDJ;;AYtmDE;EACE,2BAAA;AZymDJ;;AYtmDE;EACE,4BAAA;AZymDJ;;AY9mDE;EACE,2BAAA;AZinDJ;;AY9mDE;EACE,4BAAA;AZinDJ;;AYtnDE;EACE,2BAAA;AZynDJ;;AYtnDE;EACE,4BAAA;AZynDJ;;AY9nDE;EACE,2BAAA;AZioDJ;;AY9nDE;EACE,4BAAA;AZioDJ;;AYtoDE;EACE,2BAAA;AZyoDJ;;AYtoDE;EACE,4BAAA;AZyoDJ;;AY9oDE;EACE,2BAAA;AZipDJ;;AY9oDE;EACE,4BAAA;AZipDJ;;AYtpDE;EACE,2BAAA;AZypDJ;;AYtpDE;EACE,4BAAA;AZypDJ;;AY9pDE;EACE,2BAAA;AZiqDJ;;AY9pDE;EACE,4BAAA;AZiqDJ;;AYtqDE;EACE,2BAAA;AZyqDJ;;AYtqDE;EACE,4BAAA;AZyqDJ;;AY9qDE;EACE,2BAAA;AZirDJ;;AY9qDE;EACE,4BAAA;AZirDJ;;AYtrDE;EACE,2BAAA;AZyrDJ;;AYtrDE;EACE,4BAAA;AZyrDJ;;AY9rDE;EACE,2BAAA;AZisDJ;;AY9rDE;EACE,4BAAA;AZisDJ;;AYtsDE;EACE,2BAAA;AZysDJ;;AYtsDE;EACE,4BAAA;AZysDJ;;AY9sDE;EACE,2BAAA;AZitDJ;;AY9sDE;EACE,4BAAA;AZitDJ;;AYttDE;EACE,2BAAA;AZytDJ;;AYttDE;EACE,4BAAA;AZytDJ;;AY9tDE;EACE,2BAAA;AZiuDJ;;AY9tDE;EACE,4BAAA;AZiuDJ;;AYtuDE;EACE,2BAAA;AZyuDJ;;AYtuDE;EACE,4BAAA;AZyuDJ;;AY9uDE;EACE,2BAAA;AZivDJ;;AY9uDE;EACE,4BAAA;AZivDJ;;AYtvDE;EACE,2BAAA;AZyvDJ;;AYtvDE;EACE,4BAAA;AZyvDJ;;AY9vDE;EACE,2BAAA;AZiwDJ;;AY9vDE;EACE,4BAAA;AZiwDJ;;AYtwDE;EACE,2BAAA;AZywDJ;;AYtwDE;EACE,4BAAA;AZywDJ;;AY9wDE;EACE,2BAAA;AZixDJ;;AY9wDE;EACE,4BAAA;AZixDJ;;AYtxDE;EACE,2BAAA;AZyxDJ;;AYtxDE;EACE,4BAAA;AZyxDJ;;AY9xDE;EACE,2BAAA;AZiyDJ;;AY9xDE;EACE,4BAAA;AZiyDJ;;AYtyDE;EACE,2BAAA;AZyyDJ;;AYtyDE;EACE,4BAAA;AZyyDJ;;AY9yDE;EACE,2BAAA;AZizDJ;;AY9yDE;EACE,4BAAA;AZizDJ;;AYtzDE;EACE,2BAAA;AZyzDJ;;AYtzDE;EACE,4BAAA;AZyzDJ;;AY9zDE;EACE,2BAAA;AZi0DJ;;AY9zDE;EACE,4BAAA;AZi0DJ;;AYt0DE;EACE,2BAAA;AZy0DJ;;AYt0DE;EACE,4BAAA;AZy0DJ;;AY90DE;EACE,2BAAA;AZi1DJ;;AY90DE;EACE,4BAAA;AZi1DJ;;AYt1DE;EACE,2BAAA;AZy1DJ;;AYt1DE;EACE,4BAAA;AZy1DJ;;AY91DE;EACE,2BAAA;AZi2DJ;;AY91DE;EACE,4BAAA;AZi2DJ;;AYt2DE;EACE,2BAAA;AZy2DJ;;AYt2DE;EACE,4BAAA;AZy2DJ;;AY92DE;EACE,2BAAA;AZi3DJ;;AY92DE;EACE,4BAAA;AZi3DJ;;AYt3DE;EACE,2BAAA;AZy3DJ;;AYt3DE;EACE,4BAAA;AZy3DJ;;AY93DE;EACE,2BAAA;AZi4DJ;;AY93DE;EACE,4BAAA;AZi4DJ;;AYt4DE;EACE,2BAAA;AZy4DJ;;AYt4DE;EACE,4BAAA;AZy4DJ;;AY94DE;EACE,2BAAA;AZi5DJ;;AY94DE;EACE,4BAAA;AZi5DJ;;AYt5DE;EACE,2BAAA;AZy5DJ;;AYt5DE;EACE,4BAAA;AZy5DJ;;AY95DE;EACE,2BAAA;AZi6DJ;;AY95DE;EACE,4BAAA;AZi6DJ;;AYt6DE;EACE,2BAAA;AZy6DJ;;AYt6DE;EACE,4BAAA;AZy6DJ;;AY96DE;EACE,2BAAA;AZi7DJ;;AY96DE;EACE,4BAAA;AZi7DJ;;AYt7DE;EACE,2BAAA;AZy7DJ;;AYt7DE;EACE,4BAAA;AZy7DJ;;AY97DE;EACE,2BAAA;AZi8DJ;;AY97DE;EACE,4BAAA;AZi8DJ;;AYt8DE;EACE,2BAAA;AZy8DJ;;AYt8DE;EACE,4BAAA;AZy8DJ;;AY98DE;EACE,2BAAA;AZi9DJ;;AY98DE;EACE,4BAAA;AZi9DJ;;AYt9DE;EACE,2BAAA;AZy9DJ;;AYt9DE;EACE,4BAAA;AZy9DJ;;AY99DE;EACE,2BAAA;AZi+DJ;;AY99DE;EACE,4BAAA;AZi+DJ;;AYt+DE;EACE,2BAAA;AZy+DJ;;AYt+DE;EACE,4BAAA;AZy+DJ;;AY9+DE;EACE,2BAAA;AZi/DJ;;AY9+DE;EACE,4BAAA;AZi/DJ;;AYt/DE;EACE,2BAAA;AZy/DJ;;AYt/DE;EACE,4BAAA;AZy/DJ;;AY9/DE;EACE,2BAAA;AZigEJ;;AY9/DE;EACE,4BAAA;AZigEJ;;AYtgEE;EACE,2BAAA;AZygEJ;;AYtgEE;EACE,4BAAA;AZygEJ;;AY9gEE;EACE,2BAAA;AZihEJ;;AY9gEE;EACE,4BAAA;AZihEJ;;AYthEE;EACE,2BAAA;AZyhEJ;;AYthEE;EACE,4BAAA;AZyhEJ;;AY9hEE;EACE,2BAAA;AZiiEJ;;AY9hEE;EACE,4BAAA;AZiiEJ;;AYtiEE;EACE,2BAAA;AZyiEJ;;AYtiEE;EACE,4BAAA;AZyiEJ;;AY9iEE;EACE,2BAAA;AZijEJ;;AY9iEE;EACE,4BAAA;AZijEJ;;AYtjEE;EACE,2BAAA;AZyjEJ;;AYtjEE;EACE,4BAAA;AZyjEJ;;AY9jEE;EACE,2BAAA;AZikEJ;;AY9jEE;EACE,4BAAA;AZikEJ;;AYtkEE;EACE,2BAAA;AZykEJ;;AYtkEE;EACE,4BAAA;AZykEJ;;AY9kEE;EACE,2BAAA;AZilEJ;;AY9kEE;EACE,4BAAA;AZilEJ;;AYtlEE;EACE,2BAAA;AZylEJ;;AYtlEE;EACE,4BAAA;AZylEJ;;AY9lEE;EACE,2BAAA;AZimEJ;;AY9lEE;EACE,4BAAA;AZimEJ;;AYtmEE;EACE,2BAAA;AZymEJ;;AYtmEE;EACE,4BAAA;AZymEJ;;AY9mEE;EACE,2BAAA;AZinEJ;;AY9mEE;EACE,4BAAA;AZinEJ;;AYtnEE;EACE,2BAAA;AZynEJ;;AYtnEE;EACE,4BAAA;AZynEJ;;AY9nEE;EACE,2BAAA;AZioEJ;;AY9nEE;EACE,4BAAA;AZioEJ;;AYtoEE;EACE,2BAAA;AZyoEJ;;AYtoEE;EACE,4BAAA;AZyoEJ;;AY9oEE;EACE,2BAAA;AZipEJ;;AY9oEE;EACE,4BAAA;AZipEJ;;AYtpEE;EACE,2BAAA;AZypEJ;;AYtpEE;EACE,4BAAA;AZypEJ;;AY9pEE;EACE,2BAAA;AZiqEJ;;AY9pEE;EACE,4BAAA;AZiqEJ;;AYtqEE;EACE,2BAAA;AZyqEJ;;AYtqEE;EACE,4BAAA;AZyqEJ;;AY9qEE;EACE,2BAAA;AZirEJ;;AY9qEE;EACE,4BAAA;AZirEJ;;AYtrEE;EACE,2BAAA;AZyrEJ;;AYtrEE;EACE,4BAAA;AZyrEJ;;AY9rEE;EACE,2BAAA;AZisEJ;;AY9rEE;EACE,4BAAA;AZisEJ;;AYtsEE;EACE,2BAAA;AZysEJ;;AYtsEE;EACE,4BAAA;AZysEJ;;AY9sEE;EACE,2BAAA;AZitEJ;;AY9sEE;EACE,4BAAA;AZitEJ;;AYttEE;EACE,2BAAA;AZytEJ;;AYttEE;EACE,4BAAA;AZytEJ;;AY9tEE;EACE,2BAAA;AZiuEJ;;AY9tEE;EACE,4BAAA;AZiuEJ;;AYtuEE;EACE,2BAAA;AZyuEJ;;AYtuEE;EACE,4BAAA;AZyuEJ;;AY9uEE;EACE,2BAAA;AZivEJ;;AY9uEE;EACE,4BAAA;AZivEJ;;AYtvEE;EACE,2BAAA;AZyvEJ;;AYtvEE;EACE,4BAAA;AZyvEJ;;AY9vEE;EACE,2BAAA;AZiwEJ;;AY9vEE;EACE,4BAAA;AZiwEJ;;AYtwEE;EACE,2BAAA;AZywEJ;;AYtwEE;EACE,4BAAA;AZywEJ;;AY9wEE;EACE,4BAAA;AZixEJ;;AY9wEE;EACE,6BAAA;AZixEJ;;AY5wEA,qBAAA;AAGI;EADF;IAEI,sBAAA;EZ8wEJ;AACF;;AYzwEI;EADF;IAEI,uBAAA;EZ6wEJ;AACF;;AYxwEI;EADF;IAEI,4BAAA;EZ4wEJ;AACF;;AYxwEI;EADF;IAEI,8BAAA;EZ4wEJ;AACF;;AYxwEI;EADF;IAEI,6BAAA;EZ4wEJ;AACF;;AYxwEI;EADF;IAEI,2BAAA;EZ4wEJ;AACF;;AYxwEI;EADF;IAEI,8BAAA;EZ4wEJ;AACF;;AYxwEI;EADF;IAEI,6BAAA;EZ4wEJ;AACF;;AY1zEI;EADF;IAEI,uBAAA;EZ8zEJ;AACF;;AYzzEI;EADF;IAEI,uBAAA;EZ6zEJ;AACF;;AYxzEI;EADF;IAEI,4BAAA;EZ4zEJ;AACF;;AYxzEI;EADF;IAEI,8BAAA;EZ4zEJ;AACF;;AYxzEI;EADF;IAEI,6BAAA;EZ4zEJ;AACF;;AYxzEI;EADF;IAEI,2BAAA;EZ4zEJ;AACF;;AYxzEI;EADF;IAEI,8BAAA;EZ4zEJ;AACF;;AYxzEI;EADF;IAEI,6BAAA;EZ4zEJ;AACF;;AY12EI;EADF;IAEI,uBAAA;EZ82EJ;AACF;;AYz2EI;EADF;IAEI,uBAAA;EZ62EJ;AACF;;AYx2EI;EADF;IAEI,4BAAA;EZ42EJ;AACF;;AYx2EI;EADF;IAEI,8BAAA;EZ42EJ;AACF;;AYx2EI;EADF;IAEI,6BAAA;EZ42EJ;AACF;;AYx2EI;EADF;IAEI,2BAAA;EZ42EJ;AACF;;AYx2EI;EADF;IAEI,8BAAA;EZ42EJ;AACF;;AYx2EI;EADF;IAEI,6BAAA;EZ42EJ;AACF;;AY15EI;EADF;IAEI,uBAAA;EZ85EJ;AACF;;AYz5EI;EADF;IAEI,uBAAA;EZ65EJ;AACF;;AYx5EI;EADF;IAEI,4BAAA;EZ45EJ;AACF;;AYx5EI;EADF;IAEI,8BAAA;EZ45EJ;AACF;;AYx5EI;EADF;IAEI,6BAAA;EZ45EJ;AACF;;AYx5EI;EADF;IAEI,2BAAA;EZ45EJ;AACF;;AYx5EI;EADF;IAEI,8BAAA;EZ45EJ;AACF;;AYx5EI;EADF;IAEI,6BAAA;EZ45EJ;AACF;;AY18EI;EADF;IAEI,uBAAA;EZ88EJ;AACF;;AYz8EI;EADF;IAEI,uBAAA;EZ68EJ;AACF;;AYx8EI;EADF;IAEI,4BAAA;EZ48EJ;AACF;;AYx8EI;EADF;IAEI,8BAAA;EZ48EJ;AACF;;AYx8EI;EADF;IAEI,6BAAA;EZ48EJ;AACF;;AYx8EI;EADF;IAEI,2BAAA;EZ48EJ;AACF;;AYx8EI;EADF;IAEI,8BAAA;EZ48EJ;AACF;;AYx8EI;EADF;IAEI,6BAAA;EZ48EJ;AACF;;AY1/EI;EADF;IAEI,uBAAA;EZ8/EJ;AACF;;AYz/EI;EADF;IAEI,uBAAA;EZ6/EJ;AACF;;AYx/EI;EADF;IAEI,4BAAA;EZ4/EJ;AACF;;AYx/EI;EADF;IAEI,8BAAA;EZ4/EJ;AACF;;AYx/EI;EADF;IAEI,6BAAA;EZ4/EJ;AACF;;AYx/EI;EADF;IAEI,2BAAA;EZ4/EJ;AACF;;AYx/EI;EADF;IAEI,8BAAA;EZ4/EJ;AACF;;AYx/EI;EADF;IAEI,6BAAA;EZ4/EJ;AACF;;AY1iFI;EADF;IAEI,uBAAA;EZ8iFJ;AACF;;AYziFI;EADF;IAEI,uBAAA;EZ6iFJ;AACF;;AYxiFI;EADF;IAEI,4BAAA;EZ4iFJ;AACF;;AYxiFI;EADF;IAEI,8BAAA;EZ4iFJ;AACF;;AYxiFI;EADF;IAEI,6BAAA;EZ4iFJ;AACF;;AYxiFI;EADF;IAEI,2BAAA;EZ4iFJ;AACF;;AYxiFI;EADF;IAEI,8BAAA;EZ4iFJ;AACF;;AYxiFI;EADF;IAEI,6BAAA;EZ4iFJ;AACF;;AY1lFI;EADF;IAEI,uBAAA;EZ8lFJ;AACF;;AYzlFI;EADF;IAEI,uBAAA;EZ6lFJ;AACF;;AYxlFI;EADF;IAEI,4BAAA;EZ4lFJ;AACF;;AYxlFI;EADF;IAEI,8BAAA;EZ4lFJ;AACF;;AYxlFI;EADF;IAEI,6BAAA;EZ4lFJ;AACF;;AYxlFI;EADF;IAEI,2BAAA;EZ4lFJ;AACF;;AYxlFI;EADF;IAEI,8BAAA;EZ4lFJ;AACF;;AYxlFI;EADF;IAEI,6BAAA;EZ4lFJ;AACF;;AY1oFI;EADF;IAEI,uBAAA;EZ8oFJ;AACF;;AYzoFI;EADF;IAEI,uBAAA;EZ6oFJ;AACF;;AYxoFI;EADF;IAEI,4BAAA;EZ4oFJ;AACF;;AYxoFI;EADF;IAEI,8BAAA;EZ4oFJ;AACF;;AYxoFI;EADF;IAEI,6BAAA;EZ4oFJ;AACF;;AYxoFI;EADF;IAEI,2BAAA;EZ4oFJ;AACF;;AYxoFI;EADF;IAEI,8BAAA;EZ4oFJ;AACF;;AYxoFI;EADF;IAEI,6BAAA;EZ4oFJ;AACF;;AY1rFI;EADF;IAEI,uBAAA;EZ8rFJ;AACF;;AYzrFI;EADF;IAEI,uBAAA;EZ6rFJ;AACF;;AYxrFI;EADF;IAEI,4BAAA;EZ4rFJ;AACF;;AYxrFI;EADF;IAEI,8BAAA;EZ4rFJ;AACF;;AYxrFI;EADF;IAEI,6BAAA;EZ4rFJ;AACF;;AYxrFI;EADF;IAEI,2BAAA;EZ4rFJ;AACF;;AYxrFI;EADF;IAEI,8BAAA;EZ4rFJ;AACF;;AYxrFI;EADF;IAEI,6BAAA;EZ4rFJ;AACF;;AY1uFI;EADF;IAEI,wBAAA;EZ8uFJ;AACF;;AYzuFI;EADF;IAEI,wBAAA;EZ6uFJ;AACF;;AYxuFI;EADF;IAEI,6BAAA;EZ4uFJ;AACF;;AYxuFI;EADF;IAEI,+BAAA;EZ4uFJ;AACF;;AYxuFI;EADF;IAEI,8BAAA;EZ4uFJ;AACF;;AYxuFI;EADF;IAEI,4BAAA;EZ4uFJ;AACF;;AYxuFI;EADF;IAEI,+BAAA;EZ4uFJ;AACF;;AYxuFI;EADF;IAEI,8BAAA;EZ4uFJ;AACF;;AYruFE;EACE,kBAAA;EACA,qBAAA;AZwuFJ;;AYruFE;EACE,kBAAA;EACA,qBAAA;AZwuFJ;;AY/uFE;EACE,kBAAA;EACA,qBAAA;AZkvFJ;;AY/uFE;EACE,kBAAA;EACA,sBAAA;AZkvFJ;;AYzvFE;EACE,kBAAA;EACA,qBAAA;AZ4vFJ;;AYzvFE;EACE,kBAAA;EACA,sBAAA;AZ4vFJ;;AYnwFE;EACE,kBAAA;EACA,qBAAA;AZswFJ;;AYnwFE;EACE,kBAAA;EACA,sBAAA;AZswFJ;;AYjwFE;EACE,wBAAA;AZowFJ;;AYjwFE;EACE,6BAAA;AZowFJ;;AYjwFE;EACE,+BAAA;AZowFJ;;AYjwFE;EACE,8BAAA;AZowFJ;;AYjwFE;EACE,4BAAA;AZowFJ;;AYjwFE;EACE,+BAAA;AZowFJ;;AYjwFE;EACE,8BAAA;AZowFJ;;AY7xFE;EACE,wBAAA;AZgyFJ;;AY7xFE;EACE,6BAAA;AZgyFJ;;AY7xFE;EACE,+BAAA;AZgyFJ;;AY7xFE;EACE,8BAAA;AZgyFJ;;AY7xFE;EACE,4BAAA;AZgyFJ;;AY7xFE;EACE,+BAAA;AZgyFJ;;AY7xFE;EACE,8BAAA;AZgyFJ;;AYzzFE;EACE,wBAAA;AZ4zFJ;;AYzzFE;EACE,6BAAA;AZ4zFJ;;AYzzFE;EACE,+BAAA;AZ4zFJ;;AYzzFE;EACE,8BAAA;AZ4zFJ;;AYzzFE;EACE,4BAAA;AZ4zFJ;;AYzzFE;EACE,+BAAA;AZ4zFJ;;AYzzFE;EACE,8BAAA;AZ4zFJ;;AYr1FE;EACE,wBAAA;AZw1FJ;;AYr1FE;EACE,6BAAA;AZw1FJ;;AYr1FE;EACE,+BAAA;AZw1FJ;;AYr1FE;EACE,8BAAA;AZw1FJ;;AYr1FE;EACE,4BAAA;AZw1FJ;;AYr1FE;EACE,+BAAA;AZw1FJ;;AYr1FE;EACE,8BAAA;AZw1FJ;;AYj3FE;EACE,wBAAA;AZo3FJ;;AYj3FE;EACE,6BAAA;AZo3FJ;;AYj3FE;EACE,+BAAA;AZo3FJ;;AYj3FE;EACE,8BAAA;AZo3FJ;;AYj3FE;EACE,4BAAA;AZo3FJ;;AYj3FE;EACE,+BAAA;AZo3FJ;;AYj3FE;EACE,8BAAA;AZo3FJ;;AYh3FA;EACE,kBAAA;AZm3FF;;AYh3FA;EACE,sBAAA;AZm3FF;;AYh3FA;EACE,2BAAA;AZm3FF;;AYh3FA;EACE,4BAAA;AZm3FF;;AYh3FA;EACE,6BAAA;AZm3FF;;AY72FE;EACE,oBAAA;AZg3FJ;;AY52FI;EADF;IAEI,oBAAA;EZg3FJ;AACF;;AYv3FE;EACE,oBAAA;AZ03FJ;;AYt3FI;EADF;IAEI,oBAAA;EZ03FJ;AACF;;AYj4FE;EACE,qBAAA;AZo4FJ;;AYh4FI;EADF;IAEI,qBAAA;EZo4FJ;AACF;;AY34FE;EACE,qBAAA;AZ84FJ;;AY14FI;EADF;IAEI,qBAAA;EZ84FJ;AACF;;AYr5FE;EACE,qBAAA;AZw5FJ;;AYp5FI;EADF;IAEI,qBAAA;EZw5FJ;AACF;;AY/5FE;EACE,qBAAA;AZk6FJ;;AY95FI;EADF;IAEI,qBAAA;EZk6FJ;AACF;;AYz6FE;EACE,qBAAA;AZ46FJ;;AYx6FI;EADF;IAEI,qBAAA;EZ46FJ;AACF;;AYn7FE;EACE,qBAAA;AZs7FJ;;AYl7FI;EADF;IAEI,qBAAA;EZs7FJ;AACF;;AY77FE;EACE,qBAAA;AZg8FJ;;AY57FI;EADF;IAEI,qBAAA;EZg8FJ;AACF;;AYv8FE;EACE,qBAAA;AZ08FJ;;AYt8FI;EADF;IAEI,qBAAA;EZ08FJ;AACF;;AYj9FE;EACE,qBAAA;AZo9FJ;;AYh9FI;EADF;IAEI,qBAAA;EZo9FJ;AACF;;AY39FE;EACE,qBAAA;AZ89FJ;;AY19FI;EADF;IAEI,qBAAA;EZ89FJ;AACF;;AYr+FE;EACE,qBAAA;AZw+FJ;;AYp+FI;EADF;IAEI,qBAAA;EZw+FJ;AACF;;AY/+FE;EACE,qBAAA;AZk/FJ;;AY9+FI;EADF;IAEI,qBAAA;EZk/FJ;AACF;;AYz/FE;EACE,qBAAA;AZ4/FJ;;AYx/FI;EADF;IAEI,qBAAA;EZ4/FJ;AACF;;AYngGE;EACE,qBAAA;AZsgGJ;;AYlgGI;EADF;IAEI,qBAAA;EZsgGJ;AACF;;AY7gGE;EACE,qBAAA;AZghGJ;;AY5gGI;EADF;IAEI,qBAAA;EZghGJ;AACF;;AYvhGE;EACE,qBAAA;AZ0hGJ;;AYthGI;EADF;IAEI,qBAAA;EZ0hGJ;AACF;;AYjiGE;EACE,qBAAA;AZoiGJ;;AYhiGI;EADF;IAEI,qBAAA;EZoiGJ;AACF;;AY3iGE;EACE,qBAAA;AZ8iGJ;;AY1iGI;EADF;IAEI,qBAAA;EZ8iGJ;AACF;;AYrjGE;EACE,sBAAA;AZwjGJ;;AYpjGI;EADF;IAEI,sBAAA;EZwjGJ;AACF;;AYpjGA;EACE,yBAAA;AZujGF;;AYpjGA;EACE,6BAAA;AZujGF;;AYnjGA;EACE,wBAAA;AZsjGF;;AYnjGA;EACE,6BAAA;AZsjGF;;AYnjGA;EACE,8BAAA;AZsjGF;;AYnjGA;EACE,6BAAA;AZsjGF;;AYnjGA;EACE,8BAAA;AZsjGF;;AYnjGA;EACE,kBAAA;EACA,6BAAA;AZsjGF;;AYnjGA;EACE,gBAAA;AZsjGF;;AYnjGA;EACE,iBAAA;AZsjGF;;AYnjGA;EACE,gBAAA;EACA,mBAAA;EACA,6BAAA;AZsjGF;;AYnjGA;EACE,4BAAA;AZsjGF;;AYnjGA;EACE,4BAAA;EACA,sBAAA;AZsjGF;;AYnjGA;EACE,wBAAA;AZsjGF;;AYnjGA;EACE,kCAAA;AZsjGF;;AYnjGA;EACE,wCAAA;AZsjGF;;AYljGA;EACE,yCAAA;AZqjGF;;AYljGA;EACE,6BAAA;AZqjGF;;AYljGA;EACE,8BAAA;AZqjGF;;AYljGA;EACE,gCAAA;AZqjGF;;AYljGA;EACE,wBAAA;EACA,kCAAA;AZqjGF;;AYljGA;EACE,aAAA;EACA,iCAAA;AZqjGF;;AYljGA;EACE,aAAA;EACA,8BAAA;AZqjGF;;AYljGA;EACE,kBAAA;AZqjGF;;AYljGA;EACE,wBAAA;EACA,iCAAA;EACA,kCAAA;EACA,8BAAA;AZqjGF;;AYljGA;EACE,mCAAA;AZqjGF;;AYljGA;EACE,kBAAA;AZqjGF;;AYjjGA;EACE,4BAAA;EACA,qBAAA;EACA,cAAA;EACA,0BAAA;AZojGF;;AYjjGA;EACE,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,mCAAA;AZojGF;AYljGE;EACE,gBAAA;EACA,iBAAA;AZojGJ;AYjjGE;EACE,0CAAA;AZmjGJ;;AY/iGA;EACE,aAAA;EACA,mBAAA;AZkjGF;;AY/iGA;EACE,yCAAA;AZkjGF;;AY/iGA;EACE,0CAAA;AZkjGF;;AY/iGA;EACE,yCAAA;AZkjGF;;AY/iGA;EACE,wCAAA;AZkjGF;;AY/iGA;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,0CAAA;EACA,aAAA;EACA,kBAAA;AZkjGF;;AY/iGA;EACE;IACE,wBAAA;EZkjGF;AACF;AY/iGA;EACE,sCAAA;AZijGF;;Aat5GA;EAhCE,4BAiCsC;EAhCtC,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,8BA2Ba;EA1Bb,gBAAA;EACA,4BAAA;Ab07GF;Aax7GE;EACE,8BAsBW;EArBX,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,aAAA;EACA,kBAAA;Ab07GJ;Aav7GE;EACE,4BAWsD;Ab86G1D;Aat7GE;EAGE,sBAAA;Abs7GJ;Aal7GA;EAEE,gBAAA;EACA,gBAAA;Abm7GF;;Aah7GA;EAtCE,2BAuCsC;EAtCtC,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,8BAiCa;EAhCb,gBAAA;EACA,4BAAA;Ab09GF;Aax9GE;EACE,8BA4BW;EA3BX,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,aAAA;EACA,kBAAA;Ab09GJ;Aav9GE;EACE,2BAiBqD;Abw8GzD;Aat9GE;EAGE,sBAAA;Abs9GJ;Aa58GA;EAEE,eAAA;EACA,mBAAA;EACA,4BAAA;Ab68GF;;Aa18GA;EA7CE,mCA8CyC;EA7CzC,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iCAwCa;EAvCb,gBAAA;EACA,4BAAA;Ab2/GF;Aaz/GE;EACE,iCAmCW;EAlCX,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,aAAA;EACA,kBAAA;Ab2/GJ;Aax/GE;EACE,mBAwBgE;Abk+GpE;Aav/GE;EAGE,sBAAA;Abu/GJ;Aat+GA;EAEE,eAAA;EACA,mBAAA;EACA,4BAAA;EACA,iCAAA;Abu+GF;;Aap+GA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,kCAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;EAEA,oBAAA;Abu+GF;Aar+GE;EACE,8BAAA;EACA,oBAAA;EACA,kCAAA;EACA,uBAAA;Abu+GJ;Aap+GE;EAGE,sBAAA;Abo+GJ;;Aap8GA;EA3BE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAwBgB;EAvBhB,iCAuB8B;EAtB9B,YAAA;EACA,WAAA;EACA,6BAAA;EAEA,oBAAA;Abm+GF;Aaj+GE;EACE,8BAec;EAdd,oBAAA;EACA,iCAAA;EACA,sBAY4B;Abu9GhC;Aah+GE;EAGE,sBAAA;Abg+GJ;;Aav9GA;EA/BE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mBA4BgB;EA3BhB,yCA2B8B;EA1B9B,YAAA;EACA,WAAA;EACA,6BAAA;EAEA,oBAAA;Ab0/GF;Aax/GE;EACE,8BAmBc;EAlBd,oBAAA;EACA,yCAAA;EACA,8BAgB4B;Ab0+GhC;Aav/GE;EAGE,sBAAA;Abu/GJ;;Aaz+GE;EACE,wBAAA;Ab4+GJ","sourcesContent":["@charset \"UTF-8\";\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n.rbc-btn {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\n\nbutton.rbc-btn {\n  overflow: visible;\n  text-transform: none;\n  appearance: button;\n  cursor: pointer;\n}\n\nbutton[disabled].rbc-btn {\n  cursor: not-allowed;\n}\n\nbutton.rbc-input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n.rbc-calendar {\n  box-sizing: border-box;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.rbc-m-b-negative-3 {\n  margin-bottom: -3px;\n}\n\n.rbc-h-full {\n  height: 100%;\n}\n\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n  box-sizing: inherit;\n}\n\n.rbc-abs-full, .rbc-row-bg {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.rbc-ellipsis, .rbc-show-more, .rbc-row-segment .rbc-event-content, .rbc-event-label {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rbc-rtl {\n  direction: rtl;\n}\n\n.rbc-off-range {\n  color: #999999;\n}\n\n.rbc-off-range-bg {\n  background: rgb(229.5, 229.5, 229.5);\n}\n\n.rbc-header {\n  overflow: hidden;\n  flex: 1 0 0%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 3px;\n  text-align: center;\n  vertical-align: middle;\n  font-weight: bold;\n  font-size: 90%;\n  min-height: 0;\n  border-bottom: 1px solid #ddd;\n}\n.rbc-header + .rbc-header {\n  border-left: 1px solid #ddd;\n}\n.rbc-rtl .rbc-header + .rbc-header {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n.rbc-header > a, .rbc-header > a:active, .rbc-header > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n\n.rbc-button-link {\n  color: inherit;\n  background: none;\n  margin: 0;\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  user-select: text;\n}\n\n.rbc-row-content {\n  position: relative;\n  user-select: none;\n  -webkit-user-select: none;\n  z-index: 4;\n}\n\n.rbc-row-content-scrollable {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.rbc-row-content-scrollable .rbc-row-content-scroll-container {\n  height: 100%;\n  overflow-y: scroll;\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n  /* Hide scrollbar for Chrome, Safari and Opera */\n}\n.rbc-row-content-scrollable .rbc-row-content-scroll-container::-webkit-scrollbar {\n  display: none;\n}\n\n.rbc-today {\n  background-color: #eaf6ff;\n}\n\n.rbc-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n.rbc-toolbar .rbc-toolbar-label {\n  flex-grow: 1;\n  padding: 0 10px;\n  text-align: center;\n}\n.rbc-toolbar button {\n  color: #373a3c;\n  display: inline-block;\n  margin: 0;\n  text-align: center;\n  vertical-align: middle;\n  background: none;\n  background-image: none;\n  border: 1px solid #ccc;\n  padding: 0.375rem 1rem;\n  border-radius: 4px;\n  line-height: normal;\n  white-space: nowrap;\n}\n.rbc-toolbar button:active, .rbc-toolbar button.rbc-active {\n  background-image: none;\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  background-color: rgb(229.5, 229.5, 229.5);\n  border-color: rgb(173.4, 173.4, 173.4);\n}\n.rbc-toolbar button:active:hover, .rbc-toolbar button:active:focus, .rbc-toolbar button.rbc-active:hover, .rbc-toolbar button.rbc-active:focus {\n  color: #373a3c;\n  background-color: rgb(211.65, 211.65, 211.65);\n  border-color: rgb(140.25, 140.25, 140.25);\n}\n.rbc-toolbar button:focus {\n  color: #373a3c;\n  background-color: rgb(229.5, 229.5, 229.5);\n  border-color: rgb(173.4, 173.4, 173.4);\n}\n.rbc-toolbar button:hover {\n  color: #373a3c;\n  cursor: pointer;\n  background-color: rgb(229.5, 229.5, 229.5);\n  border-color: rgb(173.4, 173.4, 173.4);\n}\n\n.rbc-btn-group {\n  display: inline-block;\n  white-space: nowrap;\n}\n.rbc-btn-group > button:first-child:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-btn-group > button:last-child:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {\n  border-radius: 4px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {\n  border-radius: 4px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-btn-group > button:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.rbc-btn-group button + button {\n  margin-left: -1px;\n}\n.rbc-rtl .rbc-btn-group button + button {\n  margin-left: 0;\n  margin-right: -1px;\n}\n.rbc-btn-group + .rbc-btn-group, .rbc-btn-group + button {\n  margin-left: 10px;\n}\n\n@media (max-width: 767px) {\n  .rbc-toolbar {\n    flex-direction: column;\n  }\n}\n.rbc-event, .rbc-day-slot .rbc-background-event {\n  border: none;\n  box-sizing: border-box;\n  box-shadow: none;\n  margin: 0;\n  padding: 2px 5px;\n  background-color: #3174ad;\n  border-radius: 5px;\n  color: #fff;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n}\n.rbc-slot-selecting .rbc-event, .rbc-slot-selecting .rbc-day-slot .rbc-background-event, .rbc-day-slot .rbc-slot-selecting .rbc-background-event {\n  cursor: inherit;\n  pointer-events: none;\n}\n.rbc-event.rbc-selected, .rbc-day-slot .rbc-selected.rbc-background-event {\n  background-color: rgb(37.7432432432, 89.3513513514, 133.2567567568);\n}\n.rbc-event:focus, .rbc-day-slot .rbc-background-event:focus {\n  outline: 5px auto #3b99fc;\n}\n\n.rbc-event-label {\n  font-size: 80%;\n}\n\n.rbc-event-overlaps {\n  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n}\n\n.rbc-event-continues-prior {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.rbc-event-continues-after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rbc-event-continues-earlier {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.rbc-event-continues-later {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rbc-row {\n  display: flex;\n  flex-direction: row;\n}\n\n.rbc-row-segment {\n  padding: 0 1px 1px 1px;\n}\n.rbc-selected-cell {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.rbc-show-more {\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 4;\n  font-weight: bold;\n  font-size: 85%;\n  height: auto;\n  line-height: normal;\n  color: #3174ad;\n}\n.rbc-show-more:hover, .rbc-show-more:focus {\n  color: rgb(37.7432432432, 89.3513513514, 133.2567567568);\n}\n\n.rbc-month-view {\n  position: relative;\n  border: 1px solid #ddd;\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  width: 100%;\n  user-select: none;\n  -webkit-user-select: none;\n  height: 100%;\n}\n\n.rbc-month-header {\n  display: flex;\n  flex-direction: row;\n}\n\n.rbc-month-row {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  flex: 1 0 0;\n  flex-basis: 0px;\n  overflow: hidden;\n  height: 100%;\n}\n.rbc-month-row + .rbc-month-row {\n  border-top: 1px solid #ddd;\n}\n\n.rbc-date-cell {\n  flex: 1 1 0;\n  min-width: 0;\n  padding-right: 5px;\n  text-align: right;\n}\n.rbc-date-cell.rbc-now {\n  font-weight: bold;\n}\n.rbc-date-cell > a, .rbc-date-cell > a:active, .rbc-date-cell > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n\n.rbc-row-bg {\n  display: flex;\n  flex-direction: row;\n  flex: 1 0 0;\n  overflow: hidden;\n  right: 1px;\n}\n\n.rbc-day-bg {\n  flex: 1 0 0%;\n}\n.rbc-day-bg + .rbc-day-bg {\n  border-left: 1px solid #ddd;\n}\n.rbc-rtl .rbc-day-bg + .rbc-day-bg {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n\n.rbc-overlay {\n  position: absolute;\n  z-index: 5;\n  border: 1px solid #e5e5e5;\n  background-color: #fff;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  padding: 10px;\n}\n.rbc-overlay > * + * {\n  margin-top: 1px;\n}\n\n.rbc-overlay-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: -10px -10px 5px -10px;\n  padding: 2px 10px;\n}\n\n.rbc-agenda-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  overflow: auto;\n}\n.rbc-agenda-view table.rbc-agenda-table {\n  width: 100%;\n  border: 1px solid #ddd;\n  border-spacing: 0;\n  border-collapse: collapse;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n  padding: 5px 10px;\n  vertical-align: top;\n}\n.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {\n  padding-left: 15px;\n  padding-right: 15px;\n  text-transform: lowercase;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left: 1px solid #ddd;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {\n  border-top: 1px solid #ddd;\n}\n.rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  padding: 3px 5px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  text-align: right;\n}\n\n.rbc-agenda-time-cell {\n  text-transform: lowercase;\n}\n.rbc-agenda-time-cell .rbc-continues-after:after {\n  content: \" »\";\n}\n.rbc-agenda-time-cell .rbc-continues-prior:before {\n  content: \"« \";\n}\n\n.rbc-agenda-date-cell,\n.rbc-agenda-time-cell {\n  white-space: nowrap;\n}\n\n.rbc-agenda-event-cell {\n  width: 100%;\n}\n\n.rbc-time-column {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n}\n.rbc-time-column .rbc-timeslot-group {\n  flex: 1;\n}\n\n.rbc-timeslot-group {\n  border-bottom: 1px solid #ddd;\n  min-height: 40px;\n  display: flex;\n  flex-flow: column nowrap;\n}\n\n.rbc-time-gutter,\n.rbc-header-gutter {\n  flex: none;\n}\n\n.rbc-label {\n  padding: 0 5px;\n}\n\n.rbc-day-slot {\n  position: relative;\n}\n.rbc-day-slot .rbc-events-container {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  margin-right: 10px;\n  top: 0;\n}\n.rbc-day-slot .rbc-events-container.rbc-rtl {\n  left: 10px;\n  right: 0;\n}\n.rbc-day-slot .rbc-event, .rbc-day-slot .rbc-background-event {\n  border: 1px solid rgb(37.7432432432, 89.3513513514, 133.2567567568);\n  display: flex;\n  max-height: 100%;\n  min-height: 20px;\n  flex-flow: column wrap;\n  align-items: flex-start;\n  overflow: hidden;\n  position: absolute;\n}\n.rbc-day-slot .rbc-background-event {\n  opacity: 0.75;\n}\n.rbc-day-slot .rbc-event-label {\n  flex: none;\n  padding-right: 5px;\n  width: auto;\n}\n.rbc-day-slot .rbc-event-content {\n  width: 100%;\n  flex: 1 1 0;\n  word-wrap: break-word;\n  line-height: 1;\n  height: 100%;\n  min-height: 1em;\n}\n.rbc-day-slot .rbc-time-slot {\n  border-top: 1px solid rgb(246.5, 246.5, 246.5);\n}\n\n.rbc-time-view-resources .rbc-time-gutter,\n.rbc-time-view-resources .rbc-time-header-gutter {\n  position: sticky;\n  left: 0;\n  background-color: white;\n  border-right: 1px solid #ddd;\n  z-index: 10;\n  margin-right: -1px;\n}\n.rbc-time-view-resources .rbc-time-header {\n  overflow: hidden;\n}\n.rbc-time-view-resources .rbc-time-header-content {\n  min-width: auto;\n  flex: 1 0 0;\n  flex-basis: 0px;\n}\n.rbc-time-view-resources .rbc-time-header-cell-single-day {\n  display: none;\n}\n.rbc-time-view-resources .rbc-day-slot {\n  min-width: 140px;\n}\n.rbc-time-view-resources .rbc-header,\n.rbc-time-view-resources .rbc-day-bg {\n  width: 140px;\n  flex: 1 1 0;\n  flex-basis: 0 px;\n}\n\n.rbc-time-header-content + .rbc-time-header-content {\n  margin-left: -1px;\n}\n\n.rbc-time-slot {\n  flex: 1 0 0;\n}\n.rbc-time-slot.rbc-now {\n  font-weight: bold;\n}\n\n.rbc-day-header {\n  text-align: center;\n}\n\n.rbc-slot-selection {\n  z-index: 10;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  font-size: 75%;\n  width: 100%;\n  padding: 3px;\n}\n\n.rbc-slot-selecting {\n  cursor: move;\n}\n\n.rbc-time-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  border: 1px solid #ddd;\n  min-height: 0;\n}\n.rbc-time-view .rbc-time-gutter {\n  white-space: nowrap;\n  text-align: right;\n}\n.rbc-time-view .rbc-allday-cell {\n  box-sizing: content-box;\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.rbc-time-view .rbc-allday-cell + .rbc-allday-cell {\n  border-left: 1px solid #ddd;\n}\n.rbc-time-view .rbc-allday-events {\n  position: relative;\n  z-index: 4;\n}\n.rbc-time-view .rbc-row {\n  box-sizing: border-box;\n  min-height: 20px;\n}\n\n.rbc-time-header {\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: row;\n}\n.rbc-time-header.rbc-overflowing {\n  border-right: 1px solid #ddd;\n}\n.rbc-rtl .rbc-time-header.rbc-overflowing {\n  border-right-width: 0;\n  border-left: 1px solid #ddd;\n}\n.rbc-time-header > .rbc-row:first-child {\n  border-bottom: 1px solid #ddd;\n}\n.rbc-time-header > .rbc-row.rbc-row-resource {\n  border-bottom: 1px solid #ddd;\n}\n\n.rbc-time-header-cell-single-day {\n  display: none;\n}\n\n.rbc-time-header-content {\n  flex: 1;\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  border-left: 1px solid #ddd;\n}\n.rbc-rtl .rbc-time-header-content {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n.rbc-time-header-content > .rbc-row.rbc-row-resource {\n  border-bottom: 1px solid #ddd;\n  flex-shrink: 0;\n}\n\n.rbc-time-content {\n  display: flex;\n  flex: 1 0 0%;\n  align-items: flex-start;\n  width: 100%;\n  border-top: 2px solid #ddd;\n  overflow-y: auto;\n  position: relative;\n}\n.rbc-time-content > .rbc-time-gutter {\n  flex: none;\n}\n.rbc-time-content > * + * > * {\n  border-left: 1px solid #ddd;\n}\n.rbc-rtl .rbc-time-content > * + * > * {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n.rbc-time-content > .rbc-day-slot {\n  width: 100%;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.rbc-current-time-indicator {\n  position: absolute;\n  z-index: 3;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background-color: #74ad31;\n  pointer-events: none;\n}\n\n.rbc-resource-grouping.rbc-time-header-content {\n  display: flex;\n  flex-direction: column;\n}\n.rbc-resource-grouping .rbc-row .rbc-header {\n  width: 141px;\n}\n\n* {\n  font-family: \"Inter\", sans-serif;\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n#root {\n  width: 100%;\n}\n#root ul {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n#root p {\n  line-height: 1.8rem;\n}\n#root p,\n#root h1,\n#root h2,\n#root h3 {\n  margin: 0;\n}\n#root button {\n  cursor: pointer;\n}\n#root a {\n  cursor: pointer;\n  text-decoration: none;\n}\n\n*::marker {\n  color: var(--orange-800) !important;\n  width: 25px;\n  height: 25px;\n  place-content: center;\n  place-items: center;\n  font-size: 1.3rem;\n}\n\n:root {\n  --green: #00a65a;\n  --green-dark: #398439;\n  --green-hover: #008d4c;\n  --blue: #3c8dbc;\n  --blue-dark: #204d74;\n  --blue-light: #ecf0f5;\n  --blue-hover: #367fa9;\n  --red: #dd4b39;\n  --red-dark: #d73925;\n  --red-hover: #d73925;\n  --black: #333333;\n  --black-hover: #999999;\n  --grey: #d2d6de;\n  --grey-dark: #444;\n  --grey-badge: #b5bbc8;\n  --orange: #f0ad4e;\n  --orange-dark: #eea236;\n  --orange-hover: #d58512;\n  --yellow: #f39c12;\n  --yellow-dark: #db8b0b;\n  --yellow-hover: rgb(216, 140, 32);\n  --ligthblue: #00c0ef;\n  --ligthblue-dark: #00acd6;\n  --ligthblue-hover: #269abc;\n  --cyan: #00c0ef;\n  --cyan-hover: #00acd6;\n  --dark-blue: #337ab7;\n  --dark-blue-hover: #367fa9;\n  --teal: #39cccc;\n  --purple: #605ca8;\n  --white: #fff;\n  --query-mobile: 480px;\n  --query-tablet: 768px;\n  --query-large: 992px;\n  --query-notebook: 1024px;\n  --font-chica: .75rem;\n  --font-mobile: 0.675rem;\n  --font-normal: .875rem;\n  --font-boton: 1rem;\n  --font-mediana: 1.1rem;\n  --font-mediana2: 1.3rem;\n  --font-grande: 1.5rem;\n  --font-subtitulo: 2rem;\n  --font-titulo: 2.5rem;\n  --font-gigante: 3rem;\n  --radius-5: 5px;\n  --radius-10: 10px;\n  --radius-15: 15px;\n  --radius-20: 20px;\n  --radius-25: 25px;\n  --radius-30: 30px;\n  --radius-35: 35px;\n  --radius-40: 40px;\n  --radius-45: 45px;\n  --radius-50: 50px;\n  --box-shadow-light: 0px 2px 10px 5px #e9e9e9 ;\n}\n\n.text-orange {\n  color: var(--orange);\n}\n\n.text-red {\n  color: var(--red);\n}\n\n.text-green {\n  color: var(--green);\n}\n\n.text-blue {\n  color: var(--blue);\n}\n\n.text-cyan {\n  color: var(--cyan);\n}\n\n.text-ligthblue {\n  color: var(--ligthblue);\n}\n\n.text-black {\n  color: var(--black) !important;\n}\n\n.text-white {\n  color: var(--white) !important;\n}\n\n.text-grey {\n  color: var(--grey) !important;\n}\n\n.bg-orange {\n  background-color: var(--orange) !important;\n}\n\n.bg-yellow {\n  background-color: var(--yellow) !important;\n}\n\n.bg-red {\n  background-color: var(--red) !important;\n}\n\n.bg-green {\n  background-color: var(--green) !important;\n}\n\n.bg-blue {\n  background-color: var(--blue) !important;\n}\n\n.bg-dark-blue {\n  background-color: var(--dark-blue) !important;\n}\n\n.bg-cyan {\n  background-color: var(--cyan) !important;\n}\n\n.bg-ligthblue {\n  background-color: var(--ligthblue) !important;\n}\n\n.bg-ligthblue-dark {\n  background-color: var(--ligthblue-dark) !important;\n}\n\n.bg-teal {\n  background-color: var(--teal) !important;\n}\n\n.bg-purple {\n  background-color: var(--purple) !important;\n}\n\n.bg-grey {\n  background-color: var(--grey) !important;\n}\n\n.bg-grey-badge {\n  background-color: var(--grey-badge) !important;\n}\n\n.bgOrangeGradient {\n  background: linear-gradient(130deg, rgb(205, 154, 98) 0%, rgba(205, 154, 98, 0.9019607843) 70%, rgba(255, 255, 255, 0.84) 103%);\n}\n\n.bgOrangeGradient::after {\n  content: \"\";\n  position: absolute;\n  bottom: 2rem;\n  right: 2rem;\n  width: 120px;\n  height: 120px;\n  background: url(\"../assets/logos/LogoTCA.webp\") no-repeat center/contain;\n}\n\n.borderData {\n  border-top: 1px dotted #d2d6de;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.btn-default {\n  width: fit-content !important;\n  background-color: #f4f4f4 !important;\n  color: var(--black) !important;\n  border-color: #ddd !important;\n}\n\n.btn-actions {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n}\n.btn-actions .btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.optionBtns {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  gap: 5px;\n}\n.optionBtns .btn {\n  width: 31px;\n  height: 31px;\n  font-size: var(--font-chica);\n}\n\n@media (max-width: 768px) {\n  .sm-flex-column {\n    flex-direction: column !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .xs-flex-column {\n    flex-direction: column !important;\n  }\n}\n\n/* 🔹 Variantes */\n.primary {\n  background-color: var(--orange);\n  color: var(--white);\n}\n.primary:hover {\n  background-color: var(--orange-hover);\n}\n\n.secondary {\n  background-color: var(--grey);\n  color: var(--black);\n}\n.secondary:hover {\n  background-color: var(--grey-dark);\n  color: var(--white);\n}\n\n.new {\n  background-color: var(--blue);\n  color: var(--white);\n}\n.new:hover {\n  background-color: var(--blue-hover);\n}\n\n.outline {\n  background-color: var(--white);\n  color: var(--orange);\n  border: 1px solid var(--orange);\n}\n.outline:hover {\n  background-color: var(--orange);\n  color: var(--white);\n}\n\n.info {\n  background-color: var(--dark-blue);\n  color: var(--white);\n}\n.info:hover {\n  background-color: var(--dark-blue-hover);\n}\n\n.error {\n  background-color: var(--red);\n  color: var(--white);\n}\n.error:hover {\n  background-color: var(--red-hover);\n}\n\n.infoLight {\n  background-color: rgba(183, 51, 51, 0.1);\n  color: var(--red-dark);\n  border: 1px solid rgba(51, 122, 183, 0.25);\n}\n.infoLight:hover {\n  background-color: rgba(198, 59, 85, 0.2);\n}\n\n.successLight {\n  background-color: rgba(0, 166, 90, 0.1);\n  color: var(--green);\n  border: 1px solid rgba(0, 166, 90, 0.25);\n}\n.successLight:hover {\n  background-color: rgba(0, 166, 90, 0.2);\n}\n\n:root {\n  /* 12px */\n  /* 16px */\n  /* 14px */\n  /* 20px */\n  /* 16px */\n  /* 24px */\n  /* 18px */\n  /* 28px */\n  /* 20px */\n  /* 28px */\n  /* 24px */\n  /* 32px */\n  /* 30px */\n  /* 36px */\n  /* 36px */\n  /* 40px */\n  /* 48px */\n  /* 60px */\n  /* 72px */\n  /* 96px */\n  /* 128px */\n}\n:root .text-xs {\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n:root .text-sm {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n:root .text-base {\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n:root .text-lg {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n}\n:root .text-xl {\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n}\n:root .text-2xl {\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n:root .text-3xl {\n  font-size: 1.875rem;\n  line-height: 2.25rem;\n}\n:root .text-4xl {\n  font-size: 2.25rem;\n  line-height: 2.5rem;\n}\n:root .text-5xl {\n  font-size: 3rem;\n  line-height: 1;\n  /* Define el valor de línea según tus necesidades */\n}\n:root .text-6xl {\n  font-size: 3.75rem;\n  line-height: 1;\n  /* Define el valor de línea según tus necesidades */\n}\n:root .text-7xl {\n  font-size: 4.5rem;\n  line-height: 1;\n  /* Define el valor de línea según tus necesidades */\n}\n:root .text-8xl {\n  font-size: 6rem;\n  line-height: 1;\n  /* Define el valor de línea según tus necesidades */\n}\n:root .text-9xl {\n  font-size: 8rem;\n  line-height: 1;\n  /* Define el valor de línea según tus necesidades */\n}\n\n.h0 {\n  height: 0 !important;\n}\n\n.p0 {\n  padding: 0 !important;\n}\n\n.w0 {\n  width: 0rem !important;\n}\n\n.height0 {\n  height: 0rem !important;\n}\n\n.h0vh {\n  height: 0vh !important;\n}\n\n.m0 {\n  margin: 0rem !important;\n}\n\n.ml0 {\n  margin-left: 0rem !important;\n}\n\n.mb0 {\n  margin-bottom: 0rem !important;\n}\n\n.mr0 {\n  margin-right: 0rem !important;\n}\n\n.mt0 {\n  margin-top: 0rem !important;\n}\n\n.mx0 {\n  margin-inline: 0rem !important;\n}\n\n.my0 {\n  margin-block: 0rem !important;\n}\n\n.gap-0 {\n  gap: 0rem !important;\n}\n\n.w1 {\n  width: 1rem !important;\n}\n\n.height1 {\n  height: 1rem !important;\n}\n\n.h1vh {\n  height: 10vh !important;\n}\n\n.m1 {\n  margin: 1rem !important;\n}\n\n.ml1 {\n  margin-left: 1rem !important;\n}\n\n.mb1 {\n  margin-bottom: 1rem !important;\n}\n\n.mr1 {\n  margin-right: 1rem !important;\n}\n\n.mt1 {\n  margin-top: 1rem !important;\n}\n\n.mx1 {\n  margin-inline: 1rem !important;\n}\n\n.my1 {\n  margin-block: 1rem !important;\n}\n\n.gap-1 {\n  gap: 1rem !important;\n}\n\n.w2 {\n  width: 2rem !important;\n}\n\n.height2 {\n  height: 2rem !important;\n}\n\n.h2vh {\n  height: 20vh !important;\n}\n\n.m2 {\n  margin: 2rem !important;\n}\n\n.ml2 {\n  margin-left: 2rem !important;\n}\n\n.mb2 {\n  margin-bottom: 2rem !important;\n}\n\n.mr2 {\n  margin-right: 2rem !important;\n}\n\n.mt2 {\n  margin-top: 2rem !important;\n}\n\n.mx2 {\n  margin-inline: 2rem !important;\n}\n\n.my2 {\n  margin-block: 2rem !important;\n}\n\n.gap-2 {\n  gap: 2rem !important;\n}\n\n.w3 {\n  width: 3rem !important;\n}\n\n.height3 {\n  height: 3rem !important;\n}\n\n.h3vh {\n  height: 30vh !important;\n}\n\n.m3 {\n  margin: 3rem !important;\n}\n\n.ml3 {\n  margin-left: 3rem !important;\n}\n\n.mb3 {\n  margin-bottom: 3rem !important;\n}\n\n.mr3 {\n  margin-right: 3rem !important;\n}\n\n.mt3 {\n  margin-top: 3rem !important;\n}\n\n.mx3 {\n  margin-inline: 3rem !important;\n}\n\n.my3 {\n  margin-block: 3rem !important;\n}\n\n.gap-3 {\n  gap: 3rem !important;\n}\n\n.w4 {\n  width: 4rem !important;\n}\n\n.height4 {\n  height: 4rem !important;\n}\n\n.h4vh {\n  height: 40vh !important;\n}\n\n.m4 {\n  margin: 4rem !important;\n}\n\n.ml4 {\n  margin-left: 4rem !important;\n}\n\n.mb4 {\n  margin-bottom: 4rem !important;\n}\n\n.mr4 {\n  margin-right: 4rem !important;\n}\n\n.mt4 {\n  margin-top: 4rem !important;\n}\n\n.mx4 {\n  margin-inline: 4rem !important;\n}\n\n.my4 {\n  margin-block: 4rem !important;\n}\n\n.gap-4 {\n  gap: 4rem !important;\n}\n\n.w5 {\n  width: 5rem !important;\n}\n\n.height5 {\n  height: 5rem !important;\n}\n\n.h5vh {\n  height: 50vh !important;\n}\n\n.m5 {\n  margin: 5rem !important;\n}\n\n.ml5 {\n  margin-left: 5rem !important;\n}\n\n.mb5 {\n  margin-bottom: 5rem !important;\n}\n\n.mr5 {\n  margin-right: 5rem !important;\n}\n\n.mt5 {\n  margin-top: 5rem !important;\n}\n\n.mx5 {\n  margin-inline: 5rem !important;\n}\n\n.my5 {\n  margin-block: 5rem !important;\n}\n\n.gap-5 {\n  gap: 5rem !important;\n}\n\n.w6 {\n  width: 6rem !important;\n}\n\n.height6 {\n  height: 6rem !important;\n}\n\n.h6vh {\n  height: 60vh !important;\n}\n\n.m6 {\n  margin: 6rem !important;\n}\n\n.ml6 {\n  margin-left: 6rem !important;\n}\n\n.mb6 {\n  margin-bottom: 6rem !important;\n}\n\n.mr6 {\n  margin-right: 6rem !important;\n}\n\n.mt6 {\n  margin-top: 6rem !important;\n}\n\n.mx6 {\n  margin-inline: 6rem !important;\n}\n\n.my6 {\n  margin-block: 6rem !important;\n}\n\n.gap-6 {\n  gap: 6rem !important;\n}\n\n.w7 {\n  width: 7rem !important;\n}\n\n.height7 {\n  height: 7rem !important;\n}\n\n.h7vh {\n  height: 70vh !important;\n}\n\n.m7 {\n  margin: 7rem !important;\n}\n\n.ml7 {\n  margin-left: 7rem !important;\n}\n\n.mb7 {\n  margin-bottom: 7rem !important;\n}\n\n.mr7 {\n  margin-right: 7rem !important;\n}\n\n.mt7 {\n  margin-top: 7rem !important;\n}\n\n.mx7 {\n  margin-inline: 7rem !important;\n}\n\n.my7 {\n  margin-block: 7rem !important;\n}\n\n.gap-7 {\n  gap: 7rem !important;\n}\n\n.w8 {\n  width: 8rem !important;\n}\n\n.height8 {\n  height: 8rem !important;\n}\n\n.h8vh {\n  height: 80vh !important;\n}\n\n.m8 {\n  margin: 8rem !important;\n}\n\n.ml8 {\n  margin-left: 8rem !important;\n}\n\n.mb8 {\n  margin-bottom: 8rem !important;\n}\n\n.mr8 {\n  margin-right: 8rem !important;\n}\n\n.mt8 {\n  margin-top: 8rem !important;\n}\n\n.mx8 {\n  margin-inline: 8rem !important;\n}\n\n.my8 {\n  margin-block: 8rem !important;\n}\n\n.gap-8 {\n  gap: 8rem !important;\n}\n\n.w9 {\n  width: 9rem !important;\n}\n\n.height9 {\n  height: 9rem !important;\n}\n\n.h9vh {\n  height: 90vh !important;\n}\n\n.m9 {\n  margin: 9rem !important;\n}\n\n.ml9 {\n  margin-left: 9rem !important;\n}\n\n.mb9 {\n  margin-bottom: 9rem !important;\n}\n\n.mr9 {\n  margin-right: 9rem !important;\n}\n\n.mt9 {\n  margin-top: 9rem !important;\n}\n\n.mx9 {\n  margin-inline: 9rem !important;\n}\n\n.my9 {\n  margin-block: 9rem !important;\n}\n\n.gap-9 {\n  gap: 9rem !important;\n}\n\n.w10 {\n  width: 10rem !important;\n}\n\n.height10 {\n  height: 10rem !important;\n}\n\n.h10vh {\n  height: 100vh !important;\n}\n\n.m10 {\n  margin: 10rem !important;\n}\n\n.ml10 {\n  margin-left: 10rem !important;\n}\n\n.mb10 {\n  margin-bottom: 10rem !important;\n}\n\n.mr10 {\n  margin-right: 10rem !important;\n}\n\n.mt10 {\n  margin-top: 10rem !important;\n}\n\n.mx10 {\n  margin-inline: 10rem !important;\n}\n\n.my10 {\n  margin-block: 10rem !important;\n}\n\n.gap-10 {\n  gap: 10rem !important;\n}\n\n.my-auto {\n  margin-inline: auto !important;\n}\n\n.mw0 {\n  max-width: 0rem !important;\n}\n\n.mh0 {\n  max-height: 0rem !important;\n}\n\n.mw1 {\n  max-width: 1rem !important;\n}\n\n.mh1 {\n  max-height: 1rem !important;\n}\n\n.mw2 {\n  max-width: 2rem !important;\n}\n\n.mh2 {\n  max-height: 2rem !important;\n}\n\n.mw3 {\n  max-width: 3rem !important;\n}\n\n.mh3 {\n  max-height: 3rem !important;\n}\n\n.mw4 {\n  max-width: 4rem !important;\n}\n\n.mh4 {\n  max-height: 4rem !important;\n}\n\n.mw5 {\n  max-width: 5rem !important;\n}\n\n.mh5 {\n  max-height: 5rem !important;\n}\n\n.mw6 {\n  max-width: 6rem !important;\n}\n\n.mh6 {\n  max-height: 6rem !important;\n}\n\n.mw7 {\n  max-width: 7rem !important;\n}\n\n.mh7 {\n  max-height: 7rem !important;\n}\n\n.mw8 {\n  max-width: 8rem !important;\n}\n\n.mh8 {\n  max-height: 8rem !important;\n}\n\n.mw9 {\n  max-width: 9rem !important;\n}\n\n.mh9 {\n  max-height: 9rem !important;\n}\n\n.mw10 {\n  max-width: 10rem !important;\n}\n\n.mh10 {\n  max-height: 10rem !important;\n}\n\n.mw11 {\n  max-width: 11rem !important;\n}\n\n.mh11 {\n  max-height: 11rem !important;\n}\n\n.mw12 {\n  max-width: 12rem !important;\n}\n\n.mh12 {\n  max-height: 12rem !important;\n}\n\n.mw13 {\n  max-width: 13rem !important;\n}\n\n.mh13 {\n  max-height: 13rem !important;\n}\n\n.mw14 {\n  max-width: 14rem !important;\n}\n\n.mh14 {\n  max-height: 14rem !important;\n}\n\n.mw15 {\n  max-width: 15rem !important;\n}\n\n.mh15 {\n  max-height: 15rem !important;\n}\n\n.mw16 {\n  max-width: 16rem !important;\n}\n\n.mh16 {\n  max-height: 16rem !important;\n}\n\n.mw17 {\n  max-width: 17rem !important;\n}\n\n.mh17 {\n  max-height: 17rem !important;\n}\n\n.mw18 {\n  max-width: 18rem !important;\n}\n\n.mh18 {\n  max-height: 18rem !important;\n}\n\n.mw19 {\n  max-width: 19rem !important;\n}\n\n.mh19 {\n  max-height: 19rem !important;\n}\n\n.mw20 {\n  max-width: 20rem !important;\n}\n\n.mh20 {\n  max-height: 20rem !important;\n}\n\n.mw21 {\n  max-width: 21rem !important;\n}\n\n.mh21 {\n  max-height: 21rem !important;\n}\n\n.mw22 {\n  max-width: 22rem !important;\n}\n\n.mh22 {\n  max-height: 22rem !important;\n}\n\n.mw23 {\n  max-width: 23rem !important;\n}\n\n.mh23 {\n  max-height: 23rem !important;\n}\n\n.mw24 {\n  max-width: 24rem !important;\n}\n\n.mh24 {\n  max-height: 24rem !important;\n}\n\n.mw25 {\n  max-width: 25rem !important;\n}\n\n.mh25 {\n  max-height: 25rem !important;\n}\n\n.mw26 {\n  max-width: 26rem !important;\n}\n\n.mh26 {\n  max-height: 26rem !important;\n}\n\n.mw27 {\n  max-width: 27rem !important;\n}\n\n.mh27 {\n  max-height: 27rem !important;\n}\n\n.mw28 {\n  max-width: 28rem !important;\n}\n\n.mh28 {\n  max-height: 28rem !important;\n}\n\n.mw29 {\n  max-width: 29rem !important;\n}\n\n.mh29 {\n  max-height: 29rem !important;\n}\n\n.mw30 {\n  max-width: 30rem !important;\n}\n\n.mh30 {\n  max-height: 30rem !important;\n}\n\n.mw31 {\n  max-width: 31rem !important;\n}\n\n.mh31 {\n  max-height: 31rem !important;\n}\n\n.mw32 {\n  max-width: 32rem !important;\n}\n\n.mh32 {\n  max-height: 32rem !important;\n}\n\n.mw33 {\n  max-width: 33rem !important;\n}\n\n.mh33 {\n  max-height: 33rem !important;\n}\n\n.mw34 {\n  max-width: 34rem !important;\n}\n\n.mh34 {\n  max-height: 34rem !important;\n}\n\n.mw35 {\n  max-width: 35rem !important;\n}\n\n.mh35 {\n  max-height: 35rem !important;\n}\n\n.mw36 {\n  max-width: 36rem !important;\n}\n\n.mh36 {\n  max-height: 36rem !important;\n}\n\n.mw37 {\n  max-width: 37rem !important;\n}\n\n.mh37 {\n  max-height: 37rem !important;\n}\n\n.mw38 {\n  max-width: 38rem !important;\n}\n\n.mh38 {\n  max-height: 38rem !important;\n}\n\n.mw39 {\n  max-width: 39rem !important;\n}\n\n.mh39 {\n  max-height: 39rem !important;\n}\n\n.mw40 {\n  max-width: 40rem !important;\n}\n\n.mh40 {\n  max-height: 40rem !important;\n}\n\n.mw41 {\n  max-width: 41rem !important;\n}\n\n.mh41 {\n  max-height: 41rem !important;\n}\n\n.mw42 {\n  max-width: 42rem !important;\n}\n\n.mh42 {\n  max-height: 42rem !important;\n}\n\n.mw43 {\n  max-width: 43rem !important;\n}\n\n.mh43 {\n  max-height: 43rem !important;\n}\n\n.mw44 {\n  max-width: 44rem !important;\n}\n\n.mh44 {\n  max-height: 44rem !important;\n}\n\n.mw45 {\n  max-width: 45rem !important;\n}\n\n.mh45 {\n  max-height: 45rem !important;\n}\n\n.mw46 {\n  max-width: 46rem !important;\n}\n\n.mh46 {\n  max-height: 46rem !important;\n}\n\n.mw47 {\n  max-width: 47rem !important;\n}\n\n.mh47 {\n  max-height: 47rem !important;\n}\n\n.mw48 {\n  max-width: 48rem !important;\n}\n\n.mh48 {\n  max-height: 48rem !important;\n}\n\n.mw49 {\n  max-width: 49rem !important;\n}\n\n.mh49 {\n  max-height: 49rem !important;\n}\n\n.mw50 {\n  max-width: 50rem !important;\n}\n\n.mh50 {\n  max-height: 50rem !important;\n}\n\n.mw51 {\n  max-width: 51rem !important;\n}\n\n.mh51 {\n  max-height: 51rem !important;\n}\n\n.mw52 {\n  max-width: 52rem !important;\n}\n\n.mh52 {\n  max-height: 52rem !important;\n}\n\n.mw53 {\n  max-width: 53rem !important;\n}\n\n.mh53 {\n  max-height: 53rem !important;\n}\n\n.mw54 {\n  max-width: 54rem !important;\n}\n\n.mh54 {\n  max-height: 54rem !important;\n}\n\n.mw55 {\n  max-width: 55rem !important;\n}\n\n.mh55 {\n  max-height: 55rem !important;\n}\n\n.mw56 {\n  max-width: 56rem !important;\n}\n\n.mh56 {\n  max-height: 56rem !important;\n}\n\n.mw57 {\n  max-width: 57rem !important;\n}\n\n.mh57 {\n  max-height: 57rem !important;\n}\n\n.mw58 {\n  max-width: 58rem !important;\n}\n\n.mh58 {\n  max-height: 58rem !important;\n}\n\n.mw59 {\n  max-width: 59rem !important;\n}\n\n.mh59 {\n  max-height: 59rem !important;\n}\n\n.mw60 {\n  max-width: 60rem !important;\n}\n\n.mh60 {\n  max-height: 60rem !important;\n}\n\n.mw61 {\n  max-width: 61rem !important;\n}\n\n.mh61 {\n  max-height: 61rem !important;\n}\n\n.mw62 {\n  max-width: 62rem !important;\n}\n\n.mh62 {\n  max-height: 62rem !important;\n}\n\n.mw63 {\n  max-width: 63rem !important;\n}\n\n.mh63 {\n  max-height: 63rem !important;\n}\n\n.mw64 {\n  max-width: 64rem !important;\n}\n\n.mh64 {\n  max-height: 64rem !important;\n}\n\n.mw65 {\n  max-width: 65rem !important;\n}\n\n.mh65 {\n  max-height: 65rem !important;\n}\n\n.mw66 {\n  max-width: 66rem !important;\n}\n\n.mh66 {\n  max-height: 66rem !important;\n}\n\n.mw67 {\n  max-width: 67rem !important;\n}\n\n.mh67 {\n  max-height: 67rem !important;\n}\n\n.mw68 {\n  max-width: 68rem !important;\n}\n\n.mh68 {\n  max-height: 68rem !important;\n}\n\n.mw69 {\n  max-width: 69rem !important;\n}\n\n.mh69 {\n  max-height: 69rem !important;\n}\n\n.mw70 {\n  max-width: 70rem !important;\n}\n\n.mh70 {\n  max-height: 70rem !important;\n}\n\n.mw71 {\n  max-width: 71rem !important;\n}\n\n.mh71 {\n  max-height: 71rem !important;\n}\n\n.mw72 {\n  max-width: 72rem !important;\n}\n\n.mh72 {\n  max-height: 72rem !important;\n}\n\n.mw73 {\n  max-width: 73rem !important;\n}\n\n.mh73 {\n  max-height: 73rem !important;\n}\n\n.mw74 {\n  max-width: 74rem !important;\n}\n\n.mh74 {\n  max-height: 74rem !important;\n}\n\n.mw75 {\n  max-width: 75rem !important;\n}\n\n.mh75 {\n  max-height: 75rem !important;\n}\n\n.mw76 {\n  max-width: 76rem !important;\n}\n\n.mh76 {\n  max-height: 76rem !important;\n}\n\n.mw77 {\n  max-width: 77rem !important;\n}\n\n.mh77 {\n  max-height: 77rem !important;\n}\n\n.mw78 {\n  max-width: 78rem !important;\n}\n\n.mh78 {\n  max-height: 78rem !important;\n}\n\n.mw79 {\n  max-width: 79rem !important;\n}\n\n.mh79 {\n  max-height: 79rem !important;\n}\n\n.mw80 {\n  max-width: 80rem !important;\n}\n\n.mh80 {\n  max-height: 80rem !important;\n}\n\n.mw81 {\n  max-width: 81rem !important;\n}\n\n.mh81 {\n  max-height: 81rem !important;\n}\n\n.mw82 {\n  max-width: 82rem !important;\n}\n\n.mh82 {\n  max-height: 82rem !important;\n}\n\n.mw83 {\n  max-width: 83rem !important;\n}\n\n.mh83 {\n  max-height: 83rem !important;\n}\n\n.mw84 {\n  max-width: 84rem !important;\n}\n\n.mh84 {\n  max-height: 84rem !important;\n}\n\n.mw85 {\n  max-width: 85rem !important;\n}\n\n.mh85 {\n  max-height: 85rem !important;\n}\n\n.mw86 {\n  max-width: 86rem !important;\n}\n\n.mh86 {\n  max-height: 86rem !important;\n}\n\n.mw87 {\n  max-width: 87rem !important;\n}\n\n.mh87 {\n  max-height: 87rem !important;\n}\n\n.mw88 {\n  max-width: 88rem !important;\n}\n\n.mh88 {\n  max-height: 88rem !important;\n}\n\n.mw89 {\n  max-width: 89rem !important;\n}\n\n.mh89 {\n  max-height: 89rem !important;\n}\n\n.mw90 {\n  max-width: 90rem !important;\n}\n\n.mh90 {\n  max-height: 90rem !important;\n}\n\n.mw91 {\n  max-width: 91rem !important;\n}\n\n.mh91 {\n  max-height: 91rem !important;\n}\n\n.mw92 {\n  max-width: 92rem !important;\n}\n\n.mh92 {\n  max-height: 92rem !important;\n}\n\n.mw93 {\n  max-width: 93rem !important;\n}\n\n.mh93 {\n  max-height: 93rem !important;\n}\n\n.mw94 {\n  max-width: 94rem !important;\n}\n\n.mh94 {\n  max-height: 94rem !important;\n}\n\n.mw95 {\n  max-width: 95rem !important;\n}\n\n.mh95 {\n  max-height: 95rem !important;\n}\n\n.mw96 {\n  max-width: 96rem !important;\n}\n\n.mh96 {\n  max-height: 96rem !important;\n}\n\n.mw97 {\n  max-width: 97rem !important;\n}\n\n.mh97 {\n  max-height: 97rem !important;\n}\n\n.mw98 {\n  max-width: 98rem !important;\n}\n\n.mh98 {\n  max-height: 98rem !important;\n}\n\n.mw99 {\n  max-width: 99rem !important;\n}\n\n.mh99 {\n  max-height: 99rem !important;\n}\n\n.mw100 {\n  max-width: 100rem !important;\n}\n\n.mh100 {\n  max-height: 100rem !important;\n}\n\n/* ---------------- */\n@media (max-width: 1090px) {\n  .h0-maxtablet {\n    height: 0vh !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .m0-maxtablet {\n    margin: 0rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .ml0-maxtablet {\n    margin-left: 0rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mb0-maxtablet {\n    margin-bottom: 0rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mr0-maxtablet {\n    margin-right: 0rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mt0-maxtablet {\n    margin-top: 0rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mx0-maxtablet {\n    margin-inline: 0rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .my0-maxtablet {\n    margin-block: 0rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .h1-maxtablet {\n    height: 10vh !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .m1-maxtablet {\n    margin: 1rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .ml1-maxtablet {\n    margin-left: 1rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mb1-maxtablet {\n    margin-bottom: 1rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mr1-maxtablet {\n    margin-right: 1rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mt1-maxtablet {\n    margin-top: 1rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mx1-maxtablet {\n    margin-inline: 1rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .my1-maxtablet {\n    margin-block: 1rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .h2-maxtablet {\n    height: 20vh !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .m2-maxtablet {\n    margin: 2rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .ml2-maxtablet {\n    margin-left: 2rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mb2-maxtablet {\n    margin-bottom: 2rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mr2-maxtablet {\n    margin-right: 2rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mt2-maxtablet {\n    margin-top: 2rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mx2-maxtablet {\n    margin-inline: 2rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .my2-maxtablet {\n    margin-block: 2rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .h3-maxtablet {\n    height: 30vh !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .m3-maxtablet {\n    margin: 3rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .ml3-maxtablet {\n    margin-left: 3rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mb3-maxtablet {\n    margin-bottom: 3rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mr3-maxtablet {\n    margin-right: 3rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mt3-maxtablet {\n    margin-top: 3rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mx3-maxtablet {\n    margin-inline: 3rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .my3-maxtablet {\n    margin-block: 3rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .h4-maxtablet {\n    height: 40vh !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .m4-maxtablet {\n    margin: 4rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .ml4-maxtablet {\n    margin-left: 4rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mb4-maxtablet {\n    margin-bottom: 4rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mr4-maxtablet {\n    margin-right: 4rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mt4-maxtablet {\n    margin-top: 4rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mx4-maxtablet {\n    margin-inline: 4rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .my4-maxtablet {\n    margin-block: 4rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .h5-maxtablet {\n    height: 50vh !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .m5-maxtablet {\n    margin: 5rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .ml5-maxtablet {\n    margin-left: 5rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mb5-maxtablet {\n    margin-bottom: 5rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mr5-maxtablet {\n    margin-right: 5rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mt5-maxtablet {\n    margin-top: 5rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mx5-maxtablet {\n    margin-inline: 5rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .my5-maxtablet {\n    margin-block: 5rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .h6-maxtablet {\n    height: 60vh !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .m6-maxtablet {\n    margin: 6rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .ml6-maxtablet {\n    margin-left: 6rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mb6-maxtablet {\n    margin-bottom: 6rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mr6-maxtablet {\n    margin-right: 6rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mt6-maxtablet {\n    margin-top: 6rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mx6-maxtablet {\n    margin-inline: 6rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .my6-maxtablet {\n    margin-block: 6rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .h7-maxtablet {\n    height: 70vh !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .m7-maxtablet {\n    margin: 7rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .ml7-maxtablet {\n    margin-left: 7rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mb7-maxtablet {\n    margin-bottom: 7rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mr7-maxtablet {\n    margin-right: 7rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mt7-maxtablet {\n    margin-top: 7rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mx7-maxtablet {\n    margin-inline: 7rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .my7-maxtablet {\n    margin-block: 7rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .h8-maxtablet {\n    height: 80vh !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .m8-maxtablet {\n    margin: 8rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .ml8-maxtablet {\n    margin-left: 8rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mb8-maxtablet {\n    margin-bottom: 8rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mr8-maxtablet {\n    margin-right: 8rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mt8-maxtablet {\n    margin-top: 8rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mx8-maxtablet {\n    margin-inline: 8rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .my8-maxtablet {\n    margin-block: 8rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .h9-maxtablet {\n    height: 90vh !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .m9-maxtablet {\n    margin: 9rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .ml9-maxtablet {\n    margin-left: 9rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mb9-maxtablet {\n    margin-bottom: 9rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mr9-maxtablet {\n    margin-right: 9rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mt9-maxtablet {\n    margin-top: 9rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mx9-maxtablet {\n    margin-inline: 9rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .my9-maxtablet {\n    margin-block: 9rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .h10-maxtablet {\n    height: 100vh !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .m10-maxtablet {\n    margin: 10rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .ml10-maxtablet {\n    margin-left: 10rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mb10-maxtablet {\n    margin-bottom: 10rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mr10-maxtablet {\n    margin-right: 10rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mt10-maxtablet {\n    margin-top: 10rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .mx10-maxtablet {\n    margin-inline: 10rem !important;\n  }\n}\n\n@media (max-width: 1090px) {\n  .my10-maxtablet {\n    margin-block: 10rem !important;\n  }\n}\n\n.z0 {\n  position: relative;\n  z-index: 0 !important;\n}\n\n.z-0 {\n  position: relative;\n  z-index: 0 !important;\n}\n\n.z1 {\n  position: relative;\n  z-index: 1 !important;\n}\n\n.z-1 {\n  position: relative;\n  z-index: -1 !important;\n}\n\n.z2 {\n  position: relative;\n  z-index: 2 !important;\n}\n\n.z-2 {\n  position: relative;\n  z-index: -2 !important;\n}\n\n.z3 {\n  position: relative;\n  z-index: 3 !important;\n}\n\n.z-3 {\n  position: relative;\n  z-index: -3 !important;\n}\n\n.p1 {\n  padding: 1rem !important;\n}\n\n.pl1 {\n  padding-left: 1rem !important;\n}\n\n.pb1 {\n  padding-bottom: 1rem !important;\n}\n\n.pr1 {\n  padding-right: 1rem !important;\n}\n\n.pt1 {\n  padding-top: 1rem !important;\n}\n\n.px1 {\n  padding-inline: 1rem !important;\n}\n\n.py1 {\n  padding-block: 1rem !important;\n}\n\n.p2 {\n  padding: 2rem !important;\n}\n\n.pl2 {\n  padding-left: 2rem !important;\n}\n\n.pb2 {\n  padding-bottom: 2rem !important;\n}\n\n.pr2 {\n  padding-right: 2rem !important;\n}\n\n.pt2 {\n  padding-top: 2rem !important;\n}\n\n.px2 {\n  padding-inline: 2rem !important;\n}\n\n.py2 {\n  padding-block: 2rem !important;\n}\n\n.p3 {\n  padding: 3rem !important;\n}\n\n.pl3 {\n  padding-left: 3rem !important;\n}\n\n.pb3 {\n  padding-bottom: 3rem !important;\n}\n\n.pr3 {\n  padding-right: 3rem !important;\n}\n\n.pt3 {\n  padding-top: 3rem !important;\n}\n\n.px3 {\n  padding-inline: 3rem !important;\n}\n\n.py3 {\n  padding-block: 3rem !important;\n}\n\n.p4 {\n  padding: 4rem !important;\n}\n\n.pl4 {\n  padding-left: 4rem !important;\n}\n\n.pb4 {\n  padding-bottom: 4rem !important;\n}\n\n.pr4 {\n  padding-right: 4rem !important;\n}\n\n.pt4 {\n  padding-top: 4rem !important;\n}\n\n.px4 {\n  padding-inline: 4rem !important;\n}\n\n.py4 {\n  padding-block: 4rem !important;\n}\n\n.p5 {\n  padding: 5rem !important;\n}\n\n.pl5 {\n  padding-left: 5rem !important;\n}\n\n.pb5 {\n  padding-bottom: 5rem !important;\n}\n\n.pr5 {\n  padding-right: 5rem !important;\n}\n\n.pt5 {\n  padding-top: 5rem !important;\n}\n\n.px5 {\n  padding-inline: 5rem !important;\n}\n\n.py5 {\n  padding-block: 5rem !important;\n}\n\n.relative {\n  position: relative;\n}\n\n.color-white {\n  color: #FFF !important;\n}\n\n.text-left {\n  text-align: left !important;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.w0 {\n  width: 0% !important;\n}\n\n@media (max-width: 1090px) {\n  .w0-maxtablet {\n    width: 0% !important;\n  }\n}\n\n.w5 {\n  width: 5% !important;\n}\n\n@media (max-width: 1090px) {\n  .w5-maxtablet {\n    width: 5% !important;\n  }\n}\n\n.w10 {\n  width: 10% !important;\n}\n\n@media (max-width: 1090px) {\n  .w10-maxtablet {\n    width: 10% !important;\n  }\n}\n\n.w15 {\n  width: 15% !important;\n}\n\n@media (max-width: 1090px) {\n  .w15-maxtablet {\n    width: 15% !important;\n  }\n}\n\n.w20 {\n  width: 20% !important;\n}\n\n@media (max-width: 1090px) {\n  .w20-maxtablet {\n    width: 20% !important;\n  }\n}\n\n.w25 {\n  width: 25% !important;\n}\n\n@media (max-width: 1090px) {\n  .w25-maxtablet {\n    width: 25% !important;\n  }\n}\n\n.w30 {\n  width: 30% !important;\n}\n\n@media (max-width: 1090px) {\n  .w30-maxtablet {\n    width: 30% !important;\n  }\n}\n\n.w35 {\n  width: 35% !important;\n}\n\n@media (max-width: 1090px) {\n  .w35-maxtablet {\n    width: 35% !important;\n  }\n}\n\n.w40 {\n  width: 40% !important;\n}\n\n@media (max-width: 1090px) {\n  .w40-maxtablet {\n    width: 40% !important;\n  }\n}\n\n.w45 {\n  width: 45% !important;\n}\n\n@media (max-width: 1090px) {\n  .w45-maxtablet {\n    width: 45% !important;\n  }\n}\n\n.w50 {\n  width: 50% !important;\n}\n\n@media (max-width: 1090px) {\n  .w50-maxtablet {\n    width: 50% !important;\n  }\n}\n\n.w55 {\n  width: 55% !important;\n}\n\n@media (max-width: 1090px) {\n  .w55-maxtablet {\n    width: 55% !important;\n  }\n}\n\n.w60 {\n  width: 60% !important;\n}\n\n@media (max-width: 1090px) {\n  .w60-maxtablet {\n    width: 60% !important;\n  }\n}\n\n.w65 {\n  width: 65% !important;\n}\n\n@media (max-width: 1090px) {\n  .w65-maxtablet {\n    width: 65% !important;\n  }\n}\n\n.w70 {\n  width: 70% !important;\n}\n\n@media (max-width: 1090px) {\n  .w70-maxtablet {\n    width: 70% !important;\n  }\n}\n\n.w75 {\n  width: 75% !important;\n}\n\n@media (max-width: 1090px) {\n  .w75-maxtablet {\n    width: 75% !important;\n  }\n}\n\n.w80 {\n  width: 80% !important;\n}\n\n@media (max-width: 1090px) {\n  .w80-maxtablet {\n    width: 80% !important;\n  }\n}\n\n.w85 {\n  width: 85% !important;\n}\n\n@media (max-width: 1090px) {\n  .w85-maxtablet {\n    width: 85% !important;\n  }\n}\n\n.w90 {\n  width: 90% !important;\n}\n\n@media (max-width: 1090px) {\n  .w90-maxtablet {\n    width: 90% !important;\n  }\n}\n\n.w95 {\n  width: 95% !important;\n}\n\n@media (max-width: 1090px) {\n  .w95-maxtablet {\n    width: 95% !important;\n  }\n}\n\n.w100 {\n  width: 100% !important;\n}\n\n@media (max-width: 1090px) {\n  .w100-maxtablet {\n    width: 100% !important;\n  }\n}\n\n.break-spaces {\n  white-space: break-spaces;\n}\n\n.w-fit {\n  width: fit-content !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.wmincontent {\n  width: min-content !important;\n}\n\n.hmincontent {\n  height: min-content !important;\n}\n\n.wmaxcontent {\n  width: max-content !important;\n}\n\n.hmaxcontent {\n  height: max-content !important;\n}\n\n.title {\n  text-align: center;\n  font-size: var(--font-grande);\n}\n\n.text-l {\n  text-align: left;\n}\n\n.text-r {\n  text-align: right;\n}\n\n.secondarytitle {\n  text-align: left;\n  margin-bottom: 2rem;\n  font-size: var(--font-grande);\n}\n\n.bg-attach-fix {\n  background-attachment: fixed;\n}\n\n.gridcenter {\n  grid-column: 1/-1 !important;\n  width: 100% !important;\n}\n\n.dflex {\n  display: flex !important;\n}\n\n.justify-center {\n  justify-content: center !important;\n}\n\n.justify-evenly {\n  justify-content: space-evenly !important;\n}\n\n.justify-between {\n  justify-content: space-between !important;\n}\n\n.align-start {\n  align-items: start !important;\n}\n\n.align-center {\n  align-items: center !important;\n}\n\n.align-baseline {\n  align-items: baseline !important;\n}\n\n.dcenter {\n  display: flex !important;\n  justify-content: center !important;\n}\n\n.dcol {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.drow {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.relative {\n  position: relative;\n}\n\n.dcolcenter {\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n.color-grey {\n  color: var(--grey-color) !important;\n}\n\n.relative {\n  position: relative;\n}\n\n.check {\n  font-size: 1.2rem !important;\n  display: inline-block;\n  color: #FF9933;\n  transform: translateY(4px);\n}\n\n.leermas {\n  color: #FF9933;\n  width: max-content;\n  min-width: fit-content;\n  cursor: pointer;\n  transition: color 150ms ease-in-out;\n}\n.leermas svg {\n  margin-left: 5px;\n  font-size: 1.2rem;\n}\n.leermas:hover {\n  color: var(--stronggreen-color) !important;\n}\n\n.center-child {\n  display: grid;\n  place-items: center;\n}\n\n.tituloImagen {\n  font-size: var(--font-gigante) !important;\n}\n\n.tituloSection {\n  font-size: var(--font-mediana2) !important;\n}\n\n.subtituloSection {\n  font-size: var(--font-mediana) !important;\n}\n\n.parrafoSection {\n  font-size: var(--font-normal) !important;\n}\n\n.tituloBox {\n  margin-bottom: 1rem;\n  color: white;\n  text-align: center;\n  font-size: var(--font-grande);\n  background-color: var(--stronggreen-color);\n  padding: 1rem;\n  border-radius: 5px;\n}\n\n@media (max-width: 630px) {\n  .mobile-dnone {\n    display: none !important;\n  }\n}\n.swiper-pagination-bullet-active {\n  background: var(--gold-800) !important;\n}\n\n.btnGreen {\n  background: var(--green-800);\n  border-radius: 24px;\n  border: none;\n  transition: all ease 0.3s;\n  width: 10rem;\n  padding: 0.5rem;\n  color: var(--white) !important;\n  font-weight: 400;\n  font-size: var(--font-boton);\n}\n.btnGreen a {\n  color: var(--white) !important;\n  text-decoration: none;\n  outline: none;\n  position: relative;\n  font-weight: 400;\n  font-size: var(--font-boton);\n  padding: 1rem;\n  text-align: center;\n}\n.btnGreen:hover {\n  background: var(--green-600);\n}\n.btnGreen:disabled, .btnGreen[disabled=true], .btnGreen[disabled=disabled] {\n  filter: grayscale(0.6);\n}\n.btnGreen {\n  margin-top: 1rem;\n  max-height: 3rem;\n}\n\n.btnOrange {\n  background: var(--gold-800);\n  border-radius: 24px;\n  border: none;\n  transition: all ease 0.3s;\n  width: 10rem;\n  padding: 0.5rem;\n  color: var(--white) !important;\n  font-weight: 400;\n  font-size: var(--font-boton);\n}\n.btnOrange a {\n  color: var(--white) !important;\n  text-decoration: none;\n  outline: none;\n  position: relative;\n  font-weight: 400;\n  font-size: var(--font-boton);\n  padding: 1rem;\n  text-align: center;\n}\n.btnOrange:hover {\n  background: var(--gold-600);\n}\n.btnOrange:disabled, .btnOrange[disabled=true], .btnOrange[disabled=disabled] {\n  filter: grayscale(0.6);\n}\n.btnOrange {\n  padding: 0.4rem;\n  border-radius: 10px;\n  font-size: var(--font-chica);\n}\n\n.btnWhite {\n  background: var(--white) !important;\n  border-radius: 24px;\n  border: none;\n  transition: all ease 0.3s;\n  width: 10rem;\n  padding: 0.5rem;\n  color: var(--gold-800) !important;\n  font-weight: 400;\n  font-size: var(--font-boton);\n}\n.btnWhite a {\n  color: var(--gold-800) !important;\n  text-decoration: none;\n  outline: none;\n  position: relative;\n  font-weight: 400;\n  font-size: var(--font-boton);\n  padding: 1rem;\n  text-align: center;\n}\n.btnWhite:hover {\n  background: #f88c1f;\n}\n.btnWhite:disabled, .btnWhite[disabled=true], .btnWhite[disabled=disabled] {\n  filter: grayscale(0.6);\n}\n.btnWhite {\n  padding: 0.4rem;\n  border-radius: 10px;\n  font-size: var(--font-chica);\n  border: 1px solid var(--gold-800);\n}\n\n.Button {\n  width: auto;\n  height: 2rem;\n  border-radius: 5px;\n  border: none;\n  color: var(--white);\n  background-color: var(--green-800);\n  border: none;\n  z-index: 99;\n  border: 2px solid transparent;\n  -webkit-transition: 0.4s all;\n  transition: 0.4s all;\n}\n.Button:hover {\n  background-color: var(--white);\n  transition: 0.4s all;\n  border: 2px solid var(--green-800);\n  color: var(--green-800);\n}\n.Button:disabled, .Button[disabled=true], .Button[disabled=disabled] {\n  filter: grayscale(0.6);\n}\n\n.Button-orange {\n  width: auto;\n  height: 2rem;\n  border-radius: 5px;\n  border: none;\n  color: var(--white);\n  background-color: var(--gold-800);\n  border: none;\n  z-index: 99;\n  border: 2px solid transparent;\n  -webkit-transition: 0.4s all;\n  transition: 0.4s all;\n}\n.Button-orange:hover {\n  background-color: var(--white);\n  transition: 0.4s all;\n  border: 2px solid var(--gold-800);\n  color: var(--gold-800);\n}\n.Button-orange:disabled, .Button-orange[disabled=true], .Button-orange[disabled=disabled] {\n  filter: grayscale(0.6);\n}\n\n.Button-gray {\n  width: auto;\n  height: 2rem;\n  border-radius: 5px;\n  border: none;\n  color: var(--white);\n  background-color: var(--grey-light-color);\n  border: none;\n  z-index: 99;\n  border: 2px solid transparent;\n  -webkit-transition: 0.4s all;\n  transition: 0.4s all;\n}\n.Button-gray:hover {\n  background-color: var(--white);\n  transition: 0.4s all;\n  border: 2px solid var(--grey-light-color);\n  color: var(--grey-light-color);\n}\n.Button-gray:disabled, .Button-gray[disabled=true], .Button-gray[disabled=disabled] {\n  filter: grayscale(0.6);\n}\n\n.no-caret-dropdown .dropdown-toggle::after {\n  display: none !important;\n}",".rbc-btn {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\n\nbutton.rbc-btn {\n  overflow: visible;\n  text-transform: none;\n  appearance: button;\n  cursor: pointer;\n}\n\nbutton[disabled].rbc-btn {\n  cursor: not-allowed;\n}\n\nbutton.rbc-input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n","@import './variables';\n@import './reset';\n\n.rbc-calendar {\n  box-sizing: border-box;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.rbc-m-b-negative-3 {\n  margin-bottom: -3px;\n}\n\n.rbc-h-full {\n  height: 100%;\n}\n\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n  box-sizing: inherit;\n}\n\n.rbc-abs-full {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.rbc-ellipsis {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rbc-rtl {\n  direction: rtl;\n}\n\n.rbc-off-range {\n  color: $out-of-range-color;\n}\n\n.rbc-off-range-bg {\n  background: $out-of-range-bg-color;\n}\n\n.rbc-header {\n  overflow: hidden;\n  flex: 1 0 0%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 3px;\n  text-align: center;\n  vertical-align: middle;\n  font-weight: bold;\n  font-size: 90%;\n  min-height: 0;\n  border-bottom: 1px solid $cell-border;\n\n  & + & {\n    border-left: 1px solid $cell-border;\n  }\n\n  .rbc-rtl & + & {\n    border-left-width: 0;\n    border-right: 1px solid $cell-border;\n  }\n\n  & > a {\n    &,\n    &:active,\n    &:visited {\n      color: inherit;\n      text-decoration: none;\n    }\n  }\n}\n\n.rbc-button-link {\n  color: inherit;\n  background: none;\n  margin: 0;\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  user-select: text;\n}\n\n.rbc-row-content {\n  position: relative;\n  user-select: none;\n  -webkit-user-select: none;\n  z-index: 4;\n}\n\n.rbc-row-content-scrollable {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  .rbc-row-content-scroll-container {\n    height: 100%;\n    overflow-y: scroll;\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n\n    /* Hide scrollbar for Chrome, Safari and Opera */\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n}\n\n.rbc-today {\n  background-color: $today-highlight-bg;\n}\n\n@import './toolbar';\n@import './event';\n@import './month';\n@import './agenda';\n@import './time-grid';\n","$out-of-range-color: lighten(#333, 40%) !default;\n$out-of-range-bg-color: lighten(#333, 70%) !default;\n\n$calendar-border: #ddd !default;\n$cell-border: #ddd !default;\n\n$border-color: #ccc !default;\n\n// Each calendar segment is 1/7th.\n$segment-width: 0.14286% !default;\n\n$time-selection-color: white !default;\n$time-selection-bg-color: rgba(0, 0, 0, 0.5) !default;\n$date-selection-bg-color: rgba(0, 0, 0, 0.1) !default;\n\n$event-bg: #3174ad !default;\n$event-border: darken(#3174ad, 10%) !default;\n$event-outline: #3b99fc !default;\n$event-color: #fff !default;\n$event-border-radius: 5px !default;\n$event-padding: 2px 5px !default;\n$event-zindex: 4 !default;\n\n$btn-color: #373a3c !default;\n$btn-bg: #fff !default;\n$btn-border: #ccc !default;\n\n$current-time-color: #74ad31 !default;\n\n$rbc-css-prefix: rbc-i !default;\n\n$today-highlight-bg: #eaf6ff !default;\n","@import './variables';\n\n$active-background: darken($btn-bg, 10%);\n$active-border: darken($btn-border, 12%);\n\n.rbc-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 16px;\n\n  .rbc-toolbar-label {\n    flex-grow:1;\n    padding: 0 10px;\n    text-align: center;\n  }\n\n  & button {\n    color: $btn-color;\n    display: inline-block;\n    margin: 0;\n    text-align: center;\n    vertical-align: middle;\n    background: none;\n    background-image: none;\n    border: 1px solid $btn-border;\n    padding: .375rem 1rem;\n    border-radius: 4px;\n    line-height: normal;\n    white-space: nowrap;\n\n    &:active,\n    &.rbc-active {\n      background-image: none;\n      box-shadow: inset 0 3px 5px rgba(0,0,0,.125);\n      background-color: $active-background;\n      border-color: $active-border;\n\n      &:hover,\n      &:focus {\n        color: $btn-color;\n        background-color: darken($btn-bg, 17%);\n        border-color: darken($btn-border, 25%);\n      }\n    }\n\n    &:focus {\n      color: $btn-color;\n      background-color: $active-background;\n      border-color: $active-border;\n    }\n\n    &:hover {\n      color: $btn-color;\n      cursor: pointer;\n      background-color: $active-background;\n          border-color: $active-border;\n    }\n  }\n}\n\n.rbc-btn-group {\n  display: inline-block;\n  white-space: nowrap;\n\n  > button:first-child:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  > button:last-child:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .rbc-rtl & > button:first-child:not(:last-child) {\n    border-radius: 4px;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .rbc-rtl & > button:last-child:not(:first-child) {\n    border-radius: 4px;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  > button:not(:first-child):not(:last-child) {\n    border-radius: 0;\n  }\n\n  button + button {\n    margin-left: -1px;\n  }\n\n  .rbc-rtl & button + button {\n    margin-left: 0;\n    margin-right: -1px;\n  }\n\n  & + &,\n  & + button {\n    margin-left: 10px;\n  }\n}\n\n@media (max-width: 767px) {\n  .rbc-toolbar {\n    flex-direction: column;\n  }\n}\n","@import './variables';\n\n.rbc-event {\n  border: none;\n  box-sizing: border-box;\n  box-shadow: none;\n  margin: 0;\n  padding: $event-padding;\n  background-color: $event-bg;\n  border-radius: $event-border-radius;\n  color: $event-color;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n\n  .rbc-slot-selecting & {\n    cursor: inherit;\n    pointer-events: none;\n  }\n\n  &.rbc-selected {\n    background-color: darken($event-bg, 10%);\n  }\n\n  &:focus {\n    outline: 5px auto $event-outline;\n  }\n}\n\n.rbc-event-label {\n  @extend .rbc-ellipsis;\n  font-size: 80%;\n}\n\n.rbc-event-overlaps {\n  box-shadow: -1px 1px 5px 0px rgba(51,51,51,.5);\n}\n\n.rbc-event-continues-prior {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-event-continues-after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n\n.rbc-event-continues-earlier {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rbc-event-continues-later {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n","@import './variables';\n\n.rbc-row {\n  display: flex;\n  flex-direction: row;\n}\n\n.rbc-row-segment {\n  padding: 0 1px 1px 1px;\n\n  .rbc-event-content {\n    @extend .rbc-ellipsis;\n  }\n}\n\n.rbc-selected-cell {\n  background-color: $date-selection-bg-color;\n}\n\n.rbc-show-more {\n  @extend .rbc-ellipsis;\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: $event-zindex;\n  font-weight: bold;\n  font-size: 85%;\n  height: auto;\n  line-height: normal;\n  color: $event-bg;\n  &:hover,\n  &:focus {\n    color: darken($event-bg, 10%);\n  }\n}\n\n.rbc-month-view {\n  position: relative;\n  border: 1px solid $calendar-border;\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  width: 100%;\n  user-select: none;\n  -webkit-user-select: none;\n\n  height: 100%; // ie-fix\n}\n\n.rbc-month-header {\n  display: flex;\n  flex-direction: row;\n}\n\n.rbc-month-row {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  flex: 1 0 0; // postcss will remove the 0px here hence the duplication below\n  flex-basis: 0px;\n  overflow: hidden;\n\n  height: 100%; // ie-fix\n\n  & + & {\n    border-top: 1px solid $cell-border;\n  }\n}\n\n.rbc-date-cell {\n  flex: 1 1 0;\n  min-width: 0;\n  padding-right: 5px;\n  text-align: right;\n\n  &.rbc-now {\n    font-weight: bold;\n  }\n\n  > a {\n    &,\n    &:active,\n    &:visited {\n      color: inherit;\n      text-decoration: none;\n    }\n  }\n}\n\n.rbc-row-bg {\n  @extend .rbc-abs-full;\n  display: flex;\n  flex-direction: row;\n  flex: 1 0 0;\n  overflow: hidden;\n  right: 1px;\n}\n\n.rbc-day-bg {\n  flex: 1 0 0%;\n\n  & + & {\n    border-left: 1px solid $cell-border;\n  }\n\n  .rbc-rtl & + & {\n    border-left-width: 0;\n    border-right: 1px solid $cell-border;\n  }\n}\n\n.rbc-overlay {\n  position: absolute;\n  z-index: $event-zindex + 1;\n  border: 1px solid #e5e5e5;\n  background-color: #fff;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  padding: 10px;\n\n  > * + * {\n    margin-top: 1px;\n  }\n}\n\n.rbc-overlay-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: -10px -10px 5px -10px;\n  padding: 2px 10px;\n}\n","@import './variables';\n\n.rbc-agenda-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  overflow: auto;\n\n  table.rbc-agenda-table {\n    width: 100%;\n    border: 1px solid $cell-border;\n    border-spacing: 0;\n    border-collapse: collapse;\n\n    tbody > tr > td {\n      padding: 5px 10px;\n      vertical-align: top;\n    }\n\n    .rbc-agenda-time-cell {\n      padding-left: 15px;\n      padding-right: 15px;\n      text-transform: lowercase;\n    }\n\n    tbody > tr > td + td {\n      border-left: 1px solid $cell-border;\n    }\n\n    .rbc-rtl & {\n      tbody > tr > td + td {\n        border-left-width: 0;\n        border-right: 1px solid $cell-border;\n      }\n    }\n\n    tbody > tr + tr {\n      border-top: 1px solid $cell-border;\n    }\n\n    thead > tr > th {\n      padding: 3px 5px;\n      text-align: left;\n      border-bottom: 1px solid $cell-border;\n\n      .rbc-rtl & {\n        text-align: right;\n      }\n    }\n  }\n}\n\n.rbc-agenda-time-cell {\n  text-transform: lowercase;\n\n  .rbc-continues-after:after {\n    content: ' »'\n  }\n  .rbc-continues-prior:before {\n    content: '« '\n  }\n}\n\n.rbc-agenda-date-cell,\n.rbc-agenda-time-cell {\n  white-space: nowrap;\n}\n\n\n\n.rbc-agenda-event-cell {\n  width: 100%\n}\n","@import './variables';\n\n.rbc-time-column {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n\n  .rbc-timeslot-group {\n    flex: 1;\n  }\n}\n\n\n.rbc-timeslot-group {\n  border-bottom: 1px solid $cell-border;\n  min-height: 40px;\n  display: flex;\n  flex-flow: column nowrap;\n}\n\n.rbc-time-gutter,\n.rbc-header-gutter {\n  flex: none;\n}\n\n.rbc-label {\n  padding: 0 5px;\n}\n\n.rbc-day-slot {\n  position: relative;\n\n  .rbc-events-container {\n    bottom: 0;\n    left: 0;\n    position: absolute;\n    right: 0;\n    margin-right: 10px;\n    top: 0;\n\n    &.rbc-rtl {\n      left: 10px;\n      right: 0;\n    }\n  }\n\n  .rbc-event {\n    border: 1px solid $event-border;\n    display: flex;\n    max-height: 100%;\n    min-height: 20px;\n    flex-flow: column wrap;\n    align-items: flex-start;\n    overflow: hidden;\n    position: absolute;\n  }\n  \n  .rbc-background-event {\n    @extend .rbc-event;\n    opacity: 0.75;\n  }\n\n  .rbc-event-label {\n    flex: none;\n    padding-right: 5px;\n    width: auto;\n  }\n\n  .rbc-event-content {\n    width: 100%;\n    flex: 1 1 0;\n    word-wrap: break-word;\n    line-height: 1;\n    height: 100%;\n    min-height: 1em;\n  }\n\n  .rbc-time-slot {\n    border-top: 1px solid lighten($cell-border, 10%);\n  }\n}\n\n.rbc-time-view-resources {\n  .rbc-time-gutter,\n  .rbc-time-header-gutter {\n    position: sticky;\n    left: 0;\n    background-color: white;\n    border-right: 1px solid $cell-border;\n    z-index: 10;\n    margin-right: -1px;\n  }\n\n  .rbc-time-header {\n    overflow: hidden;\n  }\n\n  .rbc-time-header-content {\n    min-width: auto;\n    flex: 1 0 0;\n    flex-basis: 0px;\n  }\n\n  .rbc-time-header-cell-single-day {\n    display: none;\n  }\n\n  .rbc-day-slot {\n    min-width: 140px;\n  }\n\n  .rbc-header,\n  .rbc-day-bg {\n    width: 140px;\n    // min-width: 0;\n    flex:  1 1 0;\n    flex-basis: 0 px;\n  }\n}\n\n.rbc-time-header-content + .rbc-time-header-content {\n  margin-left: -1px;\n}\n\n.rbc-time-slot {\n  flex: 1 0 0;\n\n  &.rbc-now {\n    font-weight: bold;\n  }\n}\n\n.rbc-day-header {\n  text-align: center;\n}\n","@import './variables';\n@import './time-column';\n\n.rbc-slot-selection {\n  z-index: 10;\n  position: absolute;\n  background-color: $time-selection-bg-color;\n  color: $time-selection-color;\n  font-size: 75%;\n  width: 100%;\n  padding: 3px;\n}\n\n.rbc-slot-selecting {\n  cursor: move;\n}\n\n.rbc-time-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  border: 1px solid $calendar-border;\n  min-height: 0;\n\n  .rbc-time-gutter {\n    white-space: nowrap;\n    text-align: right;\n  }\n\n  .rbc-allday-cell {\n    box-sizing: content-box;\n    width: 100%;\n    height: 100%;\n    position: relative;\n  }\n  .rbc-allday-cell + .rbc-allday-cell {\n    border-left: 1px solid $cell-border;\n  }\n\n  .rbc-allday-events {\n    position: relative;\n    z-index: 4;\n  }\n\n  .rbc-row {\n    box-sizing: border-box;\n    min-height: 20px;\n  }\n}\n\n.rbc-time-header {\n  display: flex;\n  flex: 0 0 auto; // should not shrink below height\n  flex-direction: row;\n\n  &.rbc-overflowing {\n    border-right: 1px solid $cell-border;\n  }\n\n  .rbc-rtl &.rbc-overflowing {\n    border-right-width: 0;\n    border-left: 1px solid $cell-border;\n  }\n\n  > .rbc-row:first-child {\n    border-bottom: 1px solid $cell-border;\n  }\n\n  > .rbc-row.rbc-row-resource {\n    border-bottom: 1px solid $cell-border;\n  }\n\n  // .rbc-gutter-cell {\n  //   flex: none;\n  // }\n\n  // > .rbc-gutter-cell + * {\n  //   width: 100%;\n  // }\n}\n\n.rbc-time-header-cell-single-day {\n  display: none;\n}\n\n.rbc-time-header-content {\n  flex: 1;\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  border-left: 1px solid $cell-border;\n\n  .rbc-rtl & {\n    border-left-width: 0;\n    border-right: 1px solid $cell-border;\n  }\n\n  > .rbc-row.rbc-row-resource {\n    border-bottom: 1px solid $cell-border;\n    flex-shrink: 0;\n  }\n}\n\n.rbc-time-content {\n  display: flex;\n  flex: 1 0 0%;\n  align-items: flex-start;\n  width: 100%;\n  border-top: 2px solid $calendar-border;\n  overflow-y: auto;\n  position: relative;\n\n  > .rbc-time-gutter {\n    flex: none;\n  }\n\n  > * + * > * {\n    border-left: 1px solid $cell-border;\n  }\n\n  .rbc-rtl & > * + * > * {\n    border-left-width: 0;\n    border-right: 1px solid $cell-border;\n  }\n\n  > .rbc-day-slot {\n    width: 100%;\n    user-select: none;\n    -webkit-user-select: none;\n  }\n}\n\n.rbc-current-time-indicator {\n  position: absolute;\n  z-index: 3;\n  left: 0;\n  right: 0;\n  height: 1px;\n\n  background-color: $current-time-color;\n  pointer-events: none;\n}\n\n.rbc-resource-grouping {\n  &.rbc-time-header-content {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .rbc-row .rbc-header {\n    width: 141px;\n  }\n}","@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');\r\n@import 'react-big-calendar/lib/sass/styles';\r\n\r\n* {\r\n  // font-family: 'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif;\r\n  font-family: 'Inter', sans-serif;\r\n  padding: 0;\r\n  margin: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n#root {\r\n  width: 100%;\r\n\r\n  ul {\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n  }\r\n\r\n\r\n  p {\r\n    line-height: 1.8rem;\r\n  }\r\n\r\n  p,\r\n  h1,\r\n  h2,\r\n  h3 {\r\n    margin: 0;\r\n  }\r\n\r\n  button {\r\n    cursor: pointer;\r\n  }\r\n\r\n  a {\r\n    cursor: pointer;\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n*::marker {\r\n  color: var(--orange-800) !important;\r\n  width: 25px;\r\n  height: 25px;\r\n  place-content: center;\r\n  place-items: center;\r\n  font-size: 1.3rem;\r\n}\r\n\r\n:root {\r\n  --green: #00a65a;\r\n  --green-dark: #398439;\r\n  --green-hover: #008d4c;\r\n\r\n  --blue: #3c8dbc;\r\n  --blue-dark: #204d74;\r\n  --blue-light: #ecf0f5;\r\n  --blue-hover: #367fa9;\r\n\r\n  --red: #dd4b39;\r\n  --red-dark: #d73925;\r\n  --red-hover: #d73925;\r\n\r\n  --black: #333333;\r\n  --black-hover: #999999;\r\n\r\n  --grey: #d2d6de;\r\n  --grey-dark: #444;\r\n  --grey-badge: #b5bbc8;\r\n\r\n  --orange: #f0ad4e;\r\n  --orange-dark: #eea236;\r\n  --orange-hover: #d58512;\r\n\r\n  --yellow: #f39c12;\r\n  --yellow-dark: #db8b0b;\r\n  --yellow-hover: rgb(216, 140, 32);\r\n\r\n  --ligthblue: #00c0ef;\r\n  --ligthblue-dark: #00acd6;\r\n  --ligthblue-hover: #269abc;\r\n\r\n  --cyan: #00c0ef;\r\n  --cyan-hover: #00acd6;\r\n\r\n  --dark-blue: #337ab7;\r\n  --dark-blue-hover: #367fa9;\r\n\r\n  --teal: #39cccc;\r\n\r\n  --purple: #605ca8;\r\n\r\n  --white: #fff;\r\n\r\n  // Querys\r\n  --query-mobile: 480px;\r\n  --query-tablet: 768px;\r\n  --query-large: 992px;\r\n  --query-notebook: 1024px;\r\n\r\n  // Fonts sizes\r\n  --font-chica: .75rem;\r\n  --font-mobile: 0.675rem;\r\n  --font-normal: .875rem;\r\n  --font-boton: 1rem;\r\n  --font-mediana: 1.1rem;\r\n  --font-mediana2: 1.3rem;\r\n  --font-grande: 1.5rem;\r\n  --font-subtitulo: 2rem;\r\n  --font-titulo: 2.5rem;\r\n  --font-gigante: 3rem;\r\n\r\n  // Border radius\r\n  --radius-5: 5px;\r\n  --radius-10: 10px;\r\n  --radius-15: 15px;\r\n  --radius-20: 20px;\r\n  --radius-25: 25px;\r\n  --radius-30: 30px;\r\n  --radius-35: 35px;\r\n  --radius-40: 40px;\r\n  --radius-45: 45px;\r\n  --radius-50: 50px;\r\n\r\n  // box shadow\r\n  --box-shadow-light: 0px 2px 10px 5px #e9e9e9\r\n}\r\n\r\n\r\n.text-orange {\r\n  color: var(--orange);\r\n}\r\n\r\n.text-red {\r\n  color: var(--red);\r\n}\r\n\r\n.text-green {\r\n  color: var(--green);\r\n}\r\n\r\n.text-blue {\r\n  color: var(--blue);\r\n}\r\n\r\n.text-cyan {\r\n  color: var(--cyan);\r\n}\r\n\r\n.text-ligthblue {\r\n  color: var(--ligthblue);\r\n}\r\n\r\n.text-black {\r\n  color: var(--black) !important;\r\n}\r\n\r\n.text-white {\r\n  color: var(--white) !important;\r\n}\r\n\r\n.text-grey {\r\n  color: var(--grey) !important;\r\n}\r\n\r\n\r\n.bg-orange {\r\n  background-color: var(--orange) !important;\r\n}\r\n\r\n.bg-yellow {\r\n  background-color: var(--yellow) !important;\r\n}\r\n\r\n.bg-red {\r\n  background-color: var(--red) !important;\r\n}\r\n\r\n.bg-green {\r\n  background-color: var(--green) !important;\r\n}\r\n\r\n.bg-blue {\r\n  background-color: var(--blue) !important;\r\n}\r\n\r\n.bg-dark-blue {\r\n  background-color: var(--dark-blue) !important;\r\n}\r\n\r\n.bg-cyan {\r\n  background-color: var(--cyan) !important;\r\n}\r\n\r\n.bg-ligthblue {\r\n  background-color: var(--ligthblue) !important;\r\n}\r\n\r\n.bg-ligthblue-dark {\r\n  background-color: var(--ligthblue-dark) !important;\r\n}\r\n\r\n.bg-teal {\r\n  background-color: var(--teal) !important;\r\n}\r\n\r\n.bg-purple {\r\n  background-color: var(--purple) !important;\r\n}\r\n\r\n.bg-grey {\r\n  background-color: var(--grey) !important;\r\n}\r\n\r\n.bg-grey-badge {\r\n  background-color: var(--grey-badge) !important;\r\n}\r\n\r\n.bgOrangeGradient {\r\n  background: linear-gradient(130deg, rgb(205, 154, 98) 0%, rgba(205, 154, 98, 0.9019607843) 70%, rgb(255 255 255 / 84%) 103%);\r\n}\r\n\r\n.bgOrangeGradient::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: 2rem;\r\n  right: 2rem;\r\n  width: 120px;\r\n  height: 120px;\r\n  background: url(\"../assets/logos/LogoTCA.webp\") no-repeat center/contain;\r\n}\r\n\r\n\r\n.borderData {\r\n  border-top: 1px dotted #d2d6de;\r\n  border-radius: 5px;\r\n  margin-bottom: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.btn-default {\r\n  width: fit-content !important;\r\n  background-color: #f4f4f4 !important;\r\n  color: var(--black) !important;\r\n  border-color: #ddd !important;\r\n}\r\n\r\n.btn-actions {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 1rem;\r\n\r\n  .btn {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n  }\r\n}\r\n\r\n.optionBtns {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: row;\r\n  gap: 5px;\r\n\r\n  .btn {\r\n    width: 31px;\r\n    height: 31px;\r\n    font-size: var(--font-chica);\r\n  }\r\n}\r\n\r\n.sm-flex-column {\r\n  @media (max-width: 768px) {\r\n    flex-direction: column !important;\r\n  }\r\n}\r\n \r\n.xs-flex-column {\r\n  @media (max-width: 480px) {\r\n    flex-direction: column !important;\r\n  }\r\n}\r\n\r\n/* 🔹 Variantes */\r\n.primary {\r\n  background-color: var(--orange);\r\n  color: var(--white);\r\n\r\n  &:hover {\r\n    background-color: var(--orange-hover);\r\n  }\r\n}\r\n\r\n.secondary {\r\n  background-color: var(--grey);\r\n  color: var(--black);\r\n\r\n  &:hover {\r\n    background-color: var(--grey-dark);\r\n    color: var(--white);\r\n  }\r\n}\r\n\r\n.new {\r\n  background-color: var(--blue);\r\n  color: var(--white);\r\n\r\n  &:hover {\r\n    background-color: var(--blue-hover);\r\n  }\r\n}\r\n\r\n.outline {\r\n  background-color: var(--white);\r\n  color: var(--orange);\r\n  border: 1px solid var(--orange);\r\n\r\n  &:hover {\r\n    background-color: var(--orange);\r\n    color: var(--white);\r\n  }\r\n}\r\n\r\n.info {\r\n  background-color: var(--dark-blue);\r\n  color: var(--white);\r\n\r\n  &:hover {\r\n    background-color: var(--dark-blue-hover);\r\n  }\r\n}\r\n\r\n.error {\r\n  background-color: var(--red);\r\n  color: var(--white);\r\n\r\n  &:hover {\r\n    background-color: var(--red-hover);\r\n  }\r\n}\r\n\r\n.infoLight {\r\n  background-color: rgb(183 51 51 / 10%);\r\n  color: var(--red-dark);\r\n  border: 1px solid rgba(51, 122, 183, 0.25);\r\n\r\n  &:hover {\r\n    background-color: rgb(198 59 85 / 20%);\r\n  }\r\n}\r\n\r\n.successLight {\r\n  background-color: rgba(0, 166, 90, 0.1);\r\n  color: var(--green);\r\n  border: 1px solid rgba(0, 166, 90, 0.25);\r\n\r\n  &:hover {\r\n    background-color: rgba(0, 166, 90, 0.2);\r\n  }\r\n}\r\n",":root {\r\n  $font-size-xs: 0.75rem;\r\n  /* 12px */\r\n  $line-height-xs: 1rem;\r\n  /* 16px */\r\n  $font-size-sm: 0.875rem;\r\n  /* 14px */\r\n  $line-height-sm: 1.25rem;\r\n  /* 20px */\r\n  $font-size-base: 1rem;\r\n  /* 16px */\r\n  $line-height-base: 1.5rem;\r\n  /* 24px */\r\n  $font-size-lg: 1.125rem;\r\n  /* 18px */\r\n  $line-height-lg: 1.75rem;\r\n  /* 28px */\r\n  $font-size-xl: 1.25rem;\r\n  /* 20px */\r\n  $line-height-xl: 1.75rem;\r\n  /* 28px */\r\n  $font-size-2xl: 1.5rem;\r\n  /* 24px */\r\n  $line-height-2xl: 2rem;\r\n  /* 32px */\r\n  $font-size-3xl: 1.875rem;\r\n  /* 30px */\r\n  $line-height-3xl: 2.25rem;\r\n  /* 36px */\r\n  $font-size-4xl: 2.25rem;\r\n  /* 36px */\r\n  $line-height-4xl: 2.5rem;\r\n  /* 40px */\r\n  $font-size-5xl: 3rem;\r\n  /* 48px */\r\n  $font-size-6xl: 3.75rem;\r\n  /* 60px */\r\n  $font-size-7xl: 4.5rem;\r\n  /* 72px */\r\n  $font-size-8xl: 6rem;\r\n  /* 96px */\r\n  $font-size-9xl: 8rem;\r\n\r\n  /* 128px */\r\n  .text-xs {\r\n    font-size: $font-size-xs;\r\n    line-height: $line-height-xs;\r\n  }\r\n\r\n  .text-sm {\r\n    font-size: $font-size-sm;\r\n    line-height: $line-height-sm;\r\n  }\r\n\r\n  .text-base {\r\n    font-size: $font-size-base;\r\n    line-height: $line-height-base;\r\n  }\r\n\r\n  .text-lg {\r\n    font-size: $font-size-lg;\r\n    line-height: $line-height-lg;\r\n  }\r\n\r\n  .text-xl {\r\n    font-size: $font-size-xl;\r\n    line-height: $line-height-xl;\r\n  }\r\n\r\n  .text-2xl {\r\n    font-size: $font-size-2xl;\r\n    line-height: $line-height-2xl;\r\n  }\r\n\r\n  .text-3xl {\r\n    font-size: $font-size-3xl;\r\n    line-height: $line-height-3xl;\r\n  }\r\n\r\n  .text-4xl {\r\n    font-size: $font-size-4xl;\r\n    line-height: $line-height-4xl;\r\n  }\r\n\r\n  .text-5xl {\r\n    font-size: $font-size-5xl;\r\n    line-height: 1;\r\n    /* Define el valor de línea según tus necesidades */\r\n  }\r\n\r\n  .text-6xl {\r\n    font-size: $font-size-6xl;\r\n    line-height: 1;\r\n    /* Define el valor de línea según tus necesidades */\r\n  }\r\n\r\n  .text-7xl {\r\n    font-size: $font-size-7xl;\r\n    line-height: 1;\r\n    /* Define el valor de línea según tus necesidades */\r\n  }\r\n\r\n  .text-8xl {\r\n    font-size: $font-size-8xl;\r\n    line-height: 1;\r\n    /* Define el valor de línea según tus necesidades */\r\n  }\r\n\r\n  .text-9xl {\r\n    font-size: $font-size-9xl;\r\n    line-height: 1;\r\n    /* Define el valor de línea según tus necesidades */\r\n  }\r\n}","@use '../../sass/utils/querys' as q;\r\n\r\n$sizes: 1rem,\r\n  2rem,\r\n  3rem,\r\n  4rem !important;\r\n\r\n.h0 {\r\n  height: 0 !important;\r\n}\r\n\r\n.p0 {\r\n  padding: 0 !important;\r\n}\r\n\r\n@for $i from 0 through 10 {\r\n  .w#{$i} {\r\n    width: 1rem * $i !important;\r\n  }\r\n\r\n  .height#{$i} {\r\n    height: 1rem * $i !important;\r\n  }\r\n\r\n  .h#{$i}vh {\r\n    height: ($i) * 10vh !important;\r\n  }\r\n\r\n  .m#{$i} {\r\n    margin: 1rem * $i !important;\r\n  }\r\n\r\n  .ml#{$i} {\r\n    margin-left: 1rem * $i !important;\r\n  }\r\n\r\n  .mb#{$i} {\r\n    margin-bottom: 1rem * $i !important;\r\n  }\r\n\r\n  .mr#{$i} {\r\n    margin-right: 1rem * $i !important;\r\n  }\r\n\r\n  .mt#{$i} {\r\n    margin-top: 1rem * $i !important;\r\n  }\r\n\r\n  .mx#{$i} {\r\n    margin-inline: 1rem * $i !important;\r\n  }\r\n\r\n  .my#{$i} {\r\n    margin-block: 1rem * $i !important;\r\n  }\r\n\r\n  .gap-#{$i} {\r\n    gap: 1rem * $i !important;\r\n  }\r\n}\r\n\r\n.my-auto {\r\n  margin-inline: auto !important;\r\n}\r\n\r\n@for $i from 0 through 100 {\r\n  .mw#{$i} {\r\n    max-width: 1rem * $i !important;\r\n  }\r\n\r\n  .mh#{$i} {\r\n    max-height: 1rem * $i !important;\r\n  }\r\n\r\n}\r\n\r\n/* ---------------- */\r\n@for $i from 0 through 10 {\r\n  .h#{$i}-maxtablet {\r\n    @media(max-width:1090px) {\r\n      height: ($i) * 10vh !important;\r\n    }\r\n  }\r\n\r\n\r\n  .m#{$i}-maxtablet {\r\n    @media(max-width:1090px) {\r\n      margin: 1rem * $i !important;\r\n    }\r\n  }\r\n\r\n\r\n  .ml#{$i}-maxtablet {\r\n    @media(max-width:1090px) {\r\n      margin-left: 1rem * $i !important;\r\n    }\r\n  }\r\n\r\n  .mb#{$i}-maxtablet {\r\n    @media(max-width:1090px) {\r\n      margin-bottom: 1rem * $i !important;\r\n    }\r\n  }\r\n\r\n  .mr#{$i}-maxtablet {\r\n    @media(max-width:1090px) {\r\n      margin-right: 1rem * $i !important;\r\n    }\r\n  }\r\n\r\n  .mt#{$i}-maxtablet {\r\n    @media(max-width:1090px) {\r\n      margin-top: 1rem * $i !important;\r\n    }\r\n  }\r\n\r\n  .mx#{$i}-maxtablet {\r\n    @media(max-width:1090px) {\r\n      margin-inline: 1rem * $i !important;\r\n    }\r\n  }\r\n\r\n  .my#{$i}-maxtablet {\r\n    @media(max-width:1090px) {\r\n      margin-block: 1rem * $i !important;\r\n    }\r\n  }\r\n\r\n}\r\n\r\n\r\n@for $i from 0 through 3 {\r\n  .z#{$i} {\r\n    position: relative;\r\n    z-index: 1* $i !important;\r\n  }\r\n\r\n  .z-#{$i} {\r\n    position: relative;\r\n    z-index: -1* $i !important;\r\n  }\r\n}\r\n\r\n@for $i from 1 through 5 {\r\n  .p#{$i} {\r\n    padding: 1rem * $i !important;\r\n  }\r\n\r\n  .pl#{$i} {\r\n    padding-left: 1rem * $i !important;\r\n  }\r\n\r\n  .pb#{$i} {\r\n    padding-bottom: 1rem * $i !important;\r\n  }\r\n\r\n  .pr#{$i} {\r\n    padding-right: 1rem * $i !important;\r\n  }\r\n\r\n  .pt#{$i} {\r\n    padding-top: 1rem * $i !important;\r\n  }\r\n\r\n  .px#{$i} {\r\n    padding-inline: 1rem * $i !important;\r\n  }\r\n\r\n  .py#{$i} {\r\n    padding-block: 1rem * $i !important;\r\n  }\r\n}\r\n\r\n.relative {\r\n  position: relative\r\n}\r\n\r\n.color-white {\r\n  color: #FFF !important;\r\n}\r\n\r\n.text-left {\r\n  text-align: left !important;\r\n}\r\n\r\n.text-right {\r\n  text-align: right !important;\r\n}\r\n\r\n.text-center {\r\n  text-align: center !important;\r\n}\r\n\r\n@for $i from 0 through 20 {\r\n  $value: $i * 5;\r\n\r\n  .w#{$value} {\r\n    width: 1% * $value !important;\r\n  }\r\n\r\n  .w#{$value}-maxtablet {\r\n    @media(max-width:1090px) {\r\n      width: 1% * $value !important;\r\n    }\r\n  }\r\n}\r\n\r\n.break-spaces {\r\n  white-space: break-spaces;\r\n}\r\n\r\n.w-fit {\r\n  width: fit-content !important;\r\n}\r\n\r\n\r\n.d-none {\r\n  display: none !important;\r\n}\r\n\r\n.wmincontent {\r\n  width: min-content !important;\r\n}\r\n\r\n.hmincontent {\r\n  height: min-content !important;\r\n}\r\n\r\n.wmaxcontent {\r\n  width: max-content !important;\r\n}\r\n\r\n.hmaxcontent {\r\n  height: max-content !important;\r\n}\r\n\r\n.title {\r\n  text-align: center;\r\n  font-size: var(--font-grande);\r\n}\r\n\r\n.text-l {\r\n  text-align: left;\r\n}\r\n\r\n.text-r {\r\n  text-align: right;\r\n}\r\n\r\n.secondarytitle {\r\n  text-align: left;\r\n  margin-bottom: 2rem;\r\n  font-size: var(--font-grande);\r\n}\r\n\r\n.bg-attach-fix {\r\n  background-attachment: fixed;\r\n}\r\n\r\n.gridcenter {\r\n  grid-column: 1/-1 !important;\r\n  width: 100% !important;\r\n}\r\n\r\n.dflex {\r\n  display: flex !important;\r\n}\r\n\r\n.justify-center {\r\n  justify-content: center !important;\r\n}\r\n\r\n.justify-evenly {\r\n  justify-content: space-evenly !important;\r\n\r\n}\r\n\r\n.justify-between {\r\n  justify-content: space-between !important;\r\n}\r\n\r\n.align-start {\r\n  align-items: start !important;\r\n}\r\n\r\n.align-center {\r\n  align-items: center !important;\r\n}\r\n\r\n.align-baseline {\r\n  align-items: baseline !important;\r\n}\r\n\r\n.dcenter {\r\n  display: flex !important;\r\n  justify-content: center !important;\r\n}\r\n\r\n.dcol {\r\n  display: flex;\r\n  flex-direction: column !important;\r\n}\r\n\r\n.drow {\r\n  display: flex;\r\n  flex-direction: row !important;\r\n}\r\n\r\n.relative {\r\n  position: relative\r\n}\r\n\r\n.dcolcenter {\r\n  display: flex !important;\r\n  flex-direction: column !important;\r\n  justify-content: center !important;\r\n  align-items: center !important;\r\n}\r\n\r\n.color-grey {\r\n  color: var(--grey-color) !important;\r\n}\r\n\r\n.relative {\r\n  position: relative;\r\n}\r\n\r\n\r\n.check {\r\n  font-size: 1.2rem !important;\r\n  display: inline-block;\r\n  color: #FF9933;\r\n  transform: translateY(4px);\r\n}\r\n\r\n.leermas {\r\n  color: #FF9933;\r\n  width: max-content;\r\n  min-width: fit-content;\r\n  cursor: pointer;\r\n  transition: color 150ms ease-in-out;\r\n\r\n  svg {\r\n    margin-left: 5px;\r\n    font-size: 1.2rem;\r\n  }\r\n\r\n  &:hover {\r\n    color: var(--stronggreen-color) !important;\r\n  }\r\n}\r\n\r\n.center-child {\r\n  display: grid;\r\n  place-items: center;\r\n}\r\n\r\n.tituloImagen {\r\n  font-size: var(--font-gigante) !important;\r\n}\r\n\r\n.tituloSection {\r\n  font-size: var(--font-mediana2) !important;\r\n}\r\n\r\n.subtituloSection {\r\n  font-size: var(--font-mediana) !important;\r\n}\r\n\r\n.parrafoSection {\r\n  font-size: var(--font-normal) !important;\r\n}\r\n\r\n.tituloBox {\r\n  margin-bottom: 1rem;\r\n  color: white;\r\n  text-align: center;\r\n  font-size: var(--font-grande);\r\n  background-color: var(--stronggreen-color);\r\n  padding: clamp(0.5rem, 1rem, 2rem);\r\n  border-radius: 5px;\r\n}\r\n\r\n@media (max-width:q.$query-mobile-large) {\r\n  .mobile-dnone {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n.swiper-pagination-bullet-active {\r\n  background: var(--gold-800) !important;\r\n}","@mixin btn($color, $background, $background2) {\r\n  background: $background;\r\n  border-radius: 24px;\r\n  border: none;\r\n  transition: all ease .3s;\r\n  width: 10rem;\r\n  padding: .5rem;\r\n  color: $color;\r\n  font-weight: 400;\r\n  font-size: var(--font-boton);\r\n\r\n  a {\r\n    color: $color;\r\n    text-decoration: none;\r\n    outline: none;\r\n    position: relative;\r\n    font-weight: 400;\r\n    font-size: var(--font-boton);\r\n    padding: 1rem;\r\n    text-align: center;\r\n  }\r\n\r\n  &:hover {\r\n    background: $background2;\r\n  }\r\n\r\n  &:disabled,\r\n  &[disabled=true],\r\n  &[disabled=\"disabled\"] {\r\n    filter: grayscale(0.6);\r\n  }\r\n}\r\n\r\n.btnGreen {\r\n  @include btn(var(--white) !important, var(--green-800), var(--green-600));\r\n  margin-top: 1rem;\r\n  max-height: 3rem\r\n}\r\n\r\n.btnOrange {\r\n  @include btn(var(--white) !important, var(--gold-800), var(--gold-600));\r\n  padding: 0.4rem;\r\n  border-radius: 10px;\r\n  font-size: var(--font-chica);\r\n}\r\n\r\n.btnWhite {\r\n  @include btn(var(--gold-800) !important, var(--white) !important, #f88c1f);\r\n  padding: 0.4rem;\r\n  border-radius: 10px;\r\n  font-size: var(--font-chica);\r\n  border: 1px solid var(--gold-800)\r\n}\r\n\r\n.Button {\r\n  width: auto;\r\n  height: 2rem;\r\n  border-radius: 5px;\r\n  border: none;\r\n  color: var(--white);\r\n  background-color: var(--green-800);\r\n  border: none;\r\n  z-index: 99;\r\n  border: 2px solid transparent;\r\n  -webkit-transition: 0.4s all;\r\n  transition: 0.4s all;\r\n\r\n  &:hover {\r\n    background-color: var(--white);\r\n    transition: 0.4s all;\r\n    border: 2px solid var(--green-800);\r\n    color: var(--green-800);\r\n  }\r\n\r\n  &:disabled,\r\n  &[disabled=true],\r\n  &[disabled=\"disabled\"] {\r\n    filter: grayscale(0.6);\r\n  }\r\n}\r\n\r\n@mixin button($color, $background, $background2) {\r\n  width: auto;\r\n  height: 2rem;\r\n  border-radius: 5px;\r\n  border: none;\r\n  color: $color;\r\n  background-color: $background;\r\n  border: none;\r\n  z-index: 99;\r\n  border: 2px solid transparent;\r\n  -webkit-transition: 0.4s all;\r\n  transition: 0.4s all;\r\n\r\n  &:hover {\r\n    background-color: $color;\r\n    transition: 0.4s all;\r\n    border: 2px solid $background;\r\n    color: $background;\r\n  }\r\n\r\n  &:disabled,\r\n  &[disabled=true],\r\n  &[disabled=\"disabled\"] {\r\n    filter: grayscale(0.6);\r\n  }\r\n\r\n}\r\n\r\n.Button-orange {\r\n  @include button(var(--white), var(--gold-800), var(--primary-color));\r\n}\r\n\r\n.Button-gray {\r\n  @include button(var(--white), var(--grey-light-color), var(--grey-light-color));\r\n}\r\n\r\n.no-caret-dropdown {\r\n  .dropdown-toggle::after {\r\n    display: none !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
